(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1870],{

/***/ 13425:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/portfolio/[[...address]]",
      function () {
        return __webpack_require__(19056);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 61818:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _rainbow_me_rainbowkit__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(87671);
/* harmony import */ var _reservoir0x_reservoir_kit_ui__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(61897);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var wagmi__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69077);
/* harmony import */ var _context_ToastContextProvider__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98045);
/* harmony import */ var hooks__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35430);







const CancelBid = (param)=>{
    let { bidId , openState , trigger , mutate  } = param;
    const { addToast  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_context_ToastContextProvider__WEBPACK_IMPORTED_MODULE_2__/* .ToastContext */ .u);
    const { openConnectModal  } = (0,_rainbow_me_rainbowkit__WEBPACK_IMPORTED_MODULE_4__/* .useConnectModal */ .We)();
    const marketplaceChain = (0,hooks__WEBPACK_IMPORTED_MODULE_3__/* .useMarketplaceChain */ .gw)();
    const { switchNetworkAsync  } = (0,wagmi__WEBPACK_IMPORTED_MODULE_5__/* .useSwitchNetwork */ .g0)({
        chainId: marketplaceChain.id
    });
    const { data: signer  } = (0,wagmi__WEBPACK_IMPORTED_MODULE_5__/* .useWalletClient */ .py)();
    const { chain: activeChain  } = (0,wagmi__WEBPACK_IMPORTED_MODULE_5__/* .useNetwork */ .LN)();
    const isInTheWrongNetwork = Boolean(signer && marketplaceChain.id !== (activeChain === null || activeChain === void 0 ? void 0 : activeChain.id));
    if (isInTheWrongNetwork) {
        return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.cloneElement)(trigger, {
            onClick: async ()=>{
                if (switchNetworkAsync && activeChain) {
                    const chain = await switchNetworkAsync(marketplaceChain.id);
                    if (chain.id !== marketplaceChain.id) {
                        return false;
                    }
                }
                if (!signer) {
                    openConnectModal === null || openConnectModal === void 0 ? void 0 : openConnectModal();
                }
            }
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_reservoir0x_reservoir_kit_ui__WEBPACK_IMPORTED_MODULE_6__/* .CancelBidModal */ .BJ, {
        bidId: bidId,
        trigger: trigger,
        openState: openState,
        onCancelComplete: (data)=>{
            addToast === null || addToast === void 0 ? void 0 : addToast({
                title: "User canceled bid",
                description: "You have canceled the bid."
            });
        },
        onCancelError: (error, data)=>{
            console.log("Bid Cancel Error", error, data);
            addToast === null || addToast === void 0 ? void 0 : addToast({
                title: "Could not cancel bid",
                description: "The transaction was not completed."
            });
        },
        onClose: (data, currentStep)=>{
            if (mutate && currentStep == _reservoir0x_reservoir_kit_ui__WEBPACK_IMPORTED_MODULE_6__/* .CancelBidStep.Complete */ .JE.Complete) mutate();
        }
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CancelBid);


/***/ }),

/***/ 41456:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _rainbow_me_rainbowkit__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(87671);
/* harmony import */ var _reservoir0x_reservoir_kit_ui__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(61897);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var wagmi__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69077);
/* harmony import */ var _context_ToastContextProvider__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98045);
/* harmony import */ var hooks__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35430);







const CancelListing = (param)=>{
    let { listingId , openState , trigger , mutate  } = param;
    const { addToast  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_context_ToastContextProvider__WEBPACK_IMPORTED_MODULE_2__/* .ToastContext */ .u);
    const { openConnectModal  } = (0,_rainbow_me_rainbowkit__WEBPACK_IMPORTED_MODULE_4__/* .useConnectModal */ .We)();
    const marketplaceChain = (0,hooks__WEBPACK_IMPORTED_MODULE_3__/* .useMarketplaceChain */ .gw)();
    const { switchNetworkAsync  } = (0,wagmi__WEBPACK_IMPORTED_MODULE_5__/* .useSwitchNetwork */ .g0)({
        chainId: marketplaceChain.id
    });
    const { data: signer  } = (0,wagmi__WEBPACK_IMPORTED_MODULE_5__/* .useWalletClient */ .py)();
    const { chain: activeChain  } = (0,wagmi__WEBPACK_IMPORTED_MODULE_5__/* .useNetwork */ .LN)();
    const isInTheWrongNetwork = Boolean(signer && activeChain && activeChain.id !== marketplaceChain.id);
    if (isInTheWrongNetwork) {
        return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.cloneElement)(trigger, {
            onClick: async ()=>{
                if (switchNetworkAsync && activeChain) {
                    const chain = await switchNetworkAsync(marketplaceChain.id);
                    if (chain.id !== marketplaceChain.id) {
                        return false;
                    }
                }
                if (!signer) {
                    openConnectModal === null || openConnectModal === void 0 ? void 0 : openConnectModal();
                }
            }
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_reservoir0x_reservoir_kit_ui__WEBPACK_IMPORTED_MODULE_6__/* .CancelListingModal */ .GO, {
        listingId: listingId,
        openState: openState,
        trigger: trigger,
        onCancelComplete: (data)=>{
            addToast === null || addToast === void 0 ? void 0 : addToast({
                title: "User canceled listing",
                description: "You have canceled the listing."
            });
        },
        onCancelError: (error, data)=>{
            console.log("Listing Cancel Error", error, data);
            addToast === null || addToast === void 0 ? void 0 : addToast({
                title: "Could not cancel listing",
                description: "The transaction was not completed."
            });
        },
        onClose: (data, currentStep)=>{
            if (mutate && currentStep == _reservoir0x_reservoir_kit_ui__WEBPACK_IMPORTED_MODULE_6__/* .CancelListingStep.Complete */ .MD.Complete) mutate();
        }
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CancelListing);


/***/ }),

/***/ 61955:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _radix_ui_react_tooltip__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(40299);
/* harmony import */ var _primitives__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(92902);
/* harmony import */ var utils_chains__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67418);
/* harmony import */ var context_ChainContextProvider__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(43810);
/* harmony import */ var components_primitives_Tooltip__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(79320);
/* harmony import */ var hooks__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(35430);
/* harmony import */ var next_themes__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(82010);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _radix_ui_react_dropdown_menu__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(34509);
/* harmony import */ var _fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(99603);
/* harmony import */ var _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(59417);
/* harmony import */ var components_primitives_Dropdown__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(12623);















const ChainToggle = ()=>{
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_8__.useRouter)();
    const { chain , switchCurrentChain  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(context_ChainContextProvider__WEBPACK_IMPORTED_MODULE_4__/* .ChainContext */ .p);
    const isMounted = (0,hooks__WEBPACK_IMPORTED_MODULE_6__/* .useMounted */ .s4)();
    const { theme  } = (0,next_themes__WEBPACK_IMPORTED_MODULE_7__/* .useTheme */ .F)();
    const switchChains = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)((chainOption)=>{
        if (router.query.chain) {
            Object.keys(router.query).forEach((param)=>delete router.query[param]);
            router.replace({
                pathname: router.pathname,
                query: router.query
            }, undefined, {
                shallow: true
            });
        }
        switchCurrentChain(chainOption.id);
    }, [
        router.query,
        switchCurrentChain
    ]);
    if (!isMounted || utils_chains__WEBPACK_IMPORTED_MODULE_3__/* ["default"].length */ .ZP.length === 1) {
        return null;
    }
    if (utils_chains__WEBPACK_IMPORTED_MODULE_3__/* ["default"].length */ .ZP.length > 4) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_radix_ui_react_dropdown_menu__WEBPACK_IMPORTED_MODULE_11__/* .Root */ .fC, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_dropdown_menu__WEBPACK_IMPORTED_MODULE_11__/* .Trigger */ .xz, {
                    asChild: true,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_primitives__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .zx, {
                        color: "gray3",
                        css: {
                            px: "14px",
                            justifyContent: "space-between",
                            width: "auto",
                            minWidth: "max-content",
                            "@md": {
                                minWidth: "max-content",
                                px: "$4"
                            }
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                src: theme === "dark" ? chain.darkIconUrl : chain.lightIconUrl,
                                style: {
                                    height: 20
                                }
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_primitives__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xv, {
                                style: "body1",
                                children: chain.name
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_primitives__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, {
                                css: {
                                    color: "$gray10",
                                    transition: "transform",
                                    "[data-state=open] &": {
                                        transform: "rotate(180deg)"
                                    }
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_9__/* .FontAwesomeIcon */ .G, {
                                    icon: _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_12__/* .faChevronDown */ .ptq,
                                    width: 16
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives_Dropdown__WEBPACK_IMPORTED_MODULE_10__/* .DropdownMenuContent */ .AW, {
                    css: {
                        mt: "$2",
                        zIndex: 1000,
                        width: "auto",
                        minWidth: "max-content",
                        "@md": {
                            minWidth: "max-content"
                        }
                    },
                    children: utils_chains__WEBPACK_IMPORTED_MODULE_3__/* ["default"].map */ .ZP.map((supportedChain)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_primitives_Dropdown__WEBPACK_IMPORTED_MODULE_10__/* .DropdownMenuItem */ .Xi, {
                            css: {
                                py: "$3",
                                px: "$1",
                                display: "flex",
                                gap: "$2"
                            },
                            onClick: ()=>{
                                const newUrl = router.asPath.replace(chain.routePrefix, supportedChain.routePrefix);
                                switchCurrentChain(supportedChain.id);
                                router.replace(newUrl, undefined, {
                                    scroll: false
                                });
                            },
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_primitives__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kC, {
                                    css: {
                                        width: 30
                                    },
                                    justify: "center",
                                    align: "center",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                        src: theme === "dark" ? supportedChain.darkIconUrl : supportedChain.lightIconUrl,
                                        style: {
                                            height: 20
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_primitives__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xv, {
                                    style: "body1",
                                    children: supportedChain.name
                                })
                            ]
                        }, supportedChain.id))
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_primitives__WEBPACK_IMPORTED_MODULE_2__/* .ToggleGroup */ .tX, {
        type: "single",
        value: chain.name,
        children: utils_chains__WEBPACK_IMPORTED_MODULE_3__/* ["default"].map */ .ZP.map((chainOption)=>{
            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_radix_ui_react_tooltip__WEBPACK_IMPORTED_MODULE_13__/* .Root */ .fC, {
                delayDuration: 0,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_tooltip__WEBPACK_IMPORTED_MODULE_13__/* .Trigger */ .xz, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_primitives__WEBPACK_IMPORTED_MODULE_2__/* .ToggleGroupItem */ .GX, {
                            asChild: true,
                            value: chainOption.name,
                            disabled: chainOption.name === chain.name,
                            onClick: ()=>{
                                const newUrl = router.asPath.replace(chain.routePrefix, chainOption.routePrefix);
                                switchCurrentChain(chainOption.id);
                                router.replace(newUrl, undefined, {
                                    scroll: false
                                });
                            },
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_primitives__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, {
                                css: {
                                    width: 56,
                                    display: "flex",
                                    justifyContent: "center"
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                    src: theme === "dark" ? chainOption.darkIconUrl : chainOption.lightIconUrl,
                                    style: {
                                        height: 20
                                    }
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_radix_ui_react_tooltip__WEBPACK_IMPORTED_MODULE_13__/* .Content */ .VY, {
                        sideOffset: -4,
                        side: "top",
                        align: "center",
                        style: {
                            zIndex: 100,
                            filter: "drop-shadow(0px 3px 8px rgba(0, 0, 0, 0.3))"
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives_Tooltip__WEBPACK_IMPORTED_MODULE_5__/* .TooltipArrow */ .C, {}),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_primitives__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, {
                                css: {
                                    zIndex: 9999,
                                    $$shadowColor: "$colors$panelShadow",
                                    boxShadow: "0px 1px 5px rgba(0,0,0,0.2)",
                                    borderRadius: 8,
                                    overflow: "hidden"
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_primitives__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, {
                                    css: {
                                        background: "$neutralBgSubtle",
                                        p: "$2"
                                    },
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_primitives__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xv, {
                                        style: "body3",
                                        as: "p",
                                        children: chainOption === null || chainOption === void 0 ? void 0 : chainOption.name
                                    })
                                })
                            })
                        ]
                    })
                ]
            }, chainOption.name);
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ChainToggle);


/***/ }),

/***/ 31561:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "q": function() { return /* binding */ PercentChange; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./utils/round.ts
const round = function(num) {
    let percision = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 4;
    return Math.floor(num * Math.pow(10, percision)) / Math.pow(10, percision);
};
/* harmony default export */ var utils_round = (round);

// EXTERNAL MODULE: ./components/primitives/index.ts + 15 modules
var primitives = __webpack_require__(92902);
;// CONCATENATED MODULE: ./components/primitives/PercentChange.tsx



const PercentChange = (param)=>{
    let { value , decimals =2 , ...props } = param;
    if (value === undefined || value === null || value === 0) return null;
    const percentage = (value - 1) * 100;
    const isPositive = percentage > 0;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Text */.xv, {
        style: props.style || "subtitle3",
        css: {
            color: isPositive ? "$green11" : "$red11",
            ml: "$1"
        },
        ...props,
        children: [
            utils_round(percentage, decimals),
            "%"
        ]
    });
};


/***/ }),

/***/ 19056:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ _address_; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@fortawesome/free-solid-svg-icons/index.mjs
var free_solid_svg_icons = __webpack_require__(59417);
// EXTERNAL MODULE: ./node_modules/@fortawesome/react-fontawesome/index.es.js + 1 modules
var index_es = __webpack_require__(99603);
// EXTERNAL MODULE: ./node_modules/@radix-ui/react-tabs/dist/index.module.js + 1 modules
var index_module = __webpack_require__(79509);
// EXTERNAL MODULE: ./node_modules/@reservoir0x/reservoir-kit-ui/dist/index.module.js + 206 modules
var dist_index_module = __webpack_require__(61897);
// EXTERNAL MODULE: ./components/ConnectWalletButton.tsx
var ConnectWalletButton = __webpack_require__(80672);
// EXTERNAL MODULE: ./components/Head.tsx
var Head = __webpack_require__(4049);
// EXTERNAL MODULE: ./components/Layout.tsx
var Layout = __webpack_require__(51943);
// EXTERNAL MODULE: ./components/common/ActivityFilters.tsx
var ActivityFilters = __webpack_require__(18733);
// EXTERNAL MODULE: ./components/common/ChainToggle.tsx
var ChainToggle = __webpack_require__(61955);
// EXTERNAL MODULE: ./components/common/CopyText.tsx
var CopyText = __webpack_require__(56373);
// EXTERNAL MODULE: ./components/common/FilterButton.tsx
var FilterButton = __webpack_require__(57813);
// EXTERNAL MODULE: ./components/common/MobileActivityFilters.tsx
var MobileActivityFilters = __webpack_require__(33808);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@radix-ui/react-dialog/dist/index.module.js
var react_dialog_dist_index_module = __webpack_require__(51528);
// EXTERNAL MODULE: ./components/primitives/index.ts + 15 modules
var primitives = __webpack_require__(92902);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./components/common/FullscreenModal.tsx
var FullscreenModal = __webpack_require__(18491);
// EXTERNAL MODULE: ./components/navbar/index.tsx + 9 modules
var navbar = __webpack_require__(13282);
// EXTERNAL MODULE: ./components/common/OpenSeaVerified.tsx
var OpenSeaVerified = __webpack_require__(44930);
// EXTERNAL MODULE: ./node_modules/usehooks-ts/dist/esm/index.js + 36 modules
var esm = __webpack_require__(5678);
;// CONCATENATED MODULE: ./components/common/LoadMoreCollections.tsx




const LoadMoreCollections = (param)=>{
    let { loadMore  } = param;
    const loadMoreRef = (0,react.useRef)(null);
    const loadMoreObserver = (0,esm/* useIntersectionObserver */.S1)(loadMoreRef, {});
    (0,react.useEffect)(()=>{
        const isVisible = !!(loadMoreObserver === null || loadMoreObserver === void 0 ? void 0 : loadMoreObserver.isIntersecting);
        if (isVisible) {
            loadMore();
        }
    }, [
        loadMoreObserver === null || loadMoreObserver === void 0 ? void 0 : loadMoreObserver.isIntersecting
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Box */.xu, {
        ref: loadMoreRef,
        css: {
            height: 20,
            width: "100%"
        }
    });
};
/* harmony default export */ var common_LoadMoreCollections = (LoadMoreCollections);

// EXTERNAL MODULE: ./utils/optimizeImage.ts
var optimizeImage = __webpack_require__(77497);
;// CONCATENATED MODULE: ./components/common/MobileTokenFilters.tsx












const MobileTokenFilters = (param)=>{
    let { collections , filterCollection , setFilterCollection , loadMoreCollections  } = param;
    const triggerRef = (0,react.useRef)(null);
    const trigger = /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Flex */.kC, {
        justify: "center",
        css: {
            position: "fixed",
            left: 0,
            bottom: "70px",
            width: "100vw",
            zIndex: 99
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Button */.zx, {
            ref: triggerRef,
            css: {
                justifyContent: "center",
                alignItems: "center",
                justifyItems: "center",
                position: "fixed",
                px: "$6",
                py: "$3"
            },
            type: "button",
            size: "small",
            corners: "pill",
            color: "gray3",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                    style: "h6",
                    children: "Filter"
                }),
                filterCollection && /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Flex */.kC, {
                    justify: "center",
                    align: "center",
                    css: {
                        height: "24px",
                        width: "24px",
                        backgroundColor: "$gray4",
                        borderRadius: "100%",
                        fontSize: "medium",
                        fontWeight: "500"
                    },
                    children: "1"
                })
            ]
        })
    });
    if ((collections === null || collections === void 0 ? void 0 : collections.length) === 0 || collections == null) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(FullscreenModal/* FullscreenModal */.O, {
        trigger: trigger,
        children: [
            " ",
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                css: {
                    flexDirection: "column",
                    height: "100%",
                    overflow: "scroll"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                        css: {
                            py: "$4",
                            px: "$4",
                            width: "100%",
                            borderBottom: "1px solid $gray4",
                            height: navbar/* NAVBAR_HEIGHT_MOBILE */.t7
                        },
                        align: "center",
                        justify: "between",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Flex */.kC, {
                                align: "center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                    style: "h5",
                                    css: {
                                        mr: "$3"
                                    },
                                    children: "Filter"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_dialog_dist_index_module/* Close */.x8, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Flex */.kC, {
                                    css: {
                                        justifyContent: "center",
                                        width: "44px",
                                        height: "44px",
                                        alignItems: "center",
                                        borderRadius: 8,
                                        backgroundColor: "$gray3",
                                        color: "$gray12",
                                        "&:hover": {
                                            backgroundColor: "$gray4"
                                        }
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                        icon: free_solid_svg_icons/* faXmark */.g82,
                                        width: 16,
                                        height: 16
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                        direction: "column",
                        css: {
                            pt: "$4",
                            maxHeight: "calc(100vh - ".concat(navbar/* NAVBAR_HEIGHT_MOBILE */.t7, "px)"),
                            overflowY: "auto",
                            pb: "$5"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                style: "subtitle1",
                                css: {
                                    mb: "$2",
                                    pl: "$4"
                                },
                                children: "Collections"
                            }),
                            collections === null || collections === void 0 ? void 0 : collections.map((collection)=>{
                                var _collection_collection, _collection_collection1, _collection_collection2, _collection_collection3, _collection_collection4, _collection_collection5, _collection_ownership, _collection_collection6;
                                let selected = (collection === null || collection === void 0 ? void 0 : (_collection_collection = collection.collection) === null || _collection_collection === void 0 ? void 0 : _collection_collection.id) == filterCollection;
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                    css: {
                                        py: "$2",
                                        px: "$4",
                                        gap: "$3",
                                        cursor: "pointer",
                                        "&:hover": {
                                            backgroundColor: selected ? "$gray5" : "$gray4"
                                        },
                                        backgroundColor: selected ? "$gray5" : ""
                                    },
                                    align: "center",
                                    onClick: ()=>{
                                        var _triggerRef_current;
                                        if (selected) {
                                            setFilterCollection(undefined);
                                        } else {
                                            var _collection_collection;
                                            setFilterCollection(collection === null || collection === void 0 ? void 0 : (_collection_collection = collection.collection) === null || _collection_collection === void 0 ? void 0 : _collection_collection.id);
                                        }
                                        triggerRef === null || triggerRef === void 0 ? void 0 : (_triggerRef_current = triggerRef.current) === null || _triggerRef_current === void 0 ? void 0 : _triggerRef_current.click();
                                    },
                                    children: [
                                        (collection === null || collection === void 0 ? void 0 : (_collection_collection1 = collection.collection) === null || _collection_collection1 === void 0 ? void 0 : _collection_collection1.image) && /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            style: {
                                                borderRadius: "4px",
                                                objectFit: "cover",
                                                aspectRatio: "1/1"
                                            },
                                            loader: (param)=>{
                                                let { src  } = param;
                                                return src;
                                            },
                                            src: (0,optimizeImage/* default */.Z)(collection === null || collection === void 0 ? void 0 : (_collection_collection2 = collection.collection) === null || _collection_collection2 === void 0 ? void 0 : _collection_collection2.image, 250),
                                            alt: collection === null || collection === void 0 ? void 0 : (_collection_collection3 = collection.collection) === null || _collection_collection3 === void 0 ? void 0 : _collection_collection3.name,
                                            width: 24,
                                            height: 24
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                            style: "body1",
                                            css: {
                                                flex: 1
                                            },
                                            ellipsify: true,
                                            children: collection === null || collection === void 0 ? void 0 : (_collection_collection4 = collection.collection) === null || _collection_collection4 === void 0 ? void 0 : _collection_collection4.name
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(OpenSeaVerified/* OpenSeaVerified */.v, {
                                            openseaVerificationStatus: collection === null || collection === void 0 ? void 0 : (_collection_collection5 = collection.collection) === null || _collection_collection5 === void 0 ? void 0 : _collection_collection5.openseaVerificationStatus
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                            style: "subtitle2",
                                            css: {
                                                color: "$gray10"
                                            },
                                            children: collection === null || collection === void 0 ? void 0 : (_collection_ownership = collection.ownership) === null || _collection_ownership === void 0 ? void 0 : _collection_ownership.tokenCount
                                        })
                                    ]
                                }, collection === null || collection === void 0 ? void 0 : (_collection_collection6 = collection.collection) === null || _collection_collection6 === void 0 ? void 0 : _collection_collection6.id);
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(common_LoadMoreCollections, {
                                loadMore: loadMoreCollections
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./components/primitives/Dropdown.tsx
var Dropdown = __webpack_require__(12623);
// EXTERNAL MODULE: ./node_modules/@radix-ui/react-dropdown-menu/dist/index.module.js + 2 modules
var react_dropdown_menu_dist_index_module = __webpack_require__(34509);
// EXTERNAL MODULE: ./node_modules/react-responsive/dist/react-responsive.js
var react_responsive = __webpack_require__(1852);
;// CONCATENATED MODULE: ./components/common/PortfolioSortDropdown.tsx








const sortingOptions = [
    "acquiredAt",
    "lastAppraisalValue"
];
const nameForSortingOption = (option, compact)=>{
    switch(option){
        case "acquiredAt":
            return "Recently Acquired";
        case "lastAppraisalValue":
            return "Appraisal Value";
    }
};
const PortfolioSortDropdown = (param)=>{
    let { option , onOptionSelected  } = param;
    var _buttonRef_current;
    const isSmallDevice = (0,react_responsive.useMediaQuery)({
        maxWidth: 905
    });
    const buttonRef = (0,react.useRef)(null);
    var _buttonRef_current_offsetWidth;
    const [sortWidth, setSortWidth] = (0,react.useState)((_buttonRef_current_offsetWidth = (_buttonRef_current = buttonRef.current) === null || _buttonRef_current === void 0 ? void 0 : _buttonRef_current.offsetWidth) !== null && _buttonRef_current_offsetWidth !== void 0 ? _buttonRef_current_offsetWidth : "220px");
    const handleResize = ()=>{
        if (isSmallDevice) {
            var _buttonRef_current, _buttonRef_current1;
            setSortWidth((buttonRef === null || buttonRef === void 0 ? void 0 : (_buttonRef_current = buttonRef.current) === null || _buttonRef_current === void 0 ? void 0 : _buttonRef_current.offsetWidth) ? buttonRef === null || buttonRef === void 0 ? void 0 : (_buttonRef_current1 = buttonRef.current) === null || _buttonRef_current1 === void 0 ? void 0 : _buttonRef_current1.offsetWidth : "220px");
        }
    };
    (0,react.useEffect)(()=>{
        window.addEventListener("resize", handleResize, false);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react_dropdown_menu_dist_index_module/* Root */.fC, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_dropdown_menu_dist_index_module/* Trigger */.xz, {
                asChild: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Button */.zx, {
                    color: "gray3",
                    css: {
                        px: "14px",
                        justifyContent: "space-between",
                        width: "100%",
                        height: 48,
                        minWidth: "max-content",
                        maxWidth: 300,
                        "@md": {
                            width: "220px",
                            minWidth: "max-content",
                            px: "$4"
                        }
                    },
                    ref: buttonRef,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                            style: "body1",
                            children: nameForSortingOption(option, false)
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Box */.xu, {
                            css: {
                                color: "$gray10",
                                transition: "transform",
                                "[data-state=open] &": {
                                    transform: "rotate(180deg)"
                                }
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                icon: free_solid_svg_icons/* faChevronDown */.ptq,
                                width: 16
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Dropdown/* DropdownMenuContent */.AW, {
                css: {
                    mt: "$2",
                    zIndex: 1000,
                    width: sortWidth,
                    minWidth: "max-content",
                    maxWidth: 300,
                    "@md": {
                        width: "220px",
                        minWidth: "max-content",
                        px: "$4"
                    }
                },
                children: sortingOptions.map((optionItem)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Dropdown/* DropdownMenuItem */.Xi, {
                        css: {
                            py: "$3"
                        },
                        onClick: ()=>onOptionSelected(optionItem),
                        children: nameForSortingOption(optionItem, false)
                    }, optionItem))
            })
        ]
    });
};
/* harmony default export */ var common_PortfolioSortDropdown = (PortfolioSortDropdown);

// EXTERNAL MODULE: ./node_modules/@radix-ui/react-collapsible/dist/index.module.js + 1 modules
var react_collapsible_dist_index_module = __webpack_require__(20163);
// EXTERNAL MODULE: ./components/primitives/Collapsible.tsx
var Collapsible = __webpack_require__(61194);
// EXTERNAL MODULE: ./components/primitives/PercentChange.tsx + 1 modules
var PercentChange = __webpack_require__(31561);
// EXTERNAL MODULE: ./utils/numbers.ts + 1 modules
var numbers = __webpack_require__(23701);
;// CONCATENATED MODULE: ./components/common/TokenFilters.tsx











const TokenFilters = (param)=>{
    let { open , setOpen , collections , filterCollection , setFilterCollection , isLoading , isOwner , scrollToTop , loadMoreCollections  } = param;
    if ((collections === null || collections === void 0 ? void 0 : collections.length) === 0 || collections == null || isLoading) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_collapsible_dist_index_module/* Root */.fC, {
        open: open,
        onOpenChange: setOpen,
        style: {
            transition: "width .5s",
            width: open ? 350 : 0,
            zIndex: 900
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Collapsible/* CollapsibleContent */.Fw, {
            css: {
                position: "sticky",
                top: 16 + 80,
                height: "calc(100vh - ".concat(navbar/* NAVBAR_HEIGHT */.ik, "px - ").concat(isOwner ? 90 : 32, ")"),
                overflow: "auto"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                direction: "column",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                        style: "subtitle1",
                        css: {
                            mb: "$2",
                            ml: "$3"
                        }
                    }),
                    collections === null || collections === void 0 ? void 0 : collections.map((collection)=>{
                        var _collection_collection, _collection_collection1, _collection_collection2, _collection_collection3, _collection_collection4, _collection_collection5, _collection_ownership, _collection_collection6, _collection_collection_floorAskPrice, _collection_collection_floorAskPrice_amount, _collection_collection7, _collection_collection_floorAskPrice1, _collection_collection_floorAskPrice_currency, _collection_collection8, _collection_collection_volumeChange, _collection_collection9;
                        let selected = (collection === null || collection === void 0 ? void 0 : (_collection_collection = collection.collection) === null || _collection_collection === void 0 ? void 0 : _collection_collection.id) == filterCollection;
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                            css: {
                                py: "$2",
                                px: "$3",
                                gap: "$3",
                                borderRadius: "4px",
                                cursor: "pointer",
                                "&:hover": {
                                    backgroundColor: selected ? "$gray5" : "$gray4"
                                },
                                backgroundColor: selected ? "$gray5" : ""
                            },
                            align: "center",
                            onClick: ()=>{
                                if (selected) {
                                    setFilterCollection(undefined);
                                } else {
                                    var _collection_collection;
                                    setFilterCollection(collection === null || collection === void 0 ? void 0 : (_collection_collection = collection.collection) === null || _collection_collection === void 0 ? void 0 : _collection_collection.id);
                                }
                                scrollToTop === null || scrollToTop === void 0 ? void 0 : scrollToTop();
                            },
                            children: [
                                (collection === null || collection === void 0 ? void 0 : (_collection_collection1 = collection.collection) === null || _collection_collection1 === void 0 ? void 0 : _collection_collection1.image) && /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    style: {
                                        borderRadius: "4px",
                                        objectFit: "cover",
                                        aspectRatio: "1/1"
                                    },
                                    loader: (param)=>{
                                        let { src  } = param;
                                        return src;
                                    },
                                    src: (0,optimizeImage/* default */.Z)(collection === null || collection === void 0 ? void 0 : (_collection_collection2 = collection.collection) === null || _collection_collection2 === void 0 ? void 0 : _collection_collection2.image, 250),
                                    alt: collection === null || collection === void 0 ? void 0 : (_collection_collection3 = collection.collection) === null || _collection_collection3 === void 0 ? void 0 : _collection_collection3.name,
                                    width: 24,
                                    height: 24
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                    direction: "column",
                                    css: {
                                        minWidth: 0
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                            css: {
                                                gap: "$1"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                                    style: "body1",
                                                    css: {
                                                        flex: 1
                                                    },
                                                    ellipsify: true,
                                                    children: collection === null || collection === void 0 ? void 0 : (_collection_collection4 = collection.collection) === null || _collection_collection4 === void 0 ? void 0 : _collection_collection4.name
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(OpenSeaVerified/* OpenSeaVerified */.v, {
                                                    openseaVerificationStatus: collection === null || collection === void 0 ? void 0 : (_collection_collection5 = collection.collection) === null || _collection_collection5 === void 0 ? void 0 : _collection_collection5.openseaVerificationStatus
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Text */.xv, {
                                            style: "subtitle3",
                                            css: {
                                                color: "$gray10"
                                            },
                                            children: [
                                                "Owned: ",
                                                (0,numbers/* formatNumber */.uf)(collection === null || collection === void 0 ? void 0 : (_collection_ownership = collection.ownership) === null || _collection_ownership === void 0 ? void 0 : _collection_ownership.tokenCount)
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                    direction: "column",
                                    css: {
                                        ml: "auto",
                                        flexShrink: 0,
                                        alignItems: "end"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                            css: {
                                                gap: "$1"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                                    style: "subtitle2",
                                                    children: "Floor"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* FormatCryptoCurrency */.gv, {
                                                    logoHeight: 15,
                                                    amount: (_collection_collection6 = collection.collection) === null || _collection_collection6 === void 0 ? void 0 : (_collection_collection_floorAskPrice = _collection_collection6.floorAskPrice) === null || _collection_collection_floorAskPrice === void 0 ? void 0 : (_collection_collection_floorAskPrice_amount = _collection_collection_floorAskPrice.amount) === null || _collection_collection_floorAskPrice_amount === void 0 ? void 0 : _collection_collection_floorAskPrice_amount.decimal,
                                                    address: (_collection_collection7 = collection.collection) === null || _collection_collection7 === void 0 ? void 0 : (_collection_collection_floorAskPrice1 = _collection_collection7.floorAskPrice) === null || _collection_collection_floorAskPrice1 === void 0 ? void 0 : (_collection_collection_floorAskPrice_currency = _collection_collection_floorAskPrice1.currency) === null || _collection_collection_floorAskPrice_currency === void 0 ? void 0 : _collection_collection_floorAskPrice_currency.contract,
                                                    textStyle: "subtitle2"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Tooltip */.u, {
                                            sideOffset: 2,
                                            side: "top",
                                            content: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                                style: "body3",
                                                css: {
                                                    display: "block"
                                                },
                                                children: "24h Floor Price Change"
                                            }),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PercentChange/* PercentChange */.q, {
                                                    value: (_collection_collection8 = collection.collection) === null || _collection_collection8 === void 0 ? void 0 : (_collection_collection_volumeChange = _collection_collection8.volumeChange) === null || _collection_collection_volumeChange === void 0 ? void 0 : _collection_collection_volumeChange["1day"],
                                                    decimals: 1
                                                })
                                            })
                                        })
                                    ]
                                })
                            ]
                        }, collection === null || collection === void 0 ? void 0 : (_collection_collection9 = collection.collection) === null || _collection_collection9 === void 0 ? void 0 : _collection_collection9.id);
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(common_LoadMoreCollections, {
                        loadMore: loadMoreCollections
                    })
                ]
            })
        })
    }, "Token Filter");
};

;// CONCATENATED MODULE: ./components/portfolio/BatchActionsFooter.tsx



const BatchActionsFooter = (param)=>{
    let { isOwner , selectedItems , setSelectedItems , setShowListingPage , setOpenAcceptBidModal  } = param;
    if (!isOwner) {
        return null;
    }
    const sellableItems = (0,react.useMemo)(()=>{
        return selectedItems.filter((item)=>{
            var _item_token, _item_token_topBid;
            return ((_item_token = item.token) === null || _item_token === void 0 ? void 0 : (_item_token_topBid = _item_token.topBid) === null || _item_token_topBid === void 0 ? void 0 : _item_token_topBid.id) !== null;
        });
    }, [
        selectedItems
    ]);
    const listItemSubject = selectedItems.length === 1 ? "item" : "items";
    const sellItemSubject = sellableItems.length === 1 ? "item" : "items";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
        align: "center",
        justify: "between",
        css: {
            position: "fixed",
            bottom: 0,
            left: 0,
            right: 0,
            px: "$5",
            py: "$4",
            borderTop: "1px solid $gray7",
            backgroundColor: "$neutralBg",
            zIndex: 999
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                align: "center",
                css: {
                    gap: 24
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Text */.xv, {
                        children: [
                            selectedItems.length,
                            " ",
                            listItemSubject
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Button */.zx, {
                        color: "ghost",
                        css: {
                            color: "$primary11"
                        },
                        onClick: ()=>setSelectedItems([]),
                        children: "Clear"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                align: "center",
                css: {
                    gap: "$4"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Button */.zx, {
                        onClick: ()=>setShowListingPage(true),
                        disabled: selectedItems.length < 1,
                        color: sellableItems.length > 0 ? "gray3" : "primary",
                        children: selectedItems.length > 0 ? "List ".concat(selectedItems.length, " ").concat(listItemSubject) : "List"
                    }),
                    sellableItems.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Button */.zx, {
                        onClick: ()=>setOpenAcceptBidModal(true),
                        disabled: sellableItems.length < 1,
                        children: sellableItems.length > 0 ? "Sell ".concat(sellableItems.length, " ").concat(sellItemSubject) : "Sell"
                    }) : null
                ]
            })
        ]
    });
};
/* harmony default export */ var portfolio_BatchActionsFooter = (BatchActionsFooter);

;// CONCATENATED MODULE: ./utils/defaultExpirationOptions.ts
const expirationOptions = [
    {
        text: "1 Hour",
        value: "hour",
        relativeTime: 1,
        relativeTimeUnit: "h"
    },
    {
        text: "12 Hours",
        value: "12 hours",
        relativeTime: 12,
        relativeTimeUnit: "h"
    },
    {
        text: "1 Day",
        value: "1 day",
        relativeTime: 1,
        relativeTimeUnit: "d"
    },
    {
        text: "3 Day",
        value: "3 days",
        relativeTime: 3,
        relativeTimeUnit: "d"
    },
    {
        text: "1 Week",
        value: "week",
        relativeTime: 1,
        relativeTimeUnit: "w"
    },
    {
        text: "1 Month",
        value: "month",
        relativeTime: 1,
        relativeTimeUnit: "M"
    },
    {
        text: "3 Months",
        value: "3 months",
        relativeTime: 3,
        relativeTimeUnit: "M"
    },
    {
        text: "6 Months",
        value: "6 months",
        relativeTime: 6,
        relativeTimeUnit: "M"
    }
];
/* harmony default export */ var defaultExpirationOptions = (expirationOptions);

// EXTERNAL MODULE: ./components/primitives/CryptoCurrencyIcon.tsx
var CryptoCurrencyIcon = __webpack_require__(72064);
// EXTERNAL MODULE: ./hooks/index.ts + 5 modules
var hooks = __webpack_require__(35430);
// EXTERNAL MODULE: ./node_modules/@rainbow-me/rainbowkit/dist/chunk-3B7JRKV5.js + 15 modules
var chunk_3B7JRKV5 = __webpack_require__(87671);
// EXTERNAL MODULE: ./components/common/LoadingSpinner.tsx
var LoadingSpinner = __webpack_require__(74431);
// EXTERNAL MODULE: ./stitches.config.ts + 1 modules
var stitches_config = __webpack_require__(50530);
// EXTERNAL MODULE: ./components/primitives/Dialog.tsx
var Dialog = __webpack_require__(39114);
;// CONCATENATED MODULE: ./public/ReservoirLogoWhiteText.tsx


const ReservoirLogoWhiteText = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "87",
        height: "20",
        viewBox: "0 0 87 20",
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M23.7727 6.57178C24.3413 6.53113 24.91 6.53113 25.4922 6.57178L25.6141 7.72354H25.6953C25.9119 6.81568 26.792 6.43628 28.0241 6.43628C28.0783 6.89698 28.0783 7.65579 28.0241 8.1165C26.4941 8.1165 26.0744 8.42815 25.7088 9.40376V13.6179C25.235 13.6856 24.233 13.6856 23.7727 13.6179V6.57178V6.57178Z",
                fill: "#ECEDEE",
                className: "letter"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M35.1731 10.691C34.2659 10.7588 32.1808 10.7723 31.0164 10.7046V11.0433C31.0164 12.0054 31.5715 12.1815 32.7359 12.1815C33.5348 12.1815 34.1035 12.1138 34.8617 11.9647C34.9158 12.4254 34.9158 13.0758 34.8617 13.5365C33.9139 13.6992 33.1557 13.7805 32.2621 13.7805C30.3123 13.7805 29.0802 13.1978 29.0802 11.4769V8.7669C29.0802 6.96473 30.38 6.43628 32.1808 6.43628C33.9681 6.43628 35.1731 7.19509 35.1731 9.13276V10.691ZM33.2775 9.05146C33.2775 8.13005 32.7495 8.02165 32.1537 8.02165C31.558 8.02165 31.0164 8.13005 31.0164 9.05146V9.57991L32.059 9.51216H33.2775V9.05146Z",
                fill: "#ECEDEE",
                className: "letter"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M41.618 11.9647C41.618 13.2791 40.589 13.7805 38.91 13.7805C38.1924 13.7805 37.3665 13.7263 36.5948 13.5908C36.5271 13.1029 36.5271 12.5474 36.5948 12.0731C37.3259 12.1951 38.057 12.2357 38.6257 12.2357C39.1673 12.2357 39.6818 12.1951 39.6818 11.7344V11.4769C39.6818 11.084 39.411 11.0162 38.9507 10.8943L37.7321 10.542C36.9603 10.3252 36.5406 9.83736 36.5406 8.94305V8.1978C36.5406 6.93763 37.6238 6.43628 39.3433 6.43628C40.0203 6.43628 40.7244 6.49048 41.5097 6.65308C41.5774 7.14089 41.5774 7.68289 41.5097 8.15715C40.6837 8.00809 40.1557 7.96744 39.5599 7.96744C38.9777 7.96744 38.4768 8.00809 38.4768 8.4688V8.72625C38.4768 9.06501 38.7882 9.18696 39.2079 9.30891L40.3452 9.62056C41.1847 9.85091 41.618 10.271 41.618 11.3008V11.9647V11.9647Z",
                fill: "#ECEDEE",
                className: "letter"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M49.1461 10.691C48.2389 10.7588 46.1538 10.7723 44.9894 10.7046V11.0433C44.9894 12.0054 45.5445 12.1815 46.7089 12.1815C47.5078 12.1815 48.0764 12.1138 48.8346 11.9647C48.8888 12.4254 48.8888 13.0758 48.8346 13.5365C47.8869 13.6992 47.1286 13.7805 46.235 13.7805C44.2853 13.7805 43.0532 13.1978 43.0532 11.4769V8.7669C43.0532 6.96473 44.353 6.43628 46.1538 6.43628C47.941 6.43628 49.1461 7.19509 49.1461 9.13276V10.691ZM47.2505 9.05146C47.2505 8.13005 46.7225 8.02165 46.1267 8.02165C45.531 8.02165 44.9894 8.13005 44.9894 9.05146V9.57991L46.0319 9.51216H47.2505V9.05146Z",
                fill: "#ECEDEE",
                className: "letter"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M50.8385 6.57178C51.4072 6.53113 51.9759 6.53113 52.5581 6.57178L52.6799 7.72354H52.7612C52.9778 6.81568 53.8579 6.43628 55.09 6.43628C55.1441 6.89698 55.1441 7.65579 55.09 8.1165C53.56 8.1165 53.1403 8.42815 52.7747 9.40376V13.6179C52.3008 13.6856 51.2989 13.6856 50.8385 13.6179V6.57178V6.57178Z",
                fill: "#ECEDEE",
                className: "letter"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M56.3898 6.62601C56.8637 6.55826 57.8656 6.55826 58.326 6.62601L59.8018 11.8428L61.2641 6.62601C61.7244 6.55826 62.6857 6.55826 63.1461 6.62601L60.9933 13.6179C60.3975 13.6856 59.1519 13.6856 58.5561 13.6179L56.3898 6.62601Z",
                fill: "#ECEDEE",
                className: "letter"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M70.6335 11.5177C70.6335 13.1979 69.3608 13.7806 67.4653 13.7806C65.5697 13.7806 64.297 13.1979 64.297 11.5177V8.72637C64.297 6.97841 65.5697 6.4364 67.4653 6.4364C69.3608 6.4364 70.6335 6.97841 70.6335 8.72637V11.5177ZM68.6974 9.11933C68.6974 8.18437 68.1287 8.07597 67.4653 8.07597C66.7883 8.07597 66.2331 8.18437 66.2331 9.11933V11.0976C66.2331 12.0191 66.7883 12.1275 67.4653 12.1275C68.1287 12.1275 68.6974 12.0191 68.6974 11.0976V9.11933Z",
                fill: "#ECEDEE",
                className: "letter"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M74.4111 5.52851C73.9372 5.59626 72.8676 5.59626 72.3802 5.52851L72.3531 3.9838C72.8405 3.91605 73.9643 3.91605 74.4517 3.9838L74.4111 5.52851ZM72.4343 6.62607C72.8947 6.55832 73.8966 6.55832 74.3705 6.62607V13.6179C73.8966 13.6857 72.8947 13.6857 72.4343 13.6179V6.62607Z",
                fill: "#ECEDEE",
                className: "letter"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M76.3473 6.5719C76.916 6.53125 77.4846 6.53125 78.0668 6.5719L78.1887 7.72366H78.2699C78.4866 6.81581 79.3666 6.4364 80.5988 6.4364C80.6529 6.89711 80.6529 7.65591 80.5988 8.11662C79.0688 8.11662 78.649 8.42827 78.2835 9.40388V13.618C77.8096 13.6857 76.8076 13.6857 76.3473 13.618V6.5719V6.5719Z",
                fill: "#ECEDEE",
                className: "letter"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M17.8287 13.645L11.5125 9.99999V2.70325L17.8287 6.35501V13.645Z",
                fill: "#80D8FF"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M5.19621 13.645L11.5125 9.99999V2.70325L5.19621 6.35501V13.645Z",
                fill: "#7ACFFF"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M11.5125 13.645L17.8287 9.99997L11.5125 6.35498L5.19621 9.99997L11.5125 13.645Z",
                fill: "url(#paint0_linear_11_289)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                opacity: "0.3",
                d: "M11.5125 17.2967L5.19621 13.645V6.35498L11.5125 9.99997V17.2967Z",
                fill: "#E4F0FE"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M5.19621 13.645L11.5125 17.2967V13.645L5.19621 10V13.645Z",
                fill: "url(#paint1_linear_11_289)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                opacity: "0.3",
                d: "M11.5125 17.2967L17.8287 13.645V6.35498L11.5125 9.99997V17.2967Z",
                fill: "#D0E6FF"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M17.8287 13.645L11.5125 17.2967V13.645L17.8287 10V13.645Z",
                fill: "url(#paint2_linear_11_289)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                opacity: "0.3",
                d: "M11.5125 9.99999L17.8287 6.35501L11.5125 2.70325L5.19621 6.35501L11.5125 9.99999Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint0_linear_11_289",
                        x1: "5.43455",
                        y1: "11.3599",
                        x2: "17.7593",
                        y2: "8.60718",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#C132CE"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#425AFA"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint1_linear_11_289",
                        x1: "7.62611",
                        y1: "11.2208",
                        x2: "9.44638",
                        y2: "17.2708",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#425AFA"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.16",
                                stopColor: "#5A52F2"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.55",
                                stopColor: "#9241DE"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.84",
                                stopColor: "#B436D3"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#C132CE"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint2_linear_11_289",
                        x1: "12.6302",
                        y1: "16.1518",
                        x2: "16.6613",
                        y2: "11.2104",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#C132CE"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.1",
                                stopColor: "#AB39D6"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.28",
                                stopColor: "#8545E3"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.47",
                                stopColor: "#684EED"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.65",
                                stopColor: "#5355F4"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.83",
                                stopColor: "#4659F9"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#425AFA"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var public_ReservoirLogoWhiteText = (ReservoirLogoWhiteText);

;// CONCATENATED MODULE: ./components/common/Modal.tsx










const Title = (0,stitches_config/* styled */.zo)(react_dialog_dist_index_module/* Title */.Dx, {
    margin: 0
});
const Logo = (0,stitches_config/* styled */.zo)(public_ReservoirLogoWhiteText, {
    "& .letter": {
        fill: "$gray12"
    }
});
const Modal = /*#__PURE__*/ (0,react.forwardRef)((param, forwardedRef)=>{
    let { title , children , trigger , onBack , open , onOpenChange , loading , onPointerDownOutside , onFocusCapture  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Dialog/* Dialog */.Vq, {
        ref: forwardedRef,
        trigger: trigger,
        open: open,
        onOpenChange: onOpenChange,
        onPointerDownOutside: onPointerDownOutside,
        onFocusCapture: onFocusCapture,
        overlayProps: {
            style: {
                opacity: 0.6
            }
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                css: {
                    p: 16,
                    backgroundColor: "$gray3",
                    alignItems: "center",
                    justifyContent: "space-between",
                    borderTopRightRadius: "$borderRadius",
                    borderTopLeftRadius: "$borderRadius"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Title, {
                        css: {
                            alignItems: "center",
                            display: "flex"
                        },
                        children: [
                            onBack && /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Button */.zx, {
                                color: "ghost",
                                size: "none",
                                css: {
                                    mr: "$2",
                                    color: "$neutralText"
                                },
                                onClick: onBack,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                    icon: free_solid_svg_icons/* faChevronLeft */.A35,
                                    width: 16,
                                    height: 16
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                style: "h6",
                                children: title
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(react_dialog_dist_index_module/* Close */.x8, {
                        asChild: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Button */.zx, {
                            color: "ghost",
                            size: "none",
                            css: {
                                color: "$neutralText"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                icon: free_solid_svg_icons/* faClose */.YIN,
                                width: 16,
                                height: 16
                            })
                        })
                    })
                ]
            }),
            loading && /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingSpinner/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Box */.xu, {
                css: {
                    maxHeight: "85vh",
                    overflowY: "auto",
                    backgroundColor: "$neutralBg"
                },
                children: children
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Flex */.kC, {
                css: {
                    mx: "auto",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: "$gray3",
                    py: 10.5,
                    borderBottomRightRadius: "$borderRadius",
                    borderBottomLeftRadius: "$borderRadius"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Anchor */.ee, {
                    href: "https://reservoir.tools/",
                    target: "_blank",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Text */.xv, {
                        style: "body3",
                        css: {
                            display: "inline-flex",
                            alignItems: "center",
                            gap: 4
                        },
                        children: [
                            "Powered by ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo, {})
                        ]
                    })
                })
            })
        ]
    });
});

;// CONCATENATED MODULE: ./components/common/TransactionProgress.tsx




const Img = (0,stitches_config/* styled */.zo)("img", {
    width: 56,
    height: 56,
    borderRadius: 4,
    objectFit: "cover",
    "& + img": {
        ml: -20
    }
});
const ProgressDot = (0,stitches_config/* styled */.zo)(primitives/* Box */.xu, {
    borderRadius: "50%",
    width: 5,
    height: 5
});
const loadingStart = (0,stitches_config/* keyframes */.F4)({
    "0%": {
        transform: "scale(0.8)",
        backgroundColor: "$gray9"
    },
    "20%": {
        transform: "scale(1)",
        backgroundColor: "$primary11"
    },
    "100%": {
        transform: "scale(0.8)",
        backgroundColor: "$gray9"
    }
});
const loadingMiddle = (0,stitches_config/* keyframes */.F4)({
    "0%": {
        transform: "scale(0.8)",
        backgroundColor: "$gray9"
    },
    "20%": {
        transform: "scale(0.8)",
        backgroundColor: "$gray9"
    },
    "40%": {
        transform: "scale(1)",
        backgroundColor: "$primary11"
    },
    "100%": {
        transform: "scale(0.8)",
        backgroundColor: "$gray9"
    }
});
const loadingEnd = (0,stitches_config/* keyframes */.F4)({
    "0%": {
        transform: "scale(0.8)",
        backgroundColor: "$grayy9"
    },
    "40%": {
        transform: "scale(0.8)",
        backgroundColor: "$gray9"
    },
    "60%": {
        transform: "scale(1)",
        backgroundColor: "$primary11"
    },
    "100%": {
        transform: "scale(0.8)",
        backgroundColor: "$gray9"
    }
});
const TransactionProgress = (param)=>{
    let { fromImgs , toImgs , ...props } = param;
    const hasManyFromImgs = fromImgs.length > 5;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
        ...props,
        align: "center",
        children: [
            fromImgs.map((src, i)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Img, {
                    src: src,
                    css: {
                        "& + img": {
                            ml: hasManyFromImgs ? -40 : -30
                        }
                    }
                }, i)),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                css: {
                    gap: "$1",
                    mx: 23
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProgressDot, {
                        css: {
                            animation: "".concat(loadingStart, " 1s ease-in-out infinite")
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProgressDot, {
                        css: {
                            animation: "".concat(loadingMiddle, " 1s ease-in-out infinite")
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProgressDot, {
                        css: {
                            animation: "".concat(loadingEnd, " 1s ease-in-out infinite")
                        }
                    })
                ]
            }),
            toImgs.map((src, i)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Img, {
                    src: src
                }, i))
        ]
    });
};
/* harmony default export */ var common_TransactionProgress = (TransactionProgress);

// EXTERNAL MODULE: ./components/primitives/Flex.tsx
var Flex = __webpack_require__(20326);
// EXTERNAL MODULE: ./components/primitives/Text.tsx
var Text = __webpack_require__(71818);
;// CONCATENATED MODULE: ./components/primitives/ErrorWell.tsx






function ErrorWell(param) {
    let { message , css  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
        css: {
            color: "$red11",
            p: "$4",
            gap: "$2",
            background: "$gray3",
            ...css
        },
        align: "center",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                icon: free_solid_svg_icons/* faCircleExclamation */.xHz,
                width: 16,
                height: 16
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                style: "body3",
                color: "error",
                children: message || "Oops, something went wrong. Please try again."
            })
        ]
    });
}

// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(27484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ./node_modules/wagmi/dist/index.js + 25 modules
var dist = __webpack_require__(69077);
// EXTERNAL MODULE: ./node_modules/@stitches/react/dist/index.mjs
var react_dist = __webpack_require__(86744);
;// CONCATENATED MODULE: ./components/portfolio/ApprovalCollapsible.tsx










const ApprovalCollapsible_Img = (0,react_dist/* styled */.zo)("img", {
    height: 24,
    width: 24,
    borderRadius: 4,
    objectFit: "cover",
    "& + img": {
        marginLeft: -10
    }
});
const ApprovalCollapsible = (param)=>{
    let { item , batchListingData , selectedMarketplaces , open  } = param;
    var _batchListingData_orderIndexes_, _batchListingData_orderIndexes__token, _batchListingData_orderIndexes__token_token, _batchListingData_orderIndexes__token_token_collection;
    const [collapsibleOpen, setCollapsibleOpen] = (0,react.useState)(false);
    let isComplete = item.status == "complete";
    const orderIndexes = (item === null || item === void 0 ? void 0 : item.orderIndexes) || [];
    const marketplacesSeekingApproval = (0,react.useMemo)(()=>{
        let uniqueMarketplaces = [];
        orderIndexes.forEach((orderIndex)=>{
            if (batchListingData[orderIndex]) {
                const listing = batchListingData[orderIndex].listing;
                const marketplace = selectedMarketplaces.find((m)=>m.orderbook === listing.orderbook);
                if (marketplace && !uniqueMarketplaces.find((uniqueMarketplace)=>uniqueMarketplace.orderbook === marketplace.orderbook)) {
                    uniqueMarketplaces.push(marketplace);
                }
            }
        });
        return uniqueMarketplaces;
    }, [
        orderIndexes,
        item,
        batchListingData
    ]);
    const marketplaceNames = (0,react.useMemo)(()=>{
        return marketplacesSeekingApproval.map((marketplace)=>marketplace.name).join(" and ");
    }, [
        marketplacesSeekingApproval
    ]);
    const collectionImage = (0,react.useMemo)(()=>{
        var _batchListingData_orderIndexes_, _batchListingData_orderIndexes__token, _token_collection;
        const token = (_batchListingData_orderIndexes_ = batchListingData[orderIndexes[0]]) === null || _batchListingData_orderIndexes_ === void 0 ? void 0 : (_batchListingData_orderIndexes__token = _batchListingData_orderIndexes_.token) === null || _batchListingData_orderIndexes__token === void 0 ? void 0 : _batchListingData_orderIndexes__token.token;
        return (0,optimizeImage/* default */.Z)(token === null || token === void 0 ? void 0 : (_token_collection = token.collection) === null || _token_collection === void 0 ? void 0 : _token_collection.imageUrl, 250) || (token === null || token === void 0 ? void 0 : token.imageSmall) || "";
    }, [
        batchListingData,
        orderIndexes
    ]);
    const collectionName = ((_batchListingData_orderIndexes_ = batchListingData[orderIndexes[0]]) === null || _batchListingData_orderIndexes_ === void 0 ? void 0 : (_batchListingData_orderIndexes__token = _batchListingData_orderIndexes_.token) === null || _batchListingData_orderIndexes__token === void 0 ? void 0 : (_batchListingData_orderIndexes__token_token = _batchListingData_orderIndexes__token.token) === null || _batchListingData_orderIndexes__token_token === void 0 ? void 0 : (_batchListingData_orderIndexes__token_token_collection = _batchListingData_orderIndexes__token_token.collection) === null || _batchListingData_orderIndexes__token_token_collection === void 0 ? void 0 : _batchListingData_orderIndexes__token_token_collection.name) || "collection";
    (0,react.useEffect)(()=>{
        if (open !== undefined && open !== collapsibleOpen) {
            setCollapsibleOpen(open);
        }
    }, [
        open
    ]);
    (0,react.useEffect)(()=>{
        if (isComplete) {
            setCollapsibleOpen(false);
        }
    }, [
        isComplete
    ]);
    if (batchListingData[orderIndexes[0]] == undefined) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Collapsible/* CollapsibleRoot */.Kq, {
        onOpenChange: (open)=>{
            setCollapsibleOpen(open);
        },
        open: collapsibleOpen,
        css: {
            backgroundColor: "$gray3",
            width: "100%"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_collapsible_dist_index_module/* Trigger */.xz, {
                asChild: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                    justify: "between",
                    css: {
                        px: "$4",
                        py: "$3"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                            align: "center",
                            css: {
                                gap: "$3"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Box */.xu, {
                                    css: {
                                        width: 18,
                                        height: 18,
                                        backgroundColor: isComplete ? "$green6" : "$indigo6",
                                        borderColor: isComplete ? "$green9" : "$indigo9",
                                        borderStyle: "solid",
                                        borderWidth: 4,
                                        borderRadius: 999
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                    style: "subtitle2",
                                    css: {
                                        color: isComplete ? "$gray11" : "$gray12"
                                    },
                                    children: "Approve Collection"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Box */.xu, {
                            css: {
                                color: "$neutralSolid",
                                transform: collapsibleOpen ? "rotate(180deg)" : "rotate(0)",
                                transition: ".3s"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                icon: free_solid_svg_icons/* faChevronDown */.ptq
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Collapsible/* CollapsibleContent */.Fw, {
                css: {
                    '&[data-state="open"]': {
                        animation: "".concat(Collapsible/* slideDown */.qw, " 300ms cubic-bezier(0.87, 0, 0.13, 1)")
                    },
                    '&[data-state="closed"]': {
                        animation: "".concat(Collapsible/* slideUp */.iM, " 300ms cubic-bezier(0.87, 0, 0.13, 1)")
                    }
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                    align: "center",
                    justify: "between",
                    css: {
                        px: "$4",
                        pb: "$2",
                        width: "100%",
                        gap: "$2"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                            css: {
                                gap: "$2"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                    align: "center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ApprovalCollapsible_Img, {
                                            src: collectionImage
                                        }),
                                        marketplacesSeekingApproval.map((marketplace)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(ApprovalCollapsible_Img, {
                                                src: marketplace.imageUrl
                                            }))
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Text */.xv, {
                                    style: "body3",
                                    ellipsify: true,
                                    children: [
                                        "Approve ",
                                        collectionName,
                                        " on ",
                                        marketplaceNames
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Flex */.kC, {
                            children: item.txHash && item.status == "incomplete" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingSpinner/* default */.Z, {
                                css: {
                                    width: 18,
                                    height: 18,
                                    borderWidth: 2,
                                    borderBottomColor: "$indigo10"
                                }
                            }) : null
                        })
                    ]
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/viem/dist/esm/utils/unit/parseUnits.js
var parseUnits = __webpack_require__(22852);
// EXTERNAL MODULE: ./node_modules/viem/dist/esm/constants/address.js
var address = __webpack_require__(66373);
;// CONCATENATED MODULE: ./components/portfolio/BatchListModal.tsx
















var BatchListStep;
(function(BatchListStep) {
    BatchListStep[BatchListStep["Approving"] = 0] = "Approving";
    BatchListStep[BatchListStep["Complete"] = 1] = "Complete";
})(BatchListStep || (BatchListStep = {}));
const BatchListModal = (param)=>{
    let { listings , disabled , currency , selectedMarketplaces , onCloseComplete  } = param;
    var _stepData_currentStep_items;
    const [open, setOpen] = (0,react.useState)(false);
    const { data: wallet  } = (0,dist/* useWalletClient */.py)();
    const { openConnectModal  } = (0,chunk_3B7JRKV5/* useConnectModal */.We)();
    const { chain: activeChain  } = (0,dist/* useNetwork */.LN)();
    const marketplaceChain = (0,hooks/* useMarketplaceChain */.gw)();
    const { switchNetworkAsync  } = (0,dist/* useSwitchNetwork */.g0)({
        chainId: marketplaceChain.id
    });
    const isInTheWrongNetwork = Boolean(wallet && (activeChain === null || activeChain === void 0 ? void 0 : activeChain.id) !== marketplaceChain.id);
    const client = (0,dist_index_module/* useReservoirClient */.RW)();
    const [batchListStep, setBatchListStep] = (0,react.useState)(BatchListStep.Approving);
    const [stepData, setStepData] = (0,react.useState)(null);
    const [transactionError, setTransactionError] = (0,react.useState)();
    const [stepTitle, setStepTitle] = (0,react.useState)("");
    const [uniqueMarketplaces, setUniqueMarketplaces] = (0,react.useState)([]);
    const getUniqueMarketplaces = (0,react.useCallback)((listings)=>{
        const marketplaces = [];
        listings.forEach((listing)=>{
            const marketplace = selectedMarketplaces.find((m)=>m.orderbook === listing.listing.orderbook);
            if (marketplace && !marketplaces.includes(marketplace)) {
                marketplaces.push(marketplace);
            }
        });
        return marketplaces;
    }, [
        listings
    ]);
    (0,react.useEffect)(()=>{
        if (stepData) {
            const orderKind = stepData.listings[0].listing.orderKind || "exchange";
            const marketplaces = getUniqueMarketplaces(stepData.listings);
            const marketplaceNames = marketplaces.map((marketplace)=>marketplace.name).join(" and ");
            setUniqueMarketplaces(marketplaces);
            switch(stepData.currentStep.kind){
                case "transaction":
                    {
                        setStepTitle("Approve ".concat((orderKind === null || orderKind === void 0 ? void 0 : orderKind[0].toUpperCase()) + (orderKind === null || orderKind === void 0 ? void 0 : orderKind.slice(1)), " to access item\nin your wallet"));
                        break;
                    }
                case "signature":
                    {
                        setStepTitle("Confirm listings on ".concat(marketplaceNames, "\nin your wallet"));
                        break;
                    }
            }
        }
    }, [
        stepData
    ]);
    const listTokens = (0,react.useCallback)(()=>{
        if (!wallet) {
            const error = new Error("Missing a wallet");
            setTransactionError(error);
            throw error;
        }
        if (!client) {
            const error1 = new Error("ReservoirClient was not initialized");
            setTransactionError(error1);
            throw error1;
        }
        setTransactionError(null);
        const batchListingData = [];
        listings.forEach((listing)=>{
            var _listing_token_token, _listing_token_token1;
            let expirationTime = null;
            if (listing.expirationOption && listing.expirationOption.relativeTime && listing.expirationOption.relativeTimeUnit) {
                expirationTime = dayjs_min_default()().add(listing.expirationOption.relativeTime, listing.expirationOption.relativeTimeUnit).unix().toString();
            }
            const token = "".concat((_listing_token_token = listing.token.token) === null || _listing_token_token === void 0 ? void 0 : _listing_token_token.contract, ":").concat((_listing_token_token1 = listing.token.token) === null || _listing_token_token1 === void 0 ? void 0 : _listing_token_token1.tokenId);
            const convertedListing = {
                token: token,
                weiPrice: ((0,parseUnits/* parseUnits */.v)("".concat(+listing.price), currency.decimals || 18) * BigInt(listing.quantity)).toString(),
                orderbook: listing.orderbook,
                orderKind: listing.orderKind,
                quantity: listing.quantity
            };
            if (expirationTime) {
                convertedListing.expirationTime = expirationTime;
            }
            if (currency && currency.contract != address/* zeroAddress */.D) {
                convertedListing.currency = currency.contract;
            }
            batchListingData.push({
                listing: convertedListing,
                token: listing.token
            });
        });
        setBatchListStep(BatchListStep.Approving);
        client.actions.listToken({
            listings: batchListingData.map((data)=>data.listing),
            wallet,
            onProgress: (steps)=>{
                const executableSteps = steps.filter((step)=>step.items && step.items.length > 0);
                let stepCount = executableSteps.length;
                let incompleteStepItemIndex = null;
                let incompleteStepIndex = null;
                executableSteps.find((step, i)=>{
                    if (!step.items) {
                        return false;
                    }
                    incompleteStepItemIndex = step.items.findIndex((item)=>item.status == "incomplete");
                    if (incompleteStepItemIndex !== -1) {
                        incompleteStepIndex = i;
                        return true;
                    }
                });
                if (incompleteStepIndex === null || incompleteStepItemIndex === null) {
                    const currentStep = executableSteps[executableSteps.length - 1];
                    setBatchListStep(BatchListStep.Complete);
                    setStepData({
                        totalSteps: stepCount,
                        stepProgress: stepCount,
                        currentStep,
                        listings: batchListingData
                    });
                } else {
                    setStepData({
                        totalSteps: stepCount,
                        stepProgress: incompleteStepIndex,
                        currentStep: executableSteps[incompleteStepIndex],
                        listings: batchListingData
                    });
                }
            }
        }).catch((e)=>{
            const error = e;
            const transactionError = new Error("Oops, something went wrong. Please try again.", {
                cause: error
            });
            setTransactionError(transactionError);
        });
    }, [
        client,
        listings,
        wallet
    ]);
    const trigger = /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Button */.zx, {
        disabled: disabled,
        onClick: listTokens,
        children: "List"
    });
    if (isInTheWrongNetwork) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Button */.zx, {
            disabled: disabled,
            onClick: async ()=>{
                if (isInTheWrongNetwork && switchNetworkAsync) {
                    const chain = await switchNetworkAsync(marketplaceChain.id);
                    if (chain.id !== marketplaceChain.id) {
                        return false;
                    }
                }
                if (!wallet) {
                    openConnectModal === null || openConnectModal === void 0 ? void 0 : openConnectModal();
                }
            },
            children: "List"
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal, {
        title: "Complete Listings",
        trigger: trigger,
        open: open,
        onOpenChange: (open)=>{
            if (!open && onCloseComplete && batchListStep === BatchListStep.Complete) {
                onCloseComplete();
            }
            setOpen(open);
        },
        children: [
            batchListStep === BatchListStep.Approving && /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                direction: "column",
                justify: "start",
                align: "center",
                css: {
                    flex: 1,
                    textAlign: "center",
                    p: "$4",
                    gap: "$4"
                },
                children: [
                    transactionError && /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorWell, {
                        message: transactionError.message,
                        css: {
                            width: "100%"
                        }
                    }),
                    !stepData && !transactionError && /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Flex */.kC, {
                        css: {
                            height: "100%",
                            py: "$6"
                        },
                        align: "center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingSpinner/* default */.Z, {})
                    }),
                    stepData && /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                        direction: "column",
                        align: "center",
                        css: {
                            maxHeight: "40vh",
                            overflowY: "auto",
                            width: "100%"
                        },
                        children: [
                            stepData.currentStep.kind === "signature" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                css: {
                                    textAlign: "center",
                                    my: 28,
                                    maxWidth: 400
                                },
                                style: "subtitle1",
                                children: stepTitle
                            }) : null,
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Flex */.kC, {
                                direction: "column",
                                css: {
                                    gap: "$3",
                                    width: "100%"
                                },
                                children: stepData.currentStep.kind === "transaction" ? (_stepData_currentStep_items = stepData.currentStep.items) === null || _stepData_currentStep_items === void 0 ? void 0 : _stepData_currentStep_items.map((item, i)=>{
                                    if (item.data) return /*#__PURE__*/ (0,jsx_runtime.jsx)(ApprovalCollapsible, {
                                        item: item,
                                        batchListingData: stepData.listings,
                                        selectedMarketplaces: selectedMarketplaces,
                                        open: item.status == "incomplete"
                                    }, i);
                                }) : null
                            }),
                            stepData.currentStep.kind === "signature" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(common_TransactionProgress, {
                                justify: "center",
                                css: {
                                    mb: "$3"
                                },
                                fromImgs: stepData.listings.map((listing)=>{
                                    var _listing_token_token;
                                    return (_listing_token_token = listing.token.token) === null || _listing_token_token === void 0 ? void 0 : _listing_token_token.imageSmall;
                                }),
                                toImgs: uniqueMarketplaces.map((marketplace)=>{
                                    return (marketplace === null || marketplace === void 0 ? void 0 : marketplace.imageUrl) || "";
                                })
                            }) : null
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                        css: {
                            textAlign: "center",
                            maxWidth: 395,
                            mx: "auto"
                        },
                        style: "body3",
                        color: "subtle",
                        children: stepData === null || stepData === void 0 ? void 0 : stepData.currentStep.description
                    }),
                    !transactionError ? /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Button */.zx, {
                        css: {
                            width: "100%",
                            justifyContent: "center"
                        },
                        disabled: true,
                        children: "Waiting for Approval..."
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Button */.zx, {
                        css: {
                            width: "100%",
                            justifyContent: "center"
                        },
                        onClick: ()=>setOpen(false),
                        children: "Close"
                    })
                ]
            }),
            batchListStep === BatchListStep.Complete && /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                direction: "column",
                align: "center",
                justify: "center",
                css: {
                    flex: 1,
                    textAlign: "center",
                    p: "$4"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                        direction: "column",
                        css: {
                            my: 50
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Box */.xu, {
                                css: {
                                    color: "$green10",
                                    mb: 24
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                    icon: free_solid_svg_icons/* faCheckCircle */.f8k,
                                    size: "2x"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                style: "h5",
                                children: "Your items have been listed!"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Button */.zx, {
                        css: {
                            width: "100%",
                            justifyContent: "center"
                        },
                        onClick: ()=>{
                            setOpen(false);
                            onCloseComplete === null || onCloseComplete === void 0 ? void 0 : onCloseComplete();
                        },
                        children: "Close"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var portfolio_BatchListModal = (BatchListModal);

;// CONCATENATED MODULE: ./components/portfolio/BatchListingsTableHeading.tsx



const BatchListingsTableHeading = (param)=>{
    let { displayQuantity , gridTemplateColumns  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* HeaderRow */.VJ, {
        css: {
            display: "none",
            "@md": {
                display: "grid"
            },
            gridTemplateColumns: gridTemplateColumns,
            position: "sticky",
            top: navbar/* NAVBAR_HEIGHT */.ik,
            backgroundColor: "$neutralBg"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* TableCell */.pj, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                    style: "subtitle3",
                    color: "subtle",
                    children: "Items"
                })
            }),
            displayQuantity ? /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* TableCell */.pj, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                    style: "subtitle3",
                    color: "subtle",
                    children: "Quantity"
                })
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* TableCell */.pj, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                    style: "subtitle3",
                    color: "subtle",
                    children: "Price"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* TableCell */.pj, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                    style: "subtitle3",
                    color: "subtle",
                    children: "Expiration"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* TableCell */.pj, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                    style: "subtitle3",
                    color: "subtle",
                    children: "Creator Royalties"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* TableCell */.pj, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                    style: "subtitle3",
                    color: "subtle",
                    children: "Marketplace Fee"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* TableCell */.pj, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                    style: "subtitle3",
                    color: "subtle",
                    children: "Profit"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* TableCell */.pj, {
                css: {
                    marginLeft: "auto"
                }
            })
        ]
    });
};

// EXTERNAL MODULE: ./hooks/useOpenseaFees.ts
var useOpenseaFees = __webpack_require__(35312);
// EXTERNAL MODULE: ./context/ToastContextProvider.tsx + 4 modules
var ToastContextProvider = __webpack_require__(98045);
;// CONCATENATED MODULE: ./components/portfolio/BatchListingsTableRow.tsx










const MINIMUM_AMOUNT = 0.000001;
const BatchListingsTableRow = (param)=>{
    let { listing , listings , setListings , updateListing , selectedItems , displayQuantity , gridTemplateColumns , isLargeDevice , setSelectedItems , globalExpirationOption , globalPrice , currency , defaultCurrency , selectedMarketplaces  } = param;
    var _listing_token_token, _listing_token_token1, _listing_token_token_collection, _listing_token, _listing_token_token2, _listing_token_token_collection1, _listing_token1, _listing_token_token3, _listing_token_token_collection2, _listing_token2, _listing_token_token4, _listing_token_token5, _listing_token3, _listing_token_ownership, _listing_token_ownership1, _listing_token4, _listing_token_token6, _listing_token_token_collection3, _listing_token_token_collection_floorAskPrice, _listing_token_token_collection_floorAskPrice_amount, _listing_token5, _listing_token_token7, _listing_token_token_collection4, _listing_token_token_collection_floorAskPrice1, _listing_token_token_collection_floorAskPrice_amount1, _listing_token6, _listing_token_token8, _listing_token_token_collection5, _listing_token_token_collection_floorAskPrice2, _listing_token_token_collection_floorAskPrice_amount2;
    const [expirationOption, setExpirationOption] = (0,react.useState)(globalExpirationOption);
    const [price, setPrice] = (0,react.useState)(listing.price);
    const [quantity, setQuantity] = (0,react.useState)(1);
    const [marketplaceFee, setMarketplaceFee] = (0,react.useState)(0);
    const [marketplaceFeePercent, setMarketplaceFeePercent] = (0,react.useState)(0);
    const tokenImage = (0,react.useMemo)(()=>{
        var _listing_token_token;
        return (0,optimizeImage/* default */.Z)((_listing_token_token = listing.token.token) === null || _listing_token_token === void 0 ? void 0 : _listing_token_token.image, 250);
    }, [
        (_listing_token_token = listing.token.token) === null || _listing_token_token === void 0 ? void 0 : _listing_token_token.image
    ]);
    const { addToast  } = (0,react.useContext)(ToastContextProvider/* ToastContext */.u);
    const marketplace = selectedMarketplaces.find((m)=>m.orderbook === listing.orderbook);
    const handleMarketplaceFeeChange = (0,react.useCallback)((marketplaceFee)=>{
        setMarketplaceFee(marketplaceFee);
        const updatedListing = {
            ...listing,
            marketplaceFee: marketplaceFee
        };
        updateListing(updatedListing);
    }, [
        listing,
        updateListing
    ]);
    const removeListing = (0,react.useCallback)((token, orderbook)=>{
        const updatedListings = listings.filter((listing)=>{
            var _listing_token_token, _listing_token_token1;
            return "".concat((_listing_token_token = listing.token.token) === null || _listing_token_token === void 0 ? void 0 : _listing_token_token.contract, ":").concat((_listing_token_token1 = listing.token.token) === null || _listing_token_token1 === void 0 ? void 0 : _listing_token_token1.tokenId) !== token || listing.orderbook !== orderbook;
        });
        // Update selectedItems
        const selectedItemIndex = selectedItems.findIndex((item)=>{
            var _item_token, _item_token1;
            return "".concat(item === null || item === void 0 ? void 0 : (_item_token = item.token) === null || _item_token === void 0 ? void 0 : _item_token.contract, ":").concat(item === null || item === void 0 ? void 0 : (_item_token1 = item.token) === null || _item_token1 === void 0 ? void 0 : _item_token1.tokenId) === token;
        });
        if (selectedItemIndex !== -1 && !updatedListings.some((listing)=>{
            var _listing_token_token, _listing_token_token1;
            return "".concat((_listing_token_token = listing.token.token) === null || _listing_token_token === void 0 ? void 0 : _listing_token_token.contract, ":").concat((_listing_token_token1 = listing.token.token) === null || _listing_token_token1 === void 0 ? void 0 : _listing_token_token1.tokenId) === token;
        })) {
            const updatedSelectedItems = [
                ...selectedItems
            ];
            updatedSelectedItems.splice(selectedItemIndex, 1);
            setSelectedItems(updatedSelectedItems);
        }
        setListings(updatedListings);
    }, [
        listings
    ]);
    let openseaFees = (0,useOpenseaFees/* default */.Z)(listing.orderbook == "opensea" ? (_listing_token_token1 = listing.token.token) === null || _listing_token_token1 === void 0 ? void 0 : (_listing_token_token_collection = _listing_token_token1.collection) === null || _listing_token_token_collection === void 0 ? void 0 : _listing_token_token_collection.id : undefined);
    (0,react.useEffect)(()=>{
        if (openseaFees && openseaFees.fee && openseaFees.fee.bps && listing.orderbook == "opensea") {
            // Remove listing and emit toast if listing not enabled
            if (!openseaFees.listingEnabled) {
                var _listing_token_token, _listing_token_token1, _listing_token_token2;
                addToast === null || addToast === void 0 ? void 0 : addToast({
                    title: "Listing not enabled",
                    description: "Cannnot list ".concat((_listing_token_token = listing.token.token) === null || _listing_token_token === void 0 ? void 0 : _listing_token_token.name, " on OpenSea")
                });
                removeListing("".concat((_listing_token_token1 = listing.token.token) === null || _listing_token_token1 === void 0 ? void 0 : _listing_token_token1.contract, ":").concat((_listing_token_token2 = listing.token.token) === null || _listing_token_token2 === void 0 ? void 0 : _listing_token_token2.tokenId), listing.orderbook);
            }
            setMarketplaceFeePercent(openseaFees.fee.bps / 100 || 0);
            handleMarketplaceFeeChange(openseaFees.fee.bps / 10000 * Number(price) * listing.quantity || 0);
        }
    }, [
        openseaFees,
        price,
        quantity,
        marketplace
    ]);
    const creatorRoyalties = ((listing === null || listing === void 0 ? void 0 : (_listing_token = listing.token) === null || _listing_token === void 0 ? void 0 : (_listing_token_token2 = _listing_token.token) === null || _listing_token_token2 === void 0 ? void 0 : (_listing_token_token_collection1 = _listing_token_token2.collection) === null || _listing_token_token_collection1 === void 0 ? void 0 : _listing_token_token_collection1.royaltiesBps) || 0) / 10000;
    const profit = Number(price) * listing.quantity - marketplaceFee - creatorRoyalties * Number(price) * listing.quantity;
    const topTraitPrice = (0,react.useMemo)(()=>{
        var _listing_token_token;
        if (!((_listing_token_token = listing.token.token) === null || _listing_token_token === void 0 ? void 0 : _listing_token_token.attributes)) return undefined;
        var _attribute_floorAskPrice;
        // Find the highest floor price
        return Math.max(...listing.token.token.attributes.map((attribute)=>(_attribute_floorAskPrice = attribute.floorAskPrice) !== null && _attribute_floorAskPrice !== void 0 ? _attribute_floorAskPrice : 0));
    }, []);
    (0,react.useEffect)(()=>{
        handlePriceChange(globalPrice);
    }, [
        globalPrice
    ]);
    (0,react.useEffect)(()=>{
        if (listing.price != price && Number(listing.price) != 0) {
            handlePriceChange(listing.price);
        }
    }, [
        listing.price
    ]);
    (0,react.useEffect)(()=>{
        handleExpirationChange(globalExpirationOption.value);
    }, [
        globalExpirationOption
    ]);
    const handleExpirationChange = (0,react.useCallback)((value)=>{
        const option = defaultExpirationOptions.find((option)=>option.value === value);
        if (option) {
            setExpirationOption(option);
            const updatedListing = {
                ...listing,
                expirationOption: option
            };
            updateListing(updatedListing);
        }
    }, [
        listing,
        updateListing
    ]);
    const handlePriceChange = (0,react.useCallback)((value)=>{
        setPrice(value);
        const updatedListing = {
            ...listing,
            price: value
        };
        updateListing(updatedListing);
    }, [
        listing,
        updateListing
    ]);
    const handleQuantityChange = (0,react.useCallback)((quantity)=>{
        setQuantity(quantity);
        const updatedListing = {
            ...listing,
            quantity: quantity
        };
        updateListing(updatedListing);
    }, [
        listing,
        updateListing
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* TableRow */.SC, {
        css: {
            gridTemplateColumns: gridTemplateColumns,
            alignItems: "stretch",
            py: "$2",
            "&:last-child": {
                borderBottom: "none"
            }
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* TableCell */.pj, {
                css: {
                    overflow: "hidden",
                    minWidth: 0
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                    align: "center",
                    css: {
                        gap: "$3"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: marketplace === null || marketplace === void 0 ? void 0 : marketplace.imageUrl,
                            alt: marketplace === null || marketplace === void 0 ? void 0 : marketplace.name,
                            style: {
                                width: 32,
                                height: 32,
                                borderRadius: 4,
                                aspectRatio: "1/1",
                                visibility: (marketplace === null || marketplace === void 0 ? void 0 : marketplace.imageUrl) ? "visible" : "hidden"
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: tokenImage,
                            style: {
                                width: 48,
                                height: 48,
                                borderRadius: 4,
                                aspectRatio: "1/1"
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                            direction: "column",
                            css: {
                                minWidth: 0
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                    style: "subtitle3",
                                    color: "subtle",
                                    ellipsify: true,
                                    children: listing === null || listing === void 0 ? void 0 : (_listing_token1 = listing.token) === null || _listing_token1 === void 0 ? void 0 : (_listing_token_token3 = _listing_token1.token) === null || _listing_token_token3 === void 0 ? void 0 : (_listing_token_token_collection2 = _listing_token_token3.collection) === null || _listing_token_token_collection2 === void 0 ? void 0 : _listing_token_token_collection2.name
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Text */.xv, {
                                    ellipsify: true,
                                    children: [
                                        "#",
                                        listing === null || listing === void 0 ? void 0 : (_listing_token2 = listing.token) === null || _listing_token2 === void 0 ? void 0 : (_listing_token_token4 = _listing_token2.token) === null || _listing_token_token4 === void 0 ? void 0 : _listing_token_token4.tokenId
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            displayQuantity ? /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* TableCell */.pj, {
                css: {
                    minWith: 0,
                    overflow: "hidden"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                    direction: "column",
                    align: "start",
                    css: {
                        gap: "$2",
                        minWidth: 0,
                        overflow: "hidden"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Input */.II, {
                            type: "number",
                            value: quantity,
                            onChange: (e)=>{
                                var _listing_token_ownership;
                                const inputValue = Number(e.target.value);
                                const max = Number((_listing_token_ownership = listing.token.ownership) === null || _listing_token_ownership === void 0 ? void 0 : _listing_token_ownership.tokenCount);
                                if (e.target.value === "") {
                                    setQuantity(undefined);
                                } else if (inputValue > max) {
                                    handleQuantityChange(max);
                                } else {
                                    handleQuantityChange(inputValue);
                                }
                            },
                            onBlur: ()=>{
                                if (quantity === undefined || quantity <= 0) {
                                    handleQuantityChange(1);
                                }
                            },
                            css: {
                                maxWidth: 45
                            },
                            disabled: ((_listing_token_token5 = listing.token.token) === null || _listing_token_token5 === void 0 ? void 0 : _listing_token_token5.kind) !== "erc1155" || Number(listing === null || listing === void 0 ? void 0 : (_listing_token3 = listing.token) === null || _listing_token3 === void 0 ? void 0 : (_listing_token_ownership = _listing_token3.ownership) === null || _listing_token_ownership === void 0 ? void 0 : _listing_token_ownership.tokenCount) <= 1
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Text */.xv, {
                            style: "subtitle3",
                            color: "subtle",
                            ellipsify: true,
                            css: {
                                width: "100%"
                            },
                            children: [
                                (_listing_token_ownership1 = listing.token.ownership) === null || _listing_token_ownership1 === void 0 ? void 0 : _listing_token_ownership1.tokenCount,
                                " available"
                            ]
                        })
                    ]
                })
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* TableCell */.pj, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                    align: "start",
                    css: {
                        gap: "$3"
                    },
                    children: [
                        isLargeDevice ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                    direction: "column",
                                    align: "center",
                                    css: {
                                        gap: "$2"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Button */.zx, {
                                            color: "gray3",
                                            corners: "pill",
                                            size: "large",
                                            css: {
                                                minWidth: "max-content",
                                                minHeight: 48,
                                                py: 14
                                            },
                                            disabled: !((_listing_token4 = listing.token) === null || _listing_token4 === void 0 ? void 0 : (_listing_token_token6 = _listing_token4.token) === null || _listing_token_token6 === void 0 ? void 0 : (_listing_token_token_collection3 = _listing_token_token6.collection) === null || _listing_token_token_collection3 === void 0 ? void 0 : (_listing_token_token_collection_floorAskPrice = _listing_token_token_collection3.floorAskPrice) === null || _listing_token_token_collection_floorAskPrice === void 0 ? void 0 : (_listing_token_token_collection_floorAskPrice_amount = _listing_token_token_collection_floorAskPrice.amount) === null || _listing_token_token_collection_floorAskPrice_amount === void 0 ? void 0 : _listing_token_token_collection_floorAskPrice_amount.native),
                                            onClick: ()=>{
                                                var _listing_token, _listing_token_token, _listing_token_token_collection, _listing_token_token_collection_floorAskPrice, _listing_token_token_collection_floorAskPrice_amount;
                                                if ((_listing_token = listing.token) === null || _listing_token === void 0 ? void 0 : (_listing_token_token = _listing_token.token) === null || _listing_token_token === void 0 ? void 0 : (_listing_token_token_collection = _listing_token_token.collection) === null || _listing_token_token_collection === void 0 ? void 0 : (_listing_token_token_collection_floorAskPrice = _listing_token_token_collection.floorAskPrice) === null || _listing_token_token_collection_floorAskPrice === void 0 ? void 0 : (_listing_token_token_collection_floorAskPrice_amount = _listing_token_token_collection_floorAskPrice.amount) === null || _listing_token_token_collection_floorAskPrice_amount === void 0 ? void 0 : _listing_token_token_collection_floorAskPrice_amount.native) {
                                                    var _listing_token1, _listing_token_token1, _listing_token_token_collection1, _listing_token_token_collection_floorAskPrice1, _listing_token_token_collection_floorAskPrice_amount1, _listing_token_token_collection_floorAskPrice_amount_native;
                                                    handlePriceChange((_listing_token1 = listing.token) === null || _listing_token1 === void 0 ? void 0 : (_listing_token_token1 = _listing_token1.token) === null || _listing_token_token1 === void 0 ? void 0 : (_listing_token_token_collection1 = _listing_token_token1.collection) === null || _listing_token_token_collection1 === void 0 ? void 0 : (_listing_token_token_collection_floorAskPrice1 = _listing_token_token_collection1.floorAskPrice) === null || _listing_token_token_collection_floorAskPrice1 === void 0 ? void 0 : (_listing_token_token_collection_floorAskPrice_amount1 = _listing_token_token_collection_floorAskPrice1.amount) === null || _listing_token_token_collection_floorAskPrice_amount1 === void 0 ? void 0 : (_listing_token_token_collection_floorAskPrice_amount_native = _listing_token_token_collection_floorAskPrice_amount1.native) === null || _listing_token_token_collection_floorAskPrice_amount_native === void 0 ? void 0 : _listing_token_token_collection_floorAskPrice_amount_native.toString());
                                                }
                                            },
                                            children: "Floor"
                                        }),
                                        ((_listing_token5 = listing.token) === null || _listing_token5 === void 0 ? void 0 : (_listing_token_token7 = _listing_token5.token) === null || _listing_token_token7 === void 0 ? void 0 : (_listing_token_token_collection4 = _listing_token_token7.collection) === null || _listing_token_token_collection4 === void 0 ? void 0 : (_listing_token_token_collection_floorAskPrice1 = _listing_token_token_collection4.floorAskPrice) === null || _listing_token_token_collection_floorAskPrice1 === void 0 ? void 0 : (_listing_token_token_collection_floorAskPrice_amount1 = _listing_token_token_collection_floorAskPrice1.amount) === null || _listing_token_token_collection_floorAskPrice_amount1 === void 0 ? void 0 : _listing_token_token_collection_floorAskPrice_amount1.native) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                            style: "subtitle3",
                                            color: "subtle",
                                            children: "".concat((_listing_token6 = listing.token) === null || _listing_token6 === void 0 ? void 0 : (_listing_token_token8 = _listing_token6.token) === null || _listing_token_token8 === void 0 ? void 0 : (_listing_token_token_collection5 = _listing_token_token8.collection) === null || _listing_token_token_collection5 === void 0 ? void 0 : (_listing_token_token_collection_floorAskPrice2 = _listing_token_token_collection5.floorAskPrice) === null || _listing_token_token_collection_floorAskPrice2 === void 0 ? void 0 : (_listing_token_token_collection_floorAskPrice_amount2 = _listing_token_token_collection_floorAskPrice2.amount) === null || _listing_token_token_collection_floorAskPrice_amount2 === void 0 ? void 0 : _listing_token_token_collection_floorAskPrice_amount2.native, " ").concat(defaultCurrency.symbol)
                                        }) : null
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                    direction: "column",
                                    align: "center",
                                    css: {
                                        gap: "$2"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Button */.zx, {
                                            color: "gray3",
                                            corners: "pill",
                                            size: "large",
                                            css: {
                                                minWidth: "max-content",
                                                minHeight: 48,
                                                py: 14
                                            },
                                            onClick: ()=>handlePriceChange(topTraitPrice.toString()),
                                            disabled: !topTraitPrice || topTraitPrice <= 0,
                                            children: "Top Trait"
                                        }),
                                        topTraitPrice && topTraitPrice > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Text */.xv, {
                                            style: "subtitle3",
                                            color: "subtle",
                                            children: [
                                                topTraitPrice,
                                                " ",
                                                defaultCurrency.symbol
                                            ]
                                        }) : null
                                    ]
                                })
                            ]
                        }) : null,
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                            align: "start",
                            css: {
                                gap: "$3"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                    align: "center",
                                    css: {
                                        mt: 12
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CryptoCurrencyIcon/* default */.Z, {
                                            address: currency.contract,
                                            css: {
                                                height: 18
                                            }
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                            style: "subtitle1",
                                            color: "subtle",
                                            css: {
                                                ml: "$1"
                                            },
                                            children: currency.symbol
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                    direction: "column",
                                    align: "center",
                                    css: {
                                        gap: "$2"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Input */.II, {
                                            placeholder: "Price",
                                            type: "number",
                                            value: price,
                                            onChange: (e)=>{
                                                handlePriceChange(e.target.value);
                                            },
                                            css: {
                                                width: 100,
                                                "@bp1500": {
                                                    width: 150
                                                }
                                            }
                                        }),
                                        price !== undefined && price !== "" && Number(price) !== 0 && Number(price) < MINIMUM_AMOUNT && /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Text */.xv, {
                                            style: "subtitle3",
                                            color: "error",
                                            children: [
                                                "Must exceed ",
                                                MINIMUM_AMOUNT
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* TableCell */.pj, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Select */.Ph, {
                    css: {
                        flex: 1,
                        width: "100%",
                        whiteSpace: "nowrap"
                    },
                    value: (expirationOption === null || expirationOption === void 0 ? void 0 : expirationOption.text) || "",
                    onValueChange: handleExpirationChange,
                    children: defaultExpirationOptions.map((option)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Select.Item */.Ph.Item, {
                            value: option.value,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Select.ItemText */.Ph.ItemText, {
                                css: {
                                    whiteSpace: "nowrap"
                                },
                                children: option.text
                            })
                        }, option.text))
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* TableCell */.pj, {
                css: {
                    minWidth: 0,
                    overflow: "hidden"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                    align: "center",
                    css: {
                        gap: "$2",
                        minWidth: 0,
                        width: "100%",
                        boxSizing: "border-box",
                        mt: "$3"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* FormatCryptoCurrency */.gv, {
                            amount: creatorRoyalties * Number(price),
                            logoHeight: 14,
                            textStyle: "body1",
                            css: {
                                width: "100%"
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Text */.xv, {
                            style: "body1",
                            color: "subtle",
                            ellipsify: true,
                            children: [
                                "(",
                                creatorRoyalties * 100,
                                ")%"
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* TableCell */.pj, {
                css: {
                    minWidth: 0,
                    overflow: "hidden"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                    align: "center",
                    css: {
                        gap: "$2",
                        mt: "$3"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* FormatCryptoCurrency */.gv, {
                            amount: marketplaceFee,
                            logoHeight: 14,
                            textStyle: "body1"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Text */.xv, {
                            style: "body1",
                            color: "subtle",
                            ellipsify: true,
                            children: [
                                "(",
                                marketplaceFeePercent || 0,
                                ")%"
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* TableCell */.pj, {
                css: {
                    minWidth: 0,
                    overflow: "hidden"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Flex */.kC, {
                    css: {
                        mt: "$3"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* FormatCryptoCurrency */.gv, {
                        amount: profit,
                        logoHeight: 14,
                        textStyle: "body1"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* TableCell */.pj, {
                css: {
                    marginLeft: "auto"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Button */.zx, {
                    color: "gray3",
                    size: "small",
                    css: {
                        justifyContent: "center",
                        width: "44px",
                        height: "44px"
                    },
                    onClick: ()=>{
                        var _listing_token_token, _listing_token_token1;
                        return removeListing("".concat((_listing_token_token = listing.token.token) === null || _listing_token_token === void 0 ? void 0 : _listing_token_token.contract, ":").concat((_listing_token_token1 = listing.token.token) === null || _listing_token_token1 === void 0 ? void 0 : _listing_token_token1.tokenId), listing.orderbook);
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                        icon: free_solid_svg_icons/* faTrash */.$aW
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./utils/wrappedContracts.ts
const wrappedContracts = {
    1: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
    5: "0xB4FBF271143F4FBf7B91A5ded31805e42b2208d6",
    10: "0x4200000000000000000000000000000000000006",
    137: "0x0d500b1d8e8ef31e21c99d1db9a6444d3adf1270",
    42161: "0x82af49447d8a07e3bd95bd0d56f35241523fbab1",
    999: "0x8a5027ea12f45a13deb6CB96A07913c6e192BE84",
    80001: "0x9c3C9283D3e44854697Cd22D3Faa240Cfb032889",
    84531: "0x4200000000000000000000000000000000000006",
    534353: "0xa1EA0B2354F5A344110af2b6AD68e75545009a03",
    7777777: "0x4200000000000000000000000000000000000006",
    11155111: "0x7b79995e5f793a07bc00c21412e50ecae098e7f9"
};
/* harmony default export */ var utils_wrappedContracts = (wrappedContracts);

// EXTERNAL MODULE: ./node_modules/@wagmi/chains/dist/index.mjs
var chains_dist = __webpack_require__(31407);
;// CONCATENATED MODULE: ./components/portfolio/BatchListings.tsx














const BatchListings_MINIMUM_AMOUNT = 0.000001;
const marketplaces = [
    {
        name: "Reservoir",
        imageUrl: "https://api.reservoir.tools/redirect/sources/reservoir/logo/v2",
        orderbook: "reservoir",
        orderKind: "seaport-v1.4"
    },
    {
        name: "OpenSea",
        imageUrl: "https://api.reservoir.tools/redirect/sources/opensea/logo/v2",
        orderbook: "opensea",
        orderKind: "seaport-v1.4"
    }
];
const BatchListings = (param)=>{
    let { selectedItems , setSelectedItems , setShowListingPage  } = param;
    const [listings, setListings] = (0,react.useState)([]);
    const [selectedMarketplaces, setSelectedMarketplaces] = (0,react.useState)([
        marketplaces[0]
    ]);
    const [globalPrice, setGlobalPrice] = (0,react.useState)("");
    const [globalExpirationOption, setGlobalExpirationOption] = (0,react.useState)(defaultExpirationOptions[5]);
    const [totalProfit, setTotalProfit] = (0,react.useState)(0);
    const [listButtonDisabled, setListButtonDisabled] = (0,react.useState)(true);
    const isLargeDevice = (0,react_responsive.useMediaQuery)({
        minWidth: 1400
    });
    const chain = (0,hooks/* useMarketplaceChain */.gw)();
    const chainCurrency = (0,hooks/* useChainCurrency */.D5)();
    const defaultCurrency = {
        contract: chainCurrency.address,
        symbol: chainCurrency.symbol
    };
    // CONFIGURABLE: Here you can configure which currencies you would like to support for batch listing
    let currencies = [
        {
            ...defaultCurrency
        },
        {
            contract: utils_wrappedContracts[chain.id],
            decimals: 18,
            symbol: "W".concat(defaultCurrency.symbol)
        }
    ];
    if (chain.id === chains_dist/* mainnet.id */.RJ.id) {
        currencies.push({
            contract: "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48",
            symbol: "USDC",
            decimals: 6,
            coinGeckoId: "usd-coin"
        });
    }
    const [currency, setCurrency] = (0,react.useState)(currencies && currencies[0] ? currencies[0] : defaultCurrency);
    const displayQuantity = (0,react.useCallback)(()=>{
        return listings.some((listing)=>{
            var _listing_token, _listing_token_token;
            return (listing === null || listing === void 0 ? void 0 : (_listing_token = listing.token) === null || _listing_token === void 0 ? void 0 : (_listing_token_token = _listing_token.token) === null || _listing_token_token === void 0 ? void 0 : _listing_token_token.kind) === "erc1155";
        });
    }, [
        listings
    ]);
    let gridTemplateColumns = displayQuantity() ? isLargeDevice ? "1.1fr .5fr 2.6fr .8fr repeat(2, .7fr) .5fr .3fr" : "1.3fr .6fr 1.6fr 1fr repeat(2, .9fr) .6fr .3fr" : isLargeDevice ? "1.1fr 2.7fr 1fr repeat(2, .7fr) .5fr .3fr" : "1.3fr 1.8fr 1.2fr repeat(2, .9fr) .6fr .3fr";
    const generateListings = (0,react.useCallback)(()=>{
        const listings = selectedItems.flatMap((item)=>{
            return selectedMarketplaces.map((marketplace)=>{
                const listing = {
                    token: item,
                    quantity: 1,
                    price: globalPrice || "0",
                    expirationOption: globalExpirationOption,
                    //@ts-ignore
                    orderbook: marketplace.orderbook,
                    //@ts-ignore
                    orderKind: marketplace.orderKind
                };
                return listing;
            });
        });
        return listings;
    }, [
        selectedItems,
        selectedMarketplaces
    ]);
    (0,react.useEffect)(()=>{
        setListings(generateListings());
    }, [
        selectedItems,
        selectedMarketplaces,
        generateListings
    ]);
    (0,react.useEffect)(()=>{
        const maxProfit = selectedItems.reduce((total, item)=>{
            var _item_token, _item_token1;
            const itemId = "".concat((_item_token = item.token) === null || _item_token === void 0 ? void 0 : _item_token.contract, ":").concat((_item_token1 = item.token) === null || _item_token1 === void 0 ? void 0 : _item_token1.tokenId);
            const itemListings = listings.filter((listing)=>{
                var _listing_token_token, _listing_token_token1;
                return "".concat((_listing_token_token = listing.token.token) === null || _listing_token_token === void 0 ? void 0 : _listing_token_token.contract, ":").concat((_listing_token_token1 = listing.token.token) === null || _listing_token_token1 === void 0 ? void 0 : _listing_token_token1.tokenId) === itemId;
            });
            const profits = itemListings.map((listing)=>{
                var _listing_token, _listing_token_token, _listing_token_token_collection;
                const listingCreatorRoyalties = Number(listing.price) * listing.quantity * ((listing === null || listing === void 0 ? void 0 : (_listing_token = listing.token) === null || _listing_token === void 0 ? void 0 : (_listing_token_token = _listing_token.token) === null || _listing_token_token === void 0 ? void 0 : (_listing_token_token_collection = _listing_token_token.collection) === null || _listing_token_token_collection === void 0 ? void 0 : _listing_token_token_collection.royaltiesBps) || 0) / 10000;
                const profit = Number(listing.price) * listing.quantity - (listing.marketplaceFee || 0) - listingCreatorRoyalties;
                return profit;
            });
            const highestProfit = Math.max(...profits);
            return total + highestProfit;
        }, 0);
        setTotalProfit(maxProfit);
    }, [
        listings,
        selectedMarketplaces,
        globalPrice
    ]);
    (0,react.useEffect)(()=>{
        const hasInvalidPrice = listings.some((listing)=>listing.price === undefined || listing.price === "" || Number(listing.price) < BatchListings_MINIMUM_AMOUNT);
        setListButtonDisabled(hasInvalidPrice);
    }, [
        listings
    ]);
    const removeMarketplaceListings = (0,react.useCallback)((orderbook)=>{
        let updatedListings = listings.filter((listing)=>listing.orderbook === orderbook);
        setListings(updatedListings);
    }, [
        listings
    ]);
    const addMarketplaceListings = (0,react.useCallback)((orderbook, orderKind)=>{
        setListings((prevListings)=>{
            const updatedListings = [
                ...prevListings
            ];
            selectedItems.forEach((item)=>{
                const existingListingIndex = updatedListings.findIndex((listing)=>listing.token === item && listing.orderbook === orderbook);
                if (existingListingIndex === -1) {
                    const newListing = {
                        token: item,
                        quantity: 1,
                        price: globalPrice || "0",
                        expirationOption: globalExpirationOption,
                        //@ts-ignore
                        orderbook: orderbook,
                        //@ts-ignore
                        orderKind: orderKind
                    };
                    updatedListings.push(newListing);
                }
            });
            return updatedListings;
        });
    }, [
        selectedItems,
        globalPrice,
        globalExpirationOption
    ]);
    const handleMarketplaceSelection = (0,react.useCallback)((marketplace)=>{
        const isSelected = selectedMarketplaces.some((selected)=>selected.orderbook === marketplace.orderbook);
        if (isSelected) {
            setSelectedMarketplaces((prevSelected)=>prevSelected.filter((selected)=>selected.orderbook !== marketplace.orderbook));
            removeMarketplaceListings(marketplace.orderbook);
        } else {
            setSelectedMarketplaces((prevSelected)=>[
                    ...prevSelected,
                    marketplace
                ]);
            addMarketplaceListings(marketplace.orderbook, marketplace.orderKind);
        }
    }, [
        selectedMarketplaces,
        addMarketplaceListings,
        removeMarketplaceListings
    ]);
    const updateListing = (0,react.useCallback)((updatedListing)=>{
        setListings((prevListings)=>{
            return prevListings.map((listing)=>{
                if (listing.token === updatedListing.token && listing.orderbook === updatedListing.orderbook) {
                    return updatedListing;
                }
                return listing;
            });
        });
    }, []);
    const applyFloorPrice = (0,react.useCallback)(()=>{
        setListings((prevListings)=>{
            return prevListings.map((listing)=>{
                var _listing_token_token, _listing_token_token_collection, _listing_token_token_collection_floorAskPrice, _listing_token_token_collection_floorAskPrice_amount;
                if ((_listing_token_token = listing.token.token) === null || _listing_token_token === void 0 ? void 0 : (_listing_token_token_collection = _listing_token_token.collection) === null || _listing_token_token_collection === void 0 ? void 0 : (_listing_token_token_collection_floorAskPrice = _listing_token_token_collection.floorAskPrice) === null || _listing_token_token_collection_floorAskPrice === void 0 ? void 0 : (_listing_token_token_collection_floorAskPrice_amount = _listing_token_token_collection_floorAskPrice.amount) === null || _listing_token_token_collection_floorAskPrice_amount === void 0 ? void 0 : _listing_token_token_collection_floorAskPrice_amount.native) {
                    var _listing_token_token1, _listing_token_token_collection1, _listing_token_token_collection_floorAskPrice1, _listing_token_token_collection_floorAskPrice_amount1;
                    return {
                        ...listing,
                        price: (_listing_token_token1 = listing.token.token) === null || _listing_token_token1 === void 0 ? void 0 : (_listing_token_token_collection1 = _listing_token_token1.collection) === null || _listing_token_token_collection1 === void 0 ? void 0 : (_listing_token_token_collection_floorAskPrice1 = _listing_token_token_collection1.floorAskPrice) === null || _listing_token_token_collection_floorAskPrice1 === void 0 ? void 0 : (_listing_token_token_collection_floorAskPrice_amount1 = _listing_token_token_collection_floorAskPrice1.amount) === null || _listing_token_token_collection_floorAskPrice_amount1 === void 0 ? void 0 : _listing_token_token_collection_floorAskPrice_amount1.native.toString()
                    };
                }
                return listing;
            });
        });
        setCurrency(defaultCurrency);
    }, [
        listings
    ]);
    const applyTopTraitPrice = (0,react.useCallback)(()=>{
        setListings((prevListings)=>{
            return prevListings.map((listing)=>{
                var _listing_token_token;
                if ((_listing_token_token = listing.token.token) === null || _listing_token_token === void 0 ? void 0 : _listing_token_token.attributes) {
                    var _attribute_floorAskPrice;
                    // Find the highest floor price
                    let topTraitPrice = Math.max(...listing.token.token.attributes.map((attribute)=>(_attribute_floorAskPrice = attribute.floorAskPrice) !== null && _attribute_floorAskPrice !== void 0 ? _attribute_floorAskPrice : 0));
                    if (topTraitPrice && topTraitPrice > 0) {
                        return {
                            ...listing,
                            price: topTraitPrice.toString()
                        };
                    }
                }
                return listing;
            });
        });
        setCurrency(defaultCurrency);
    }, [
        listings
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
        direction: "column",
        css: {
            gap: "$5",
            width: "100%"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                align: "center",
                css: {
                    gap: 24
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Button */.zx, {
                        color: "gray3",
                        size: "small",
                        css: {
                            justifyContent: "center",
                            width: "44px",
                            height: "44px"
                        },
                        onClick: ()=>setShowListingPage(false),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                            icon: free_solid_svg_icons/* faChevronLeft */.A35
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                        style: "h4",
                        children: "List for Sale"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                justify: "between",
                css: {
                    border: "1px solid $gray6",
                    borderRadius: 8,
                    p: 24
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                        direction: "column",
                        css: {
                            gap: "$3"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                style: "h6",
                                children: "Select Marketplaces"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Flex */.kC, {
                                align: "center",
                                css: {
                                    gap: "$3"
                                },
                                children: marketplaces.map((marketplace)=>{
                                    const isSelected = selectedMarketplaces.some((selected)=>selected.orderbook === marketplace.orderbook);
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                        align: "center",
                                        css: {
                                            border: isSelected ? "1px solid $primary7" : "1px solid $gray6",
                                            borderRadius: 8,
                                            gap: "$2",
                                            p: "$3",
                                            cursor: "pointer"
                                        },
                                        onClick: ()=>handleMarketplaceSelection(marketplace),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: marketplace.imageUrl,
                                                alt: marketplace.name,
                                                style: {
                                                    width: 32,
                                                    height: 32
                                                }
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                                style: "subtitle2",
                                                children: marketplace.name
                                            })
                                        ]
                                    }, marketplace.name);
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                        direction: "column",
                        css: {
                            gap: "$3"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                style: "h6",
                                children: "Apply to All"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                align: "center",
                                css: {
                                    gap: "$5"
                                },
                                children: [
                                    isLargeDevice ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                        align: "center",
                                        css: {
                                            gap: "$3"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Button */.zx, {
                                                color: "gray3",
                                                corners: "pill",
                                                size: "large",
                                                css: {
                                                    minWidth: "max-content"
                                                },
                                                onClick: applyFloorPrice,
                                                children: "Floor"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Button */.zx, {
                                                color: "gray3",
                                                corners: "pill",
                                                size: "large",
                                                css: {
                                                    minWidth: "max-content"
                                                },
                                                onClick: applyTopTraitPrice,
                                                children: "Top Trait"
                                            })
                                        ]
                                    }) : null,
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                        align: "center",
                                        css: {
                                            gap: "$3"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Select */.Ph, {
                                                trigger: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Select.Trigger */.Ph.Trigger, {
                                                    css: {
                                                        width: 130
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Select.Value */.Ph.Value, {
                                                        asChild: true,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                                            align: "center",
                                                            justify: "center",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CryptoCurrencyIcon/* default */.Z, {
                                                                    address: currency.contract,
                                                                    css: {
                                                                        height: 18
                                                                    }
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                                                    style: "subtitle1",
                                                                    color: "subtle",
                                                                    css: {
                                                                        ml: "$1"
                                                                    },
                                                                    children: currency.symbol
                                                                }),
                                                                currencies && (currencies === null || currencies === void 0 ? void 0 : currencies.length) > 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Select.DownIcon */.Ph.DownIcon, {
                                                                    style: {
                                                                        marginLeft: 6
                                                                    }
                                                                }) : null
                                                            ]
                                                        })
                                                    })
                                                }),
                                                value: currency.contract,
                                                onValueChange: (value)=>{
                                                    const option = currencies === null || currencies === void 0 ? void 0 : currencies.find((option)=>option.contract == value);
                                                    if (option) {
                                                        setCurrency(option);
                                                    }
                                                },
                                                children: currencies === null || currencies === void 0 ? void 0 : currencies.map((option)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Select.Item */.Ph.Item, {
                                                        value: option.contract,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Select.ItemText */.Ph.ItemText, {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                                                align: "center",
                                                                css: {
                                                                    gap: "$1"
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CryptoCurrencyIcon/* default */.Z, {
                                                                        address: option.contract,
                                                                        css: {
                                                                            height: 18
                                                                        }
                                                                    }),
                                                                    option.symbol
                                                                ]
                                                            })
                                                        })
                                                    }, option.contract))
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Input */.II, {
                                                placeholder: "Set Price for All",
                                                type: "number",
                                                value: globalPrice,
                                                onChange: (e)=>{
                                                    setGlobalPrice(e.target.value);
                                                }
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Flex */.kC, {
                                        align: "center",
                                        css: {
                                            gap: "$3"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Select */.Ph, {
                                            css: {
                                                flex: 1,
                                                width: 200
                                            },
                                            value: (globalExpirationOption === null || globalExpirationOption === void 0 ? void 0 : globalExpirationOption.text) || "",
                                            onValueChange: (value)=>{
                                                const option = defaultExpirationOptions.find((option)=>option.value == value);
                                                if (option) {
                                                    setGlobalExpirationOption(option);
                                                }
                                            },
                                            children: defaultExpirationOptions.map((option)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Select.Item */.Ph.Item, {
                                                    value: option.value,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Select.ItemText */.Ph.ItemText, {
                                                        children: option.text
                                                    })
                                                }, option.text))
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            listings.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                direction: "column",
                css: {
                    width: "100%",
                    pb: 37
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BatchListingsTableHeading, {
                        displayQuantity: displayQuantity(),
                        gridTemplateColumns: gridTemplateColumns
                    }),
                    listings.map((listing, i)=>{
                        var _listing_token_token, _listing_token_token_collection, _listing_token_token1;
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(BatchListingsTableRow, {
                            listing: listing,
                            listings: listings,
                            setListings: setListings,
                            updateListing: updateListing,
                            setSelectedItems: setSelectedItems,
                            selectedItems: selectedItems,
                            displayQuantity: displayQuantity(),
                            gridTemplateColumns: gridTemplateColumns,
                            isLargeDevice: isLargeDevice,
                            globalExpirationOption: globalExpirationOption,
                            globalPrice: globalPrice,
                            currency: currency,
                            defaultCurrency: defaultCurrency,
                            selectedMarketplaces: selectedMarketplaces
                        }, "".concat((_listing_token_token = listing.token.token) === null || _listing_token_token === void 0 ? void 0 : (_listing_token_token_collection = _listing_token_token.collection) === null || _listing_token_token_collection === void 0 ? void 0 : _listing_token_token_collection.id, ":").concat((_listing_token_token1 = listing.token.token) === null || _listing_token_token1 === void 0 ? void 0 : _listing_token_token1.tokenId, ":").concat(listing.orderbook));
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Flex */.kC, {
                        align: "center",
                        justify: "between",
                        css: {
                            position: "fixed",
                            bottom: 0,
                            left: 0,
                            right: 0,
                            px: "$5",
                            py: "$4",
                            borderTop: "1px solid $gray7",
                            backgroundColor: "$neutralBg"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                            align: "center",
                            css: {
                                gap: 24,
                                marginLeft: "auto"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                    style: "body1",
                                    children: "Max Profit"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* FormatCryptoCurrency */.gv, {
                                    amount: totalProfit,
                                    logoHeight: 18,
                                    textStyle: "h6",
                                    css: {
                                        width: "max-content"
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(portfolio_BatchListModal, {
                                    listings: listings,
                                    disabled: listButtonDisabled,
                                    currency: currency,
                                    selectedMarketplaces: selectedMarketplaces,
                                    onCloseComplete: ()=>{
                                        setShowListingPage(false);
                                        setSelectedItems([]);
                                        setListings([]);
                                    }
                                })
                            ]
                        })
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                direction: "column",
                align: "center",
                css: {
                    py: "$6",
                    gap: "$4",
                    width: "100%"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                        css: {
                            color: "$gray11"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                            icon: free_solid_svg_icons/* faMagnifyingGlass */.Y$T,
                            size: "2xl"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                        css: {
                            color: "$gray11"
                        },
                        children: "No items selected"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var portfolio_BatchListings = (BatchListings);

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./components/buttons/CancelListing.tsx
var CancelListing = __webpack_require__(41456);
// EXTERNAL MODULE: ./context/ChainContextProvider.tsx
var ChainContextProvider = __webpack_require__(43810);
// EXTERNAL MODULE: ./components/primitives/Img.tsx
var primitives_Img = __webpack_require__(68916);
// EXTERNAL MODULE: ./components/buttons/index.ts + 3 modules
var buttons = __webpack_require__(52158);
;// CONCATENATED MODULE: ./components/portfolio/ListingsTable.tsx

















const desktopTemplateColumns = "1.25fr .75fr repeat(3, 1fr)";
const ListingsTable = (param)=>{
    let { address , isOwner  } = param;
    const loadMoreRef = (0,react.useRef)(null);
    const loadMoreObserver = (0,esm/* useIntersectionObserver */.S1)(loadMoreRef, {});
    let listingsQuery = {
        maker: address,
        includeCriteriaMetadata: true,
        includeRawData: true
    };
    const { chain  } = (0,react.useContext)(ChainContextProvider/* ChainContext */.p);
    if (chain.community) listingsQuery.community = chain.community;
    const { data: listings , mutate , fetchNextPage , isFetchingPage , isValidating  } = (0,dist_index_module/* useListings */.Jn)(listingsQuery);
    (0,react.useEffect)(()=>{
        const isVisible = !!(loadMoreObserver === null || loadMoreObserver === void 0 ? void 0 : loadMoreObserver.isIntersecting);
        if (isVisible) {
            fetchNextPage();
        }
    }, [
        loadMoreObserver === null || loadMoreObserver === void 0 ? void 0 : loadMoreObserver.isIntersecting
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            !isValidating && !isFetchingPage && listings && listings.length === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                direction: "column",
                align: "center",
                css: {
                    py: "$6",
                    gap: "$4",
                    width: "100%"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                        css: {
                            color: "$gray11"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                            icon: free_solid_svg_icons/* faTag */.LEN,
                            size: "2xl"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                        css: {
                            color: "$gray11"
                        },
                        children: "No listings yet"
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                direction: "column",
                css: {
                    width: "100%",
                    pb: "$2"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TableHeading, {}),
                    listings.map((listing, i)=>{
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ListingTableRow, {
                            listing: listing,
                            isOwner: isOwner,
                            mutate: mutate
                        }, "".concat(listing === null || listing === void 0 ? void 0 : listing.id, "-").concat(i));
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Box */.xu, {
                        ref: loadMoreRef,
                        css: {
                            height: 20
                        }
                    })
                ]
            }),
            isValidating && /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Flex */.kC, {
                align: "center",
                justify: "center",
                css: {
                    py: "$5"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingSpinner/* default */.Z, {})
            })
        ]
    });
};
const ListingTableRow = (param)=>{
    let { listing , isOwner , mutate  } = param;
    var _listing_criteria, _criteriaData_token, _criteriaData_token1, _criteriaData_collection, _criteriaData_token2, _criteriaData_token3, _criteriaData_collection1, _criteriaData_token4, _listing_price, _listing_price_amount, _listing_price1, _listing_price_currency, _listing_source, _listing_source1, _listing_source2, _listing_source3, _listing_criteria1, _listing_criteria_data, _listing_criteria_data_token, _listing_criteria2, _listing_criteria_data1, _listing_criteria_data_collection;
    const isSmallDevice = (0,react_responsive.useMediaQuery)({
        maxWidth: 900
    });
    const { routePrefix  } = (0,hooks/* useMarketplaceChain */.gw)();
    const expiration = (0,hooks/* useTimeSince */.vS)(listing === null || listing === void 0 ? void 0 : listing.expiration);
    const isOracleOrder = listing === null || listing === void 0 ? void 0 : listing.isNativeOffChainCancellable;
    let criteriaData = listing === null || listing === void 0 ? void 0 : (_listing_criteria = listing.criteria) === null || _listing_criteria === void 0 ? void 0 : _listing_criteria.data;
    const imageSrc = (0,react.useMemo)(()=>{
        var _criteriaData_token, _criteriaData_token1, _criteriaData_collection, _criteriaData_collection1;
        return (0,optimizeImage/* default */.Z)((criteriaData === null || criteriaData === void 0 ? void 0 : (_criteriaData_token = criteriaData.token) === null || _criteriaData_token === void 0 ? void 0 : _criteriaData_token.tokenId) ? (criteriaData === null || criteriaData === void 0 ? void 0 : (_criteriaData_token1 = criteriaData.token) === null || _criteriaData_token1 === void 0 ? void 0 : _criteriaData_token1.image) || (criteriaData === null || criteriaData === void 0 ? void 0 : (_criteriaData_collection = criteriaData.collection) === null || _criteriaData_collection === void 0 ? void 0 : _criteriaData_collection.image) : criteriaData === null || criteriaData === void 0 ? void 0 : (_criteriaData_collection1 = criteriaData.collection) === null || _criteriaData_collection1 === void 0 ? void 0 : _criteriaData_collection1.image, 250);
    }, [
        criteriaData === null || criteriaData === void 0 ? void 0 : (_criteriaData_token = criteriaData.token) === null || _criteriaData_token === void 0 ? void 0 : _criteriaData_token.tokenId,
        criteriaData === null || criteriaData === void 0 ? void 0 : (_criteriaData_token1 = criteriaData.token) === null || _criteriaData_token1 === void 0 ? void 0 : _criteriaData_token1.image,
        criteriaData === null || criteriaData === void 0 ? void 0 : (_criteriaData_collection = criteriaData.collection) === null || _criteriaData_collection === void 0 ? void 0 : _criteriaData_collection.image
    ]);
    if (isSmallDevice) {
        var _criteriaData_token5, _criteriaData_collection2, _criteriaData_token6, _listing_price2, _listing_price_amount1, _listing_price3, _listing_price_currency1, _listing_source4, _listing_source5, _listing_source6, _listing_criteria3, _listing_criteria_data2, _listing_criteria_data_token1, _listing_criteria4, _listing_criteria_data3, _listing_criteria_data_collection1;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
            direction: "column",
            align: "start",
            css: {
                gap: "$3",
                borderBottom: "1px solid $gray3",
                py: "$3",
                width: "100%",
                overflow: "hidden",
                flex: 1
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                    justify: "between",
                    css: {
                        width: "100%"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/".concat(routePrefix, "/asset/").concat(listing === null || listing === void 0 ? void 0 : listing.contract, ":").concat(criteriaData === null || criteriaData === void 0 ? void 0 : (_criteriaData_token5 = criteriaData.token) === null || _criteriaData_token5 === void 0 ? void 0 : _criteriaData_token5.tokenId),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                align: "center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives_Img/* default */.Z, {
                                        css: {
                                            borderRadius: "4px",
                                            objectFit: "cover",
                                            aspectRatio: "1/1"
                                        },
                                        loader: (param)=>{
                                            let { src  } = param;
                                            return src;
                                        },
                                        src: imageSrc,
                                        alt: "".concat(listing === null || listing === void 0 ? void 0 : listing.id),
                                        width: 36,
                                        height: 36
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                        direction: "column",
                                        css: {
                                            ml: "$2",
                                            overflow: "hidden",
                                            minWidth: 0
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                                style: "subtitle3",
                                                ellipsify: true,
                                                css: {
                                                    color: "$gray11"
                                                },
                                                children: criteriaData === null || criteriaData === void 0 ? void 0 : (_criteriaData_collection2 = criteriaData.collection) === null || _criteriaData_collection2 === void 0 ? void 0 : _criteriaData_collection2.name
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Text */.xv, {
                                                style: "subtitle2",
                                                ellipsify: true,
                                                children: [
                                                    "#",
                                                    criteriaData === null || criteriaData === void 0 ? void 0 : (_criteriaData_token6 = criteriaData.token) === null || _criteriaData_token6 === void 0 ? void 0 : _criteriaData_token6.tokenId
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* FormatCryptoCurrency */.gv, {
                            amount: listing === null || listing === void 0 ? void 0 : (_listing_price2 = listing.price) === null || _listing_price2 === void 0 ? void 0 : (_listing_price_amount1 = _listing_price2.amount) === null || _listing_price_amount1 === void 0 ? void 0 : _listing_price_amount1.decimal,
                            address: listing === null || listing === void 0 ? void 0 : (_listing_price3 = listing.price) === null || _listing_price3 === void 0 ? void 0 : (_listing_price_currency1 = _listing_price3.currency) === null || _listing_price_currency1 === void 0 ? void 0 : _listing_price_currency1.contract,
                            textStyle: "subtitle2",
                            logoHeight: 14
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                    justify: "between",
                    align: "center",
                    css: {
                        width: "100%"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: "https://".concat(listing === null || listing === void 0 ? void 0 : (_listing_source4 = listing.source) === null || _listing_source4 === void 0 ? void 0 : _listing_source4.domain),
                            target: "_blank",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                align: "center",
                                css: {
                                    gap: "$2"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        width: "20px",
                                        height: "20px",
                                        src: (listing === null || listing === void 0 ? void 0 : (_listing_source5 = listing.source) === null || _listing_source5 === void 0 ? void 0 : _listing_source5.icon) || "",
                                        alt: "".concat(listing === null || listing === void 0 ? void 0 : (_listing_source6 = listing.source) === null || _listing_source6 === void 0 ? void 0 : _listing_source6.name)
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                        style: "subtitle2",
                                        children: expiration
                                    })
                                ]
                            })
                        }),
                        isOwner ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CancelListing/* default */.Z, {
                            listingId: listing === null || listing === void 0 ? void 0 : listing.id,
                            mutate: mutate,
                            trigger: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Flex */.kC, {
                                children: !isOracleOrder ? /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Tooltip */.u, {
                                    content: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                        style: "body3",
                                        as: "p",
                                        children: "Cancelling this order requires gas."
                                    }),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Button */.zx, {
                                        css: {
                                            color: "$red11",
                                            minWidth: "150px",
                                            justifyContent: "center"
                                        },
                                        color: "gray3",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                color: "#697177",
                                                icon: free_solid_svg_icons/* faGasPump */.q16,
                                                width: "16",
                                                height: "16"
                                            }),
                                            "Cancel"
                                        ]
                                    })
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Button */.zx, {
                                    css: {
                                        color: "$red11",
                                        minWidth: "150px",
                                        justifyContent: "center"
                                    },
                                    color: "gray3",
                                    children: "Cancel"
                                })
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(buttons/* BuyNow */.Wg, {
                            tokenId: listing === null || listing === void 0 ? void 0 : (_listing_criteria3 = listing.criteria) === null || _listing_criteria3 === void 0 ? void 0 : (_listing_criteria_data2 = _listing_criteria3.data) === null || _listing_criteria_data2 === void 0 ? void 0 : (_listing_criteria_data_token1 = _listing_criteria_data2.token) === null || _listing_criteria_data_token1 === void 0 ? void 0 : _listing_criteria_data_token1.tokenId,
                            collectionId: listing === null || listing === void 0 ? void 0 : (_listing_criteria4 = listing.criteria) === null || _listing_criteria4 === void 0 ? void 0 : (_listing_criteria_data3 = _listing_criteria4.data) === null || _listing_criteria_data3 === void 0 ? void 0 : (_listing_criteria_data_collection1 = _listing_criteria_data3.collection) === null || _listing_criteria_data_collection1 === void 0 ? void 0 : _listing_criteria_data_collection1.id,
                            orderId: listing === null || listing === void 0 ? void 0 : listing.id,
                            mutate: mutate,
                            buttonCss: {
                                minWidth: "150px",
                                justifyContent: "center"
                            },
                            buttonChildren: "Buy Now"
                        })
                    ]
                })
            ]
        }, listing === null || listing === void 0 ? void 0 : listing.id);
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* TableRow */.SC, {
        css: {
            gridTemplateColumns: desktopTemplateColumns
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* TableCell */.pj, {
                css: {
                    minWidth: 0
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: "/".concat(routePrefix, "/asset/").concat(listing === null || listing === void 0 ? void 0 : listing.contract, ":").concat(criteriaData === null || criteriaData === void 0 ? void 0 : (_criteriaData_token2 = criteriaData.token) === null || _criteriaData_token2 === void 0 ? void 0 : _criteriaData_token2.tokenId),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                        align: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives_Img/* default */.Z, {
                                css: {
                                    borderRadius: "4px",
                                    objectFit: "cover",
                                    aspectRatio: "1/1"
                                },
                                loader: (param)=>{
                                    let { src  } = param;
                                    return src;
                                },
                                src: imageSrc,
                                alt: "".concat(criteriaData === null || criteriaData === void 0 ? void 0 : (_criteriaData_token3 = criteriaData.token) === null || _criteriaData_token3 === void 0 ? void 0 : _criteriaData_token3.name),
                                width: 48,
                                height: 48
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                direction: "column",
                                css: {
                                    ml: "$2",
                                    overflow: "hidden"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                        style: "subtitle3",
                                        ellipsify: true,
                                        css: {
                                            color: "$gray11"
                                        },
                                        children: criteriaData === null || criteriaData === void 0 ? void 0 : (_criteriaData_collection1 = criteriaData.collection) === null || _criteriaData_collection1 === void 0 ? void 0 : _criteriaData_collection1.name
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Text */.xv, {
                                        style: "subtitle2",
                                        ellipsify: true,
                                        children: [
                                            "#",
                                            criteriaData === null || criteriaData === void 0 ? void 0 : (_criteriaData_token4 = criteriaData.token) === null || _criteriaData_token4 === void 0 ? void 0 : _criteriaData_token4.tokenId
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* TableCell */.pj, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* FormatCryptoCurrency */.gv, {
                    amount: listing === null || listing === void 0 ? void 0 : (_listing_price = listing.price) === null || _listing_price === void 0 ? void 0 : (_listing_price_amount = _listing_price.amount) === null || _listing_price_amount === void 0 ? void 0 : _listing_price_amount.decimal,
                    address: listing === null || listing === void 0 ? void 0 : (_listing_price1 = listing.price) === null || _listing_price1 === void 0 ? void 0 : (_listing_price_currency = _listing_price1.currency) === null || _listing_price_currency === void 0 ? void 0 : _listing_price_currency.contract,
                    textStyle: "subtitle2",
                    logoHeight: 14
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* TableCell */.pj, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                    style: "subtitle2",
                    children: expiration
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* TableCell */.pj, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                    align: "center",
                    css: {
                        gap: "$2"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            width: "20px",
                            height: "20px",
                            src: (listing === null || listing === void 0 ? void 0 : (_listing_source = listing.source) === null || _listing_source === void 0 ? void 0 : _listing_source.icon) || "",
                            alt: "".concat(listing === null || listing === void 0 ? void 0 : (_listing_source1 = listing.source) === null || _listing_source1 === void 0 ? void 0 : _listing_source1.name)
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Anchor */.ee, {
                            href: "https://".concat(listing === null || listing === void 0 ? void 0 : (_listing_source2 = listing.source) === null || _listing_source2 === void 0 ? void 0 : _listing_source2.domain),
                            target: "_blank",
                            color: "primary",
                            weight: "normal",
                            children: listing === null || listing === void 0 ? void 0 : (_listing_source3 = listing.source) === null || _listing_source3 === void 0 ? void 0 : _listing_source3.name
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* TableCell */.pj, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Flex */.kC, {
                    justify: "end",
                    children: isOwner ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CancelListing/* default */.Z, {
                        listingId: listing === null || listing === void 0 ? void 0 : listing.id,
                        mutate: mutate,
                        trigger: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Flex */.kC, {
                            children: !isOracleOrder ? /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Tooltip */.u, {
                                content: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                    style: "body3",
                                    as: "p",
                                    children: "Cancelling this order requires gas."
                                }),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Button */.zx, {
                                    css: {
                                        color: "$red11",
                                        minWidth: "150px",
                                        justifyContent: "center"
                                    },
                                    color: "gray3",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                            color: "#697177",
                                            icon: free_solid_svg_icons/* faGasPump */.q16,
                                            width: "16",
                                            height: "16"
                                        }),
                                        "Cancel"
                                    ]
                                })
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Button */.zx, {
                                css: {
                                    color: "$red11",
                                    minWidth: "150px",
                                    justifyContent: "center"
                                },
                                color: "gray3",
                                children: "Cancel"
                            })
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(buttons/* BuyNow */.Wg, {
                        tokenId: listing === null || listing === void 0 ? void 0 : (_listing_criteria1 = listing.criteria) === null || _listing_criteria1 === void 0 ? void 0 : (_listing_criteria_data = _listing_criteria1.data) === null || _listing_criteria_data === void 0 ? void 0 : (_listing_criteria_data_token = _listing_criteria_data.token) === null || _listing_criteria_data_token === void 0 ? void 0 : _listing_criteria_data_token.tokenId,
                        collectionId: listing === null || listing === void 0 ? void 0 : (_listing_criteria2 = listing.criteria) === null || _listing_criteria2 === void 0 ? void 0 : (_listing_criteria_data1 = _listing_criteria2.data) === null || _listing_criteria_data1 === void 0 ? void 0 : (_listing_criteria_data_collection = _listing_criteria_data1.collection) === null || _listing_criteria_data_collection === void 0 ? void 0 : _listing_criteria_data_collection.id,
                        orderId: listing === null || listing === void 0 ? void 0 : listing.id,
                        mutate: mutate,
                        buttonCss: {
                            minWidth: "150px",
                            justifyContent: "center"
                        },
                        buttonChildren: "Buy Now"
                    })
                })
            })
        ]
    }, listing === null || listing === void 0 ? void 0 : listing.id);
};
const headings = [
    "Items",
    "Listed Price",
    "Expiration",
    "Marketplace",
    ""
];
const TableHeading = ()=>/*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* HeaderRow */.VJ, {
        css: {
            display: "none",
            "@md": {
                display: "grid"
            },
            gridTemplateColumns: desktopTemplateColumns,
            position: "sticky",
            top: navbar/* NAVBAR_HEIGHT */.ik,
            backgroundColor: "$neutralBg"
        },
        children: headings.map((heading)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* TableCell */.pj, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                    style: "subtitle3",
                    color: "subtle",
                    children: heading
                })
            }, heading))
    });

// EXTERNAL MODULE: ./components/buttons/CancelBid.tsx
var CancelBid = __webpack_require__(61818);
;// CONCATENATED MODULE: ./components/portfolio/OffersTable.tsx
















const OffersTable_desktopTemplateColumns = "1.25fr .75fr repeat(3, 1fr)";
const OffersTable = (param)=>{
    let { address , isOwner  } = param;
    const loadMoreRef = (0,react.useRef)(null);
    const loadMoreObserver = (0,esm/* useIntersectionObserver */.S1)(loadMoreRef, {});
    let bidsQuery = {
        maker: address,
        includeCriteriaMetadata: true,
        includeRawData: true
    };
    const { chain  } = (0,react.useContext)(ChainContextProvider/* ChainContext */.p);
    if (chain.community) bidsQuery.community = chain.community;
    const { data: offers , fetchNextPage , mutate , isValidating , isFetchingPage  } = (0,dist_index_module/* useBids */.Lk)(bidsQuery);
    (0,react.useEffect)(()=>{
        const isVisible = !!(loadMoreObserver === null || loadMoreObserver === void 0 ? void 0 : loadMoreObserver.isIntersecting);
        if (isVisible) {
            fetchNextPage();
        }
    }, [
        loadMoreObserver === null || loadMoreObserver === void 0 ? void 0 : loadMoreObserver.isIntersecting
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            !isValidating && !isFetchingPage && offers && offers.length === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                direction: "column",
                align: "center",
                css: {
                    py: "$6",
                    gap: "$4",
                    width: "100%"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                        css: {
                            color: "$gray11"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                            icon: free_solid_svg_icons/* faHand */.ioV,
                            size: "2xl"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                        css: {
                            color: "$gray11"
                        },
                        children: "No offers made yet"
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                direction: "column",
                css: {
                    width: "100%",
                    pb: "$2"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(OffersTable_TableHeading, {}),
                    offers.map((offer, i)=>{
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(OfferTableRow, {
                            offer: offer,
                            isOwner: isOwner,
                            mutate: mutate
                        }, "".concat(offer === null || offer === void 0 ? void 0 : offer.id, "-").concat(i));
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Box */.xu, {
                        ref: loadMoreRef,
                        css: {
                            height: 20
                        }
                    })
                ]
            }),
            isValidating && /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Flex */.kC, {
                align: "center",
                justify: "center",
                css: {
                    py: "$5"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingSpinner/* default */.Z, {})
            })
        ]
    });
};
const OfferTableRow = (param)=>{
    let { offer , isOwner , mutate  } = param;
    var _offer_criteria, _offer_criteria1, _offer_criteria_data, _offer_criteria2, _criteriaData_token, _criteriaData_token1, _criteriaData_collection, _criteriaData_token2, _criteriaData_token3, _criteriaData_collection1, _criteriaData_token4, _offer_price, _offer_price_amount, _offer_price1, _offer_price_currency, _offer_source, _offer_source1, _offer_source2, _offer_source3;
    const isSmallDevice = (0,react_responsive.useMediaQuery)({
        maxWidth: 900
    });
    const { routePrefix  } = (0,hooks/* useMarketplaceChain */.gw)();
    const expiration = (0,hooks/* useTimeSince */.vS)(offer === null || offer === void 0 ? void 0 : offer.expiration);
    const isOracleOrder = offer === null || offer === void 0 ? void 0 : offer.isNativeOffChainCancellable;
    const isCollectionOffer = (offer === null || offer === void 0 ? void 0 : (_offer_criteria = offer.criteria) === null || _offer_criteria === void 0 ? void 0 : _offer_criteria.kind) !== "token";
    // @ts-ignore
    const attribute = offer === null || offer === void 0 ? void 0 : (_offer_criteria1 = offer.criteria) === null || _offer_criteria1 === void 0 ? void 0 : (_offer_criteria_data = _offer_criteria1.data) === null || _offer_criteria_data === void 0 ? void 0 : _offer_criteria_data.attribute;
    const attributeQueryParam = attribute ? "?attributes[".concat(attribute.key, "]=").concat(attribute.value) : "";
    const attributeDisplayText = attribute ? "".concat(attribute === null || attribute === void 0 ? void 0 : attribute.key, ": ").concat(attribute === null || attribute === void 0 ? void 0 : attribute.value) : "";
    let criteriaData = offer === null || offer === void 0 ? void 0 : (_offer_criteria2 = offer.criteria) === null || _offer_criteria2 === void 0 ? void 0 : _offer_criteria2.data;
    const imageSrc = (0,react.useMemo)(()=>{
        var _criteriaData_token, _criteriaData_token1, _criteriaData_collection, _criteriaData_collection1;
        return (0,optimizeImage/* default */.Z)((criteriaData === null || criteriaData === void 0 ? void 0 : (_criteriaData_token = criteriaData.token) === null || _criteriaData_token === void 0 ? void 0 : _criteriaData_token.tokenId) ? (criteriaData === null || criteriaData === void 0 ? void 0 : (_criteriaData_token1 = criteriaData.token) === null || _criteriaData_token1 === void 0 ? void 0 : _criteriaData_token1.image) || (criteriaData === null || criteriaData === void 0 ? void 0 : (_criteriaData_collection = criteriaData.collection) === null || _criteriaData_collection === void 0 ? void 0 : _criteriaData_collection.image) : criteriaData === null || criteriaData === void 0 ? void 0 : (_criteriaData_collection1 = criteriaData.collection) === null || _criteriaData_collection1 === void 0 ? void 0 : _criteriaData_collection1.image, 250);
    }, [
        criteriaData === null || criteriaData === void 0 ? void 0 : (_criteriaData_token = criteriaData.token) === null || _criteriaData_token === void 0 ? void 0 : _criteriaData_token.tokenId,
        criteriaData === null || criteriaData === void 0 ? void 0 : (_criteriaData_token1 = criteriaData.token) === null || _criteriaData_token1 === void 0 ? void 0 : _criteriaData_token1.image,
        criteriaData === null || criteriaData === void 0 ? void 0 : (_criteriaData_collection = criteriaData.collection) === null || _criteriaData_collection === void 0 ? void 0 : _criteriaData_collection.image
    ]);
    if (isSmallDevice) {
        var _criteriaData_token5, _criteriaData_collection2, _criteriaData_token6, _offer_price2, _offer_price_amount1, _offer_price3, _offer_price_currency1, _offer_source4, _offer_source5, _offer_source6;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
            direction: "column",
            align: "start",
            css: {
                gap: "$3",
                borderBottom: "1px solid $gray3",
                py: "$3",
                width: "100%",
                overflow: "hidden",
                flex: 1
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                    justify: "between",
                    css: {
                        width: "100%"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: isCollectionOffer ? "/".concat(routePrefix, "/collection/").concat(offer === null || offer === void 0 ? void 0 : offer.contract).concat(attributeQueryParam) : "/".concat(routePrefix, "/asset/").concat(offer === null || offer === void 0 ? void 0 : offer.contract, ":").concat(criteriaData === null || criteriaData === void 0 ? void 0 : (_criteriaData_token5 = criteriaData.token) === null || _criteriaData_token5 === void 0 ? void 0 : _criteriaData_token5.tokenId),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                align: "center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives_Img/* default */.Z, {
                                        css: {
                                            borderRadius: "4px",
                                            objectFit: "cover",
                                            aspectRatio: "1/1"
                                        },
                                        loader: (param)=>{
                                            let { src  } = param;
                                            return src;
                                        },
                                        src: imageSrc,
                                        alt: "".concat(offer === null || offer === void 0 ? void 0 : offer.id),
                                        width: 36,
                                        height: 36
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                        direction: "column",
                                        css: {
                                            ml: "$2",
                                            overflow: "hidden",
                                            minWidth: 0
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                                style: "subtitle3",
                                                ellipsify: true,
                                                css: {
                                                    color: "$gray11"
                                                },
                                                children: criteriaData === null || criteriaData === void 0 ? void 0 : (_criteriaData_collection2 = criteriaData.collection) === null || _criteriaData_collection2 === void 0 ? void 0 : _criteriaData_collection2.name
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                                style: "subtitle2",
                                                ellipsify: true,
                                                children: isCollectionOffer ? attributeDisplayText : "#".concat(criteriaData === null || criteriaData === void 0 ? void 0 : (_criteriaData_token6 = criteriaData.token) === null || _criteriaData_token6 === void 0 ? void 0 : _criteriaData_token6.tokenId)
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* FormatCryptoCurrency */.gv, {
                            amount: offer === null || offer === void 0 ? void 0 : (_offer_price2 = offer.price) === null || _offer_price2 === void 0 ? void 0 : (_offer_price_amount1 = _offer_price2.amount) === null || _offer_price_amount1 === void 0 ? void 0 : _offer_price_amount1.decimal,
                            address: offer === null || offer === void 0 ? void 0 : (_offer_price3 = offer.price) === null || _offer_price3 === void 0 ? void 0 : (_offer_price_currency1 = _offer_price3.currency) === null || _offer_price_currency1 === void 0 ? void 0 : _offer_price_currency1.contract,
                            textStyle: "subtitle2",
                            logoHeight: 14
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                    justify: "between",
                    align: "center",
                    css: {
                        width: "100%"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: "https://".concat(offer === null || offer === void 0 ? void 0 : (_offer_source4 = offer.source) === null || _offer_source4 === void 0 ? void 0 : _offer_source4.domain),
                            target: "_blank",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                align: "center",
                                css: {
                                    gap: "$2"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        width: "20px",
                                        height: "20px",
                                        src: (offer === null || offer === void 0 ? void 0 : (_offer_source5 = offer.source) === null || _offer_source5 === void 0 ? void 0 : _offer_source5.icon) || "",
                                        alt: "".concat(offer === null || offer === void 0 ? void 0 : (_offer_source6 = offer.source) === null || _offer_source6 === void 0 ? void 0 : _offer_source6.name)
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                        style: "subtitle2",
                                        children: expiration
                                    })
                                ]
                            })
                        }),
                        isOwner ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CancelBid/* default */.Z, {
                            bidId: offer === null || offer === void 0 ? void 0 : offer.id,
                            mutate: mutate,
                            trigger: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Flex */.kC, {
                                children: !isOracleOrder ? /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Tooltip */.u, {
                                    content: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                        style: "body3",
                                        as: "p",
                                        children: "Cancelling this order requires gas."
                                    }),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Button */.zx, {
                                        css: {
                                            color: "$red11",
                                            minWidth: "150px",
                                            justifyContent: "center"
                                        },
                                        color: "gray3",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                color: "#697177",
                                                icon: free_solid_svg_icons/* faGasPump */.q16,
                                                width: "16",
                                                height: "16"
                                            }),
                                            "Cancel"
                                        ]
                                    })
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Button */.zx, {
                                    css: {
                                        color: "$red11",
                                        minWidth: "150px",
                                        justifyContent: "center"
                                    },
                                    color: "gray3",
                                    children: "Cancel"
                                })
                            })
                        }) : null
                    ]
                })
            ]
        }, offer === null || offer === void 0 ? void 0 : offer.id);
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* TableRow */.SC, {
        css: {
            gridTemplateColumns: OffersTable_desktopTemplateColumns
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* TableCell */.pj, {
                css: {
                    minWidth: 0
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: isCollectionOffer ? "/".concat(routePrefix, "/collection/").concat(offer === null || offer === void 0 ? void 0 : offer.contract).concat(attributeQueryParam) : "/".concat(routePrefix, "/asset/").concat(offer === null || offer === void 0 ? void 0 : offer.contract, ":").concat(criteriaData === null || criteriaData === void 0 ? void 0 : (_criteriaData_token2 = criteriaData.token) === null || _criteriaData_token2 === void 0 ? void 0 : _criteriaData_token2.tokenId),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                        align: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives_Img/* default */.Z, {
                                css: {
                                    borderRadius: "4px",
                                    objectFit: "cover",
                                    aspectRatio: "1/1"
                                },
                                loader: (param)=>{
                                    let { src  } = param;
                                    return src;
                                },
                                src: imageSrc,
                                alt: "".concat(criteriaData === null || criteriaData === void 0 ? void 0 : (_criteriaData_token3 = criteriaData.token) === null || _criteriaData_token3 === void 0 ? void 0 : _criteriaData_token3.name),
                                width: 48,
                                height: 48
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                direction: "column",
                                css: {
                                    ml: "$2",
                                    overflow: "hidden"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                        style: "subtitle3",
                                        ellipsify: true,
                                        css: {
                                            color: "$gray11"
                                        },
                                        children: criteriaData === null || criteriaData === void 0 ? void 0 : (_criteriaData_collection1 = criteriaData.collection) === null || _criteriaData_collection1 === void 0 ? void 0 : _criteriaData_collection1.name
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                        style: "subtitle2",
                                        ellipsify: true,
                                        children: isCollectionOffer ? attributeDisplayText : "#".concat(criteriaData === null || criteriaData === void 0 ? void 0 : (_criteriaData_token4 = criteriaData.token) === null || _criteriaData_token4 === void 0 ? void 0 : _criteriaData_token4.tokenId)
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* TableCell */.pj, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* FormatCryptoCurrency */.gv, {
                    amount: offer === null || offer === void 0 ? void 0 : (_offer_price = offer.price) === null || _offer_price === void 0 ? void 0 : (_offer_price_amount = _offer_price.amount) === null || _offer_price_amount === void 0 ? void 0 : _offer_price_amount.decimal,
                    address: offer === null || offer === void 0 ? void 0 : (_offer_price1 = offer.price) === null || _offer_price1 === void 0 ? void 0 : (_offer_price_currency = _offer_price1.currency) === null || _offer_price_currency === void 0 ? void 0 : _offer_price_currency.contract,
                    textStyle: "subtitle2",
                    logoHeight: 14
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* TableCell */.pj, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                    style: "subtitle2",
                    children: expiration
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* TableCell */.pj, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                    align: "center",
                    css: {
                        gap: "$2"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            width: "20px",
                            height: "20px",
                            src: (offer === null || offer === void 0 ? void 0 : (_offer_source = offer.source) === null || _offer_source === void 0 ? void 0 : _offer_source.icon) || "",
                            alt: "".concat(offer === null || offer === void 0 ? void 0 : (_offer_source1 = offer.source) === null || _offer_source1 === void 0 ? void 0 : _offer_source1.name)
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Anchor */.ee, {
                            href: "https://".concat(offer === null || offer === void 0 ? void 0 : (_offer_source2 = offer.source) === null || _offer_source2 === void 0 ? void 0 : _offer_source2.domain),
                            target: "_blank",
                            color: "primary",
                            weight: "normal",
                            children: offer === null || offer === void 0 ? void 0 : (_offer_source3 = offer.source) === null || _offer_source3 === void 0 ? void 0 : _offer_source3.name
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* TableCell */.pj, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Flex */.kC, {
                    justify: "end",
                    children: isOwner ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CancelBid/* default */.Z, {
                        bidId: offer === null || offer === void 0 ? void 0 : offer.id,
                        mutate: mutate,
                        trigger: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Flex */.kC, {
                            children: !isOracleOrder ? /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Tooltip */.u, {
                                content: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                    style: "body3",
                                    as: "p",
                                    children: "Cancelling this order requires gas."
                                }),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Button */.zx, {
                                    css: {
                                        color: "$red11",
                                        minWidth: "150px",
                                        justifyContent: "center"
                                    },
                                    color: "gray3",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                            color: "#697177",
                                            icon: free_solid_svg_icons/* faGasPump */.q16,
                                            width: "16",
                                            height: "16"
                                        }),
                                        "Cancel"
                                    ]
                                })
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Button */.zx, {
                                css: {
                                    color: "$red11",
                                    minWidth: "150px",
                                    justifyContent: "center"
                                },
                                color: "gray3",
                                children: "Cancel"
                            })
                        })
                    }) : null
                })
            })
        ]
    }, offer === null || offer === void 0 ? void 0 : offer.id);
};
const OffersTable_headings = [
    "Items",
    "Offer Amount",
    "Expiration",
    "Marketplace",
    ""
];
const OffersTable_TableHeading = ()=>/*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* HeaderRow */.VJ, {
        css: {
            display: "none",
            "@md": {
                display: "grid"
            },
            gridTemplateColumns: OffersTable_desktopTemplateColumns,
            position: "sticky",
            top: navbar/* NAVBAR_HEIGHT */.ik,
            backgroundColor: "$neutralBg"
        },
        children: OffersTable_headings.map((heading)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* TableCell */.pj, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                    style: "subtitle3",
                    color: "subtle",
                    children: heading
                })
            }, heading))
    });

// EXTERNAL MODULE: ./components/primitives/Checkbox.tsx + 3 modules
var Checkbox = __webpack_require__(92522);
// EXTERNAL MODULE: ./constants/index.ts
var constants = __webpack_require__(59843);
// EXTERNAL MODULE: ./utils/fetcher.ts
var fetcher = __webpack_require__(84205);
// EXTERNAL MODULE: ./utils/till.ts
var till = __webpack_require__(94830);
// EXTERNAL MODULE: ./components/buttons/BuyNow.tsx
var BuyNow = __webpack_require__(66918);
// EXTERNAL MODULE: ./components/buttons/List.tsx
var List = __webpack_require__(85534);
;// CONCATENATED MODULE: ./components/portfolio/PortfolioTokenCard.tsx





















/* harmony default export */ var PortfolioTokenCard = ((param)=>{
    let { token , address , isOwner , rarityEnabled =true , orderQuantity , tokenCount , selectedItems , setSelectedItems , mutate , onMediaPlayed  } = param;
    var _token_token, _token_token_collection, _token_ownership, _token_ownership_floorAsk, _token_ownership_floorAsk_rawData, _token_token1, _token_token_collection1, _token_token_collection_id, _token_token2, _token_token3, _token_token4, _token_token5, _token_token6, _token_token7, _token_token8, _token_token9, _token_token10, _token_token11, _token_token12, _token_ownership1, _token_ownership_floorAsk1, _token_ownership2, _token_ownership_floorAsk2, _token_ownership_floorAsk_price, _token_ownership_floorAsk_price_amount, _token_ownership3, _token_ownership_floorAsk3, _token_ownership_floorAsk_price1, _token_ownership_floorAsk_price_currency, _token_ownership4, _token_ownership_floorAsk4, _token_ownership_floorAsk_source, _token_ownership5, _token_ownership_floorAsk5, _token_ownership_floorAsk_source1, _token_token13, _token_token_lastSale, _token_token_lastSale_price, _token_token_lastSale_price_amount, _token_token_lastSale_price_amount1, _token_token_lastSale_price_currency, _token_token_lastSale_price_currency1, _token_ownership6, _token_ownership_floorAsk6, _token_ownership_floorAsk_price2, _token_token14, _token_token15, _token_token_collection2, _token_token16, _token_token_topBid, _token_token_topBid_price, _token_token_topBid_price_amount, _token_token17, _token_ownership7, _token_ownership_floorAsk7, _token_token18, _token_token19, _token_token_collection3, _token_ownership8, _token_ownership_floorAsk8, _token_token20, _token_token21, _token_token_collection4, _token_ownership9, _token_ownership_floorAsk9;
    const { addToast  } = (0,react.useContext)(ToastContextProvider/* ToastContext */.u);
    const [isRefreshing, setIsRefreshing] = (0,react.useState)(false);
    let dynamicToken = token;
    const isSmallDevice = (0,react_responsive.useMediaQuery)({
        maxWidth: 900
    });
    const mediaType = (0,dist_index_module/* extractMediaType */.uh)(dynamicToken === null || dynamicToken === void 0 ? void 0 : dynamicToken.token);
    const showPreview = mediaType === "other" || mediaType === "html" || mediaType === null;
    const { routePrefix , proxyApi  } = (0,hooks/* useMarketplaceChain */.gw)();
    const collectionImage = (0,react.useMemo)(()=>{
        var _token_token, _token_token_collection;
        return (0,optimizeImage/* default */.Z)(token === null || token === void 0 ? void 0 : (_token_token = token.token) === null || _token_token === void 0 ? void 0 : (_token_token_collection = _token_token.collection) === null || _token_token_collection === void 0 ? void 0 : _token_token_collection.imageUrl, 500);
    }, [
        token === null || token === void 0 ? void 0 : (_token_token = token.token) === null || _token_token === void 0 ? void 0 : (_token_token_collection = _token_token.collection) === null || _token_token_collection === void 0 ? void 0 : _token_token_collection.imageUrl
    ]);
    const isOracleOrder = token === null || token === void 0 ? void 0 : (_token_ownership = token.ownership) === null || _token_ownership === void 0 ? void 0 : (_token_ownership_floorAsk = _token_ownership.floorAsk) === null || _token_ownership_floorAsk === void 0 ? void 0 : (_token_ownership_floorAsk_rawData = _token_ownership_floorAsk.rawData) === null || _token_ownership_floorAsk_rawData === void 0 ? void 0 : _token_ownership_floorAsk_rawData.isNativeOffChainCancellable;
    const contract = ((_token_token1 = token.token) === null || _token_token1 === void 0 ? void 0 : (_token_token_collection1 = _token_token1.collection) === null || _token_token_collection1 === void 0 ? void 0 : _token_token_collection1.id) ? (_token_token_collection_id = (_token_token2 = token.token) === null || _token_token2 === void 0 ? void 0 : _token_token2.collection.id) === null || _token_token_collection_id === void 0 ? void 0 : _token_token_collection_id.split(":")[0] : undefined;
    const addSelectedItem = (item)=>{
        setSelectedItems([
            ...selectedItems,
            item
        ]);
    };
    const removeSelectedItem = (item)=>{
        setSelectedItems(selectedItems.filter((selectedItem)=>{
            var _selectedItem_token, _item_token, _selectedItem_token1, _item_token1;
            return (selectedItem === null || selectedItem === void 0 ? void 0 : (_selectedItem_token = selectedItem.token) === null || _selectedItem_token === void 0 ? void 0 : _selectedItem_token.tokenId) !== (item === null || item === void 0 ? void 0 : (_item_token = item.token) === null || _item_token === void 0 ? void 0 : _item_token.tokenId) || (selectedItem === null || selectedItem === void 0 ? void 0 : (_selectedItem_token1 = selectedItem.token) === null || _selectedItem_token1 === void 0 ? void 0 : _selectedItem_token1.contract) !== (item === null || item === void 0 ? void 0 : (_item_token1 = item.token) === null || _item_token1 === void 0 ? void 0 : _item_token1.contract);
        }));
    };
    const isSelectedItem = (0,react.useMemo)(()=>{
        return selectedItems.some((selectedItem)=>{
            var _selectedItem_token, _token_token, _selectedItem_token1, _token_token1;
            return (selectedItem === null || selectedItem === void 0 ? void 0 : (_selectedItem_token = selectedItem.token) === null || _selectedItem_token === void 0 ? void 0 : _selectedItem_token.tokenId) === (token === null || token === void 0 ? void 0 : (_token_token = token.token) === null || _token_token === void 0 ? void 0 : _token_token.tokenId) && (selectedItem === null || selectedItem === void 0 ? void 0 : (_selectedItem_token1 = selectedItem.token) === null || _selectedItem_token1 === void 0 ? void 0 : _selectedItem_token1.contract) === (token === null || token === void 0 ? void 0 : (_token_token1 = token.token) === null || _token_token1 === void 0 ? void 0 : _token_token1.contract);
        });
    }, [
        selectedItems
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Box */.xu, {
        css: {
            borderRadius: 8,
            overflow: "hidden",
            background: "$neutralBgSubtle",
            $$shadowColor: "$colors$panelShadow",
            boxShadow: "0 8px 12px 0px $$shadowColor",
            position: "relative",
            "&:hover > a > div > img": {
                transform: "scale(1.1)"
            },
            "@sm": {
                "&:hover .token-button-container": {
                    bottom: 0
                }
            }
        },
        children: [
            tokenCount && /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Flex */.kC, {
                justify: "center",
                align: "center",
                css: {
                    borderRadius: 8,
                    px: "$2",
                    py: "$1",
                    mr: "$2",
                    position: "absolute",
                    left: "$2",
                    top: "$2",
                    zIndex: 1,
                    maxWidth: "50%",
                    backgroundColor: "rgba(	38, 41, 43, 0.3)"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Text */.xv, {
                    css: {
                        color: "$whiteA12"
                    },
                    ellipsify: true,
                    children: [
                        "x",
                        (0,numbers/* formatNumber */.uf)(tokenCount, 0, true)
                    ]
                })
            }),
            isOwner && !isSmallDevice ? /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Button */.zx, {
                css: {
                    borderRadius: "99999px",
                    width: 48,
                    height: 48,
                    backgroundColor: isSelectedItem ? "$primary9" : "#15171833",
                    "&:hover": {
                        backgroundColor: isSelectedItem ? "$primary9" : "#15171859"
                    },
                    opacity: isSelectedItem ? 1 : 1,
                    position: "absolute",
                    right: "$2",
                    zIndex: 1,
                    top: "$2",
                    color: "white",
                    p: 0,
                    justifyContent: "center"
                },
                onClick: (e)=>{
                    e.preventDefault();
                    if (!isSelectedItem) {
                        addSelectedItem(token);
                    } else {
                        removeSelectedItem(token);
                    }
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                    icon: isSelectedItem ? free_solid_svg_icons/* faCheck */.LEp : free_solid_svg_icons/* faPlus */.r8p,
                    width: 20,
                    height: 20
                })
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                passHref: true,
                href: "/".concat(routePrefix, "/asset/").concat(token === null || token === void 0 ? void 0 : (_token_token3 = token.token) === null || _token_token3 === void 0 ? void 0 : _token_token3.contract, ":").concat(token === null || token === void 0 ? void 0 : (_token_token4 = token.token) === null || _token_token4 === void 0 ? void 0 : _token_token4.tokenId),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Box */.xu, {
                    css: {
                        background: "$gray3",
                        overflow: "hidden"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_module/* TokenMedia */.Y1, {
                        token: dynamicToken === null || dynamicToken === void 0 ? void 0 : dynamicToken.token,
                        style: {
                            width: "100%",
                            transition: "transform .3s ease-in-out",
                            maxHeight: 720,
                            height: "100%",
                            borderRadius: 0,
                            aspectRatio: "1/1"
                        },
                        preview: showPreview,
                        audioOptions: {
                            onPlay: (e)=>{
                                onMediaPlayed === null || onMediaPlayed === void 0 ? void 0 : onMediaPlayed(e);
                            }
                        },
                        videoOptions: {
                            onPlay: (e)=>{
                                onMediaPlayed === null || onMediaPlayed === void 0 ? void 0 : onMediaPlayed(e);
                            }
                        },
                        onRefreshToken: ()=>{
                            mutate === null || mutate === void 0 ? void 0 : mutate();
                            addToast === null || addToast === void 0 ? void 0 : addToast({
                                title: "Refresh token",
                                description: "Request to refresh this token was accepted."
                            });
                        }
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: "/".concat(routePrefix, "/asset/").concat(token === null || token === void 0 ? void 0 : (_token_token5 = token.token) === null || _token_token5 === void 0 ? void 0 : _token_token5.contract, ":").concat(token === null || token === void 0 ? void 0 : (_token_token6 = token.token) === null || _token_token6 === void 0 ? void 0 : _token_token6.tokenId),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                    css: {
                        p: "$4",
                        minHeight: 132,
                        cursor: "pointer"
                    },
                    direction: "column",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                            css: {
                                mb: "$4"
                            },
                            align: "center",
                            justify: "between",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                    align: "center",
                                    css: {
                                        gap: "$2",
                                        minWidth: 0
                                    },
                                    children: [
                                        collectionImage ? /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            style: {
                                                borderRadius: "4px",
                                                objectFit: "cover",
                                                aspectRatio: "1/1"
                                            },
                                            loader: (param)=>{
                                                let { src  } = param;
                                                return src;
                                            },
                                            src: collectionImage,
                                            alt: "".concat(token === null || token === void 0 ? void 0 : (_token_token7 = token.token) === null || _token_token7 === void 0 ? void 0 : _token_token7.name),
                                            width: 24,
                                            height: 24
                                        }) : null,
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Text */.xv, {
                                            style: "subtitle1",
                                            as: "p",
                                            ellipsify: true,
                                            css: {
                                                pr: "$1",
                                                flex: 1
                                            },
                                            children: [
                                                (token === null || token === void 0 ? void 0 : (_token_token8 = token.token) === null || _token_token8 === void 0 ? void 0 : _token_token8.name) || "#" + (token === null || token === void 0 ? void 0 : (_token_token9 = token.token) === null || _token_token9 === void 0 ? void 0 : _token_token9.tokenId),
                                                " "
                                            ]
                                        })
                                    ]
                                }),
                                rarityEnabled && (token === null || token === void 0 ? void 0 : (_token_token10 = token.token) === null || _token_token10 === void 0 ? void 0 : _token_token10.kind) !== "erc1155" && (token === null || token === void 0 ? void 0 : (_token_token11 = token.token) === null || _token_token11 === void 0 ? void 0 : _token_token11.rarityRank) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Box */.xu, {
                                    css: {
                                        px: "$1",
                                        py: 2,
                                        background: "$gray5",
                                        borderRadius: 8,
                                        minWidth: "max-content"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                        align: "center",
                                        css: {
                                            gap: 5
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                style: {
                                                    width: 13,
                                                    height: 13
                                                },
                                                src: "/icons/rarity-icon.svg"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                                style: "subtitle3",
                                                as: "p",
                                                children: (0,numbers/* formatNumber */.uf)(token === null || token === void 0 ? void 0 : (_token_token12 = token.token) === null || _token_token12 === void 0 ? void 0 : _token_token12.rarityRank)
                                            })
                                        ]
                                    })
                                }) : null
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                            align: "center",
                            css: {
                                gap: "$2"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Box */.xu, {
                                    css: {
                                        flex: 1,
                                        minWidth: 0,
                                        width: "100%",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis"
                                    },
                                    children: (token === null || token === void 0 ? void 0 : (_token_ownership1 = token.ownership) === null || _token_ownership1 === void 0 ? void 0 : (_token_ownership_floorAsk1 = _token_ownership1.floorAsk) === null || _token_ownership_floorAsk1 === void 0 ? void 0 : _token_ownership_floorAsk1.price) && /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* FormatCryptoCurrency */.gv, {
                                        logoHeight: 18,
                                        amount: token === null || token === void 0 ? void 0 : (_token_ownership2 = token.ownership) === null || _token_ownership2 === void 0 ? void 0 : (_token_ownership_floorAsk2 = _token_ownership2.floorAsk) === null || _token_ownership_floorAsk2 === void 0 ? void 0 : (_token_ownership_floorAsk_price = _token_ownership_floorAsk2.price) === null || _token_ownership_floorAsk_price === void 0 ? void 0 : (_token_ownership_floorAsk_price_amount = _token_ownership_floorAsk_price.amount) === null || _token_ownership_floorAsk_price_amount === void 0 ? void 0 : _token_ownership_floorAsk_price_amount.decimal,
                                        address: token === null || token === void 0 ? void 0 : (_token_ownership3 = token.ownership) === null || _token_ownership3 === void 0 ? void 0 : (_token_ownership_floorAsk3 = _token_ownership3.floorAsk) === null || _token_ownership_floorAsk3 === void 0 ? void 0 : (_token_ownership_floorAsk_price1 = _token_ownership_floorAsk3.price) === null || _token_ownership_floorAsk_price1 === void 0 ? void 0 : (_token_ownership_floorAsk_price_currency = _token_ownership_floorAsk_price1.currency) === null || _token_ownership_floorAsk_price_currency === void 0 ? void 0 : _token_ownership_floorAsk_price_currency.contract,
                                        textStyle: "h6",
                                        css: {
                                            textOverflow: "ellipsis",
                                            minWidth: 0,
                                            with: "100%",
                                            overflow: "hidden"
                                        },
                                        maximumFractionDigits: 4
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: (token === null || token === void 0 ? void 0 : (_token_ownership4 = token.ownership) === null || _token_ownership4 === void 0 ? void 0 : (_token_ownership_floorAsk4 = _token_ownership4.floorAsk) === null || _token_ownership_floorAsk4 === void 0 ? void 0 : (_token_ownership_floorAsk_source = _token_ownership_floorAsk4.source) === null || _token_ownership_floorAsk_source === void 0 ? void 0 : _token_ownership_floorAsk_source.name) && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        style: {
                                            width: 20,
                                            height: 20,
                                            borderRadius: "50%"
                                        },
                                        src: "".concat(proxyApi, "/redirect/sources/").concat(token === null || token === void 0 ? void 0 : (_token_ownership5 = token.ownership) === null || _token_ownership5 === void 0 ? void 0 : (_token_ownership_floorAsk5 = _token_ownership5.floorAsk) === null || _token_ownership_floorAsk5 === void 0 ? void 0 : (_token_ownership_floorAsk_source1 = _token_ownership_floorAsk5.source) === null || _token_ownership_floorAsk_source1 === void 0 ? void 0 : _token_ownership_floorAsk_source1.domain, "/logo/v2")
                                    })
                                })
                            ]
                        }),
                        (token === null || token === void 0 ? void 0 : (_token_token13 = token.token) === null || _token_token13 === void 0 ? void 0 : (_token_token_lastSale = _token_token13.lastSale) === null || _token_token_lastSale === void 0 ? void 0 : (_token_token_lastSale_price = _token_token_lastSale.price) === null || _token_token_lastSale_price === void 0 ? void 0 : (_token_token_lastSale_price_amount = _token_token_lastSale_price.amount) === null || _token_token_lastSale_price_amount === void 0 ? void 0 : _token_token_lastSale_price_amount.decimal) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                            css: {
                                gap: "$2",
                                marginTop: "auto"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                    css: {
                                        color: "$gray11"
                                    },
                                    style: "subtitle3",
                                    children: "Last Sale"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* FormatCryptoCurrency */.gv, {
                                    logoHeight: 12,
                                    amount: (_token_token_lastSale_price_amount1 = token.token.lastSale.price.amount) === null || _token_token_lastSale_price_amount1 === void 0 ? void 0 : _token_token_lastSale_price_amount1.decimal,
                                    address: (_token_token_lastSale_price_currency = token.token.lastSale.price.currency) === null || _token_token_lastSale_price_currency === void 0 ? void 0 : _token_token_lastSale_price_currency.contract,
                                    decimals: (_token_token_lastSale_price_currency1 = token.token.lastSale.price.currency) === null || _token_token_lastSale_price_currency1 === void 0 ? void 0 : _token_token_lastSale_price_currency1.decimals,
                                    textStyle: "subtitle3",
                                    maximumFractionDigits: 4
                                })
                            ]
                        }) : null
                    ]
                })
            }),
            !isOwner && (token === null || token === void 0 ? void 0 : (_token_ownership6 = token.ownership) === null || _token_ownership6 === void 0 ? void 0 : (_token_ownership_floorAsk6 = _token_ownership6.floorAsk) === null || _token_ownership_floorAsk6 === void 0 ? void 0 : (_token_ownership_floorAsk_price2 = _token_ownership_floorAsk6.price) === null || _token_ownership_floorAsk_price2 === void 0 ? void 0 : _token_ownership_floorAsk_price2.amount) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Flex */.kC, {
                className: "token-button-container",
                css: {
                    width: "100%",
                    transition: "bottom 0.25s ease-in-out",
                    position: "absolute",
                    bottom: -44,
                    left: 0,
                    right: 0,
                    gap: 1
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BuyNow/* default */.Z, {
                    tokenId: (_token_token14 = token.token) === null || _token_token14 === void 0 ? void 0 : _token_token14.tokenId,
                    collectionId: (_token_token15 = token.token) === null || _token_token15 === void 0 ? void 0 : (_token_token_collection2 = _token_token15.collection) === null || _token_token_collection2 === void 0 ? void 0 : _token_token_collection2.id,
                    mutate: mutate,
                    buttonCss: {
                        justifyContent: "center",
                        flex: 1
                    },
                    buttonProps: {
                        corners: "square"
                    },
                    buttonChildren: "Buy Now"
                })
            }) : null,
            isOwner ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                className: "token-button-container",
                css: {
                    width: "100%",
                    transition: "bottom 0.25s ease-in-out",
                    position: "absolute",
                    bottom: -44,
                    left: 0,
                    right: 0,
                    gap: 1
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(List/* default */.Z, {
                        token: token,
                        buttonCss: {
                            justifyContent: "center",
                            flex: 1
                        },
                        buttonProps: {
                            corners: "square"
                        },
                        buttonChildren: "List",
                        mutate: mutate
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Dropdown/* Dropdown */.Lt, {
                        modal: false,
                        trigger: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Button */.zx, {
                            corners: "square",
                            size: "xs",
                            css: {
                                width: 44,
                                justifyContent: "center"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                icon: free_solid_svg_icons/* faEllipsis */.S6C
                            })
                        }),
                        contentProps: {
                            asChild: true,
                            forceMount: true,
                            align: "start",
                            alignOffset: -18
                        },
                        children: [
                            (token === null || token === void 0 ? void 0 : (_token_token16 = token.token) === null || _token_token16 === void 0 ? void 0 : (_token_token_topBid = _token_token16.topBid) === null || _token_token_topBid === void 0 ? void 0 : (_token_token_topBid_price = _token_token_topBid.price) === null || _token_token_topBid_price === void 0 ? void 0 : (_token_token_topBid_price_amount = _token_token_topBid_price.amount) === null || _token_token_topBid_price_amount === void 0 ? void 0 : _token_token_topBid_price_amount.decimal) && isOwner && /*#__PURE__*/ (0,jsx_runtime.jsx)(buttons/* AcceptBid */.ZS, {
                                tokenId: token.token.tokenId,
                                collectionId: token === null || token === void 0 ? void 0 : (_token_token17 = token.token) === null || _token_token17 === void 0 ? void 0 : _token_token17.contract,
                                mutate: mutate,
                                buttonCss: {
                                    gap: "$2",
                                    px: "$2",
                                    py: "$3",
                                    borderRadius: 8,
                                    outline: "none",
                                    cursor: "pointer",
                                    "&:hover": {
                                        backgroundColor: "$gray5"
                                    },
                                    "&:focus": {
                                        backgroundColor: "$gray5"
                                    }
                                },
                                buttonChildren: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Box */.xu, {
                                            css: {
                                                color: "$gray10"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                icon: free_solid_svg_icons/* faHand */.ioV
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                            children: "Accept Best Offer"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Dropdown/* DropdownMenuItem */.Xi, {
                                css: {
                                    py: "$3",
                                    width: "100%"
                                },
                                onClick: (e)=>{
                                    var _token_token;
                                    if (isRefreshing) {
                                        e.preventDefault();
                                        return;
                                    }
                                    setIsRefreshing(true);
                                    (0,fetcher/* default */.ZP)("".concat(window.location.origin, "/").concat(proxyApi, "/tokens/refresh/v1"), undefined, {
                                        method: "POST",
                                        headers: {
                                            "Content-Type": "application/json"
                                        },
                                        body: JSON.stringify({
                                            token: "".concat(contract, ":").concat((_token_token = token.token) === null || _token_token === void 0 ? void 0 : _token_token.tokenId)
                                        })
                                    }).then((param)=>{
                                        let { data , response  } = param;
                                        if (response.status === 200) {
                                            addToast === null || addToast === void 0 ? void 0 : addToast({
                                                title: "Refresh token",
                                                description: "Request to refresh this token was accepted."
                                            });
                                        } else {
                                            throw data;
                                        }
                                        setIsRefreshing(false);
                                    }).catch((e)=>{
                                        var _DATE_REGEX_exec;
                                        const ratelimit = (_DATE_REGEX_exec = till/* DATE_REGEX.exec */.n.exec(e === null || e === void 0 ? void 0 : e.message)) === null || _DATE_REGEX_exec === void 0 ? void 0 : _DATE_REGEX_exec[0];
                                        addToast === null || addToast === void 0 ? void 0 : addToast({
                                            title: "Refresh token failed",
                                            description: ratelimit ? "This token was recently refreshed. The next available refresh is ".concat((0,till/* timeTill */.x)(ratelimit), ".") : "This token was recently refreshed. Please try again later."
                                        });
                                        setIsRefreshing(false);
                                        throw e;
                                    });
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                    align: "center",
                                    css: {
                                        gap: "$2"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Box */.xu, {
                                            css: {
                                                color: "$gray10",
                                                animation: isRefreshing ? "".concat(LoadingSpinner/* spin */.O, " 1s cubic-bezier(0.76, 0.35, 0.2, 0.7) infinite") : "none"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                icon: free_solid_svg_icons/* faRefresh */.QDM,
                                                width: 16,
                                                height: 16
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                            children: "Refresh Token"
                                        })
                                    ]
                                })
                            }),
                            isOracleOrder && (token === null || token === void 0 ? void 0 : (_token_ownership7 = token.ownership) === null || _token_ownership7 === void 0 ? void 0 : (_token_ownership_floorAsk7 = _token_ownership7.floorAsk) === null || _token_ownership_floorAsk7 === void 0 ? void 0 : _token_ownership_floorAsk7.id) && (token === null || token === void 0 ? void 0 : (_token_token18 = token.token) === null || _token_token18 === void 0 ? void 0 : _token_token18.tokenId) && (token === null || token === void 0 ? void 0 : (_token_token19 = token.token) === null || _token_token19 === void 0 ? void 0 : (_token_token_collection3 = _token_token19.collection) === null || _token_token_collection3 === void 0 ? void 0 : _token_token_collection3.id) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_module/* EditListingModal */.oU, {
                                trigger: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                    align: "center",
                                    css: {
                                        gap: "$2",
                                        px: "$2",
                                        py: "$3",
                                        borderRadius: 8,
                                        outline: "none",
                                        cursor: "pointer",
                                        "&:hover": {
                                            backgroundColor: "$gray5"
                                        },
                                        "&:focus": {
                                            backgroundColor: "$gray5"
                                        }
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Box */.xu, {
                                            css: {
                                                color: "$gray10"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                icon: free_solid_svg_icons/* faEdit */.Xcf
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                            children: "Edit Listing"
                                        })
                                    ]
                                }),
                                listingId: token === null || token === void 0 ? void 0 : (_token_ownership8 = token.ownership) === null || _token_ownership8 === void 0 ? void 0 : (_token_ownership_floorAsk8 = _token_ownership8.floorAsk) === null || _token_ownership_floorAsk8 === void 0 ? void 0 : _token_ownership_floorAsk8.id,
                                tokenId: token === null || token === void 0 ? void 0 : (_token_token20 = token.token) === null || _token_token20 === void 0 ? void 0 : _token_token20.tokenId,
                                collectionId: token === null || token === void 0 ? void 0 : (_token_token21 = token.token) === null || _token_token21 === void 0 ? void 0 : (_token_token_collection4 = _token_token21.collection) === null || _token_token_collection4 === void 0 ? void 0 : _token_token_collection4.id,
                                onClose: (data, currentStep)=>{
                                    if (mutate && currentStep == dist_index_module/* EditListingStep.Complete */.qy.Complete) mutate();
                                }
                            }) : null,
                            (token === null || token === void 0 ? void 0 : (_token_ownership9 = token.ownership) === null || _token_ownership9 === void 0 ? void 0 : (_token_ownership_floorAsk9 = _token_ownership9.floorAsk) === null || _token_ownership_floorAsk9 === void 0 ? void 0 : _token_ownership_floorAsk9.id) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CancelListing/* default */.Z, {
                                listingId: token.ownership.floorAsk.id,
                                mutate: mutate,
                                trigger: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Flex */.kC, {
                                    css: {
                                        px: "$2",
                                        py: "$3",
                                        borderRadius: 8,
                                        outline: "none",
                                        cursor: "pointer",
                                        "&:hover": {
                                            backgroundColor: "$gray5"
                                        },
                                        "&:focus": {
                                            backgroundColor: "$gray5"
                                        }
                                    },
                                    children: !isOracleOrder ? /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Tooltip */.u, {
                                        content: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                            style: "body2",
                                            as: "p",
                                            children: "Canceling this order requires gas."
                                        }),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                            align: "center",
                                            css: {
                                                gap: "$2"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Box */.xu, {
                                                    css: {
                                                        color: "$gray10"
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                        icon: free_solid_svg_icons/* faGasPump */.q16
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                                    color: "error",
                                                    children: "Cancel Listing"
                                                })
                                            ]
                                        })
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                        color: "error",
                                        children: "Cancel"
                                    })
                                })
                            }) : null
                        ]
                    })
                ]
            }) : null
        ]
    });
});

;// CONCATENATED MODULE: ./components/portfolio/TokenTable.tsx



























const ownerDesktopTemplateColumns = "1.25fr repeat(3, .75fr) 1.5fr";
const TokenTable_desktopTemplateColumns = "1.25fr repeat(3, .75fr)";
const TokenTable = /*#__PURE__*/ (0,react.forwardRef)((param, ref)=>{
    let { address , isLoading , sortBy , filterCollection , selectedItems , isOwner , itemView , setSelectedItems  } = param;
    const loadMoreRef = (0,react.useRef)(null);
    const loadMoreObserver = (0,esm/* useIntersectionObserver */.S1)(loadMoreRef, {});
    const client = (0,dist_index_module/* useReservoirClient */.RW)();
    const [acceptBidModalOpen, setAcceptBidModalOpen] = (0,react.useState)(false);
    const [playingElement, setPlayingElement] = (0,react.useState)();
    let tokenQuery = {
        limit: 20,
        sortBy: sortBy,
        collection: filterCollection,
        includeTopBid: true,
        includeRawData: true,
        includeAttributes: true
    };
    const { chain  } = (0,react.useContext)(ChainContextProvider/* ChainContext */.p);
    if (chain.collectionSetId) {
        tokenQuery.collectionsSetId = chain.collectionSetId;
    } else if (chain.community) {
        tokenQuery.community = chain.community;
    }
    const { data: tokens , fetchNextPage , mutate , isFetchingPage , isValidating  } = (0,dist_index_module/* useUserTokens */.Vy)(address, tokenQuery, {
        revalidateIfStale: true
    });
    (0,react.useEffect)(()=>{
        const isVisible = !!(loadMoreObserver === null || loadMoreObserver === void 0 ? void 0 : loadMoreObserver.isIntersecting);
        if (isVisible) {
            fetchNextPage();
        }
    }, [
        loadMoreObserver === null || loadMoreObserver === void 0 ? void 0 : loadMoreObserver.isIntersecting
    ]);
    (0,react.useEffect)(()=>{
        const eventListener = (event, chainId)=>{
            switch(event.name){
                case "accept_offer_complete":
                    {
                        if (!acceptBidModalOpen && !selectedItems.length) {
                            mutate();
                            setSelectedItems([]);
                        }
                        break;
                    }
            }
        };
        client === null || client === void 0 ? void 0 : client.addEventListener(eventListener);
        return ()=>{
            client === null || client === void 0 ? void 0 : client.removeEventListener(eventListener);
        };
    }, [
        client
    ]);
    (0,react.useEffect)(()=>{
        if (acceptBidModalOpen) {
            setSelectedItems([]);
        }
    }, [
        acceptBidModalOpen
    ]);
    (0,react.useImperativeHandle)(ref, ()=>({
            mutate
        }));
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            !isValidating && !isFetchingPage && tokens && tokens.length === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                direction: "column",
                align: "center",
                css: {
                    py: "$6",
                    gap: "$4",
                    width: "100%"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                        css: {
                            color: "$gray11"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                            icon: free_solid_svg_icons/* faMagnifyingGlass */.Y$T,
                            size: "2xl"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                        css: {
                            color: "$gray11"
                        },
                        children: "No items found"
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                direction: "column",
                css: {
                    width: "100%"
                },
                children: [
                    isLoading ? null : itemView === "list" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TokenTable_TableHeading, {
                                isOwner: isOwner
                            }),
                            tokens.map((token, i)=>{
                                var _token_token;
                                if (!token) return null;
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(TokenTableRow, {
                                    token: token,
                                    mutate: mutate,
                                    selectedItems: selectedItems,
                                    setSelectedItems: setSelectedItems,
                                    isOwner: isOwner,
                                    onAcceptBidModalOpened: (open)=>{
                                        setAcceptBidModalOpen(open);
                                    }
                                }, "".concat((_token_token = token.token) === null || _token_token === void 0 ? void 0 : _token_token.tokenId, "-").concat(i));
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Grid */.rj, {
                        css: {
                            gap: "$4",
                            width: "100%",
                            pb: "$6",
                            gridTemplateColumns: "repeat(auto-fill, minmax(200px, 1fr))",
                            "@md": {
                                gridTemplateColumns: "repeat(auto-fill, minmax(240px, 1fr))"
                            }
                        },
                        children: tokens === null || tokens === void 0 ? void 0 : tokens.map((token, i)=>{
                            var _token_token, _token_ownership;
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)(PortfolioTokenCard, {
                                token: token,
                                isOwner: isOwner,
                                address: address,
                                tokenCount: (token === null || token === void 0 ? void 0 : (_token_token = token.token) === null || _token_token === void 0 ? void 0 : _token_token.kind) === "erc1155" ? (_token_ownership = token.ownership) === null || _token_ownership === void 0 ? void 0 : _token_ownership.tokenCount : undefined,
                                mutate: mutate,
                                selectedItems: selectedItems,
                                setSelectedItems: setSelectedItems,
                                rarityEnabled: true,
                                onMediaPlayed: (e)=>{
                                    if (playingElement && playingElement !== e.nativeEvent.target) {
                                        playingElement.pause();
                                    }
                                    const element = e.nativeEvent.target || e.nativeEvent.target;
                                    if (element) {
                                        setPlayingElement(element);
                                    }
                                }
                            }, i);
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        ref: loadMoreRef
                    })
                ]
            }),
            isValidating && /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Flex */.kC, {
                align: "center",
                justify: "center",
                css: {
                    py: "$6"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingSpinner/* default */.Z, {})
            })
        ]
    });
});
const TokenTableRow = (param)=>{
    let { token , selectedItems , isOwner , onAcceptBidModalOpened , mutate , setSelectedItems  } = param;
    var _token_token, _token_token1, _token_token2, _token_token_collection, _token_ownership, _token_ownership_floorAsk, _token_token3, _token_token_collection1, _token_token_collection_id, _token_token4, _token_token5, _token_token6, _token_token7, _token_token8, _token_token9, _token_token10, _token_token_collection2, _token_token11, _token_ownership1, _token_ownership2, _token_token12, _token_token_collection3, _token_token13, _token_ownership3, _token_ownership_floorAsk1, _token_ownership_floorAsk_price, _token_ownership_floorAsk_price_amount, _token_ownership4, _token_ownership_floorAsk2, _token_ownership_floorAsk_price1, _token_ownership_floorAsk_price_amount1, _token_ownership5, _token_ownership_floorAsk3, _token_ownership_floorAsk_price2, _token_ownership_floorAsk_price_currency, _token_ownership6, _token_ownership_floorAsk4, _token_ownership_floorAsk_price3, _token_ownership_floorAsk_price_currency1, _token_ownership7, _token_ownership_floorAsk5, _token_ownership_floorAsk_price4, _token_ownership_floorAsk_price_netAmount, _token_ownership8, _token_ownership_floorAsk6, _token_ownership_floorAsk_price5, _token_ownership_floorAsk_price_currency2, _token_ownership9, _token_ownership_floorAsk7, _token_ownership_floorAsk_price6, _token_ownership_floorAsk_price_currency3, _token_ownership10, _token_ownership_floorAsk8, _token_ownership_floorAsk_source, _token_ownership11, _token_ownership_floorAsk9, _token_ownership_floorAsk_price7, _token_ownership_floorAsk_price_amount2, _token_ownership12, _token_ownership_floorAsk10, _token_ownership_floorAsk_price8, _token_ownership_floorAsk_price_currency4, _token_ownership13, _token_ownership_floorAsk11, _token_ownership_floorAsk_price9, _token_ownership_floorAsk_price_currency5, _token_token14, _token_token_collection4, _token_token_collection_floorAskPrice, _token_token_collection_floorAskPrice_amount, _token_token15, _token_token_collection5, _token_token_collection_floorAskPrice1, _token_token_collection_floorAskPrice_currency, _token_token16, _token_token_collection6, _token_token_collection_floorAskPrice2, _token_token_collection_floorAskPrice_currency1, _token_token17, _token_token_topBid, _token_token_topBid_price, _token_token_topBid_price_amount, _token_token18, _token_token_topBid1, _token_token_topBid_price1, _token_token_topBid_price_amount1, _token_token19, _token_token_topBid2, _token_token_topBid_price2, _token_token_topBid_price_currency, _token_token20, _token_token_topBid3, _token_token_topBid_price3, _token_token_topBid_price_currency1, _token_token21, _token_token_topBid4, _token_token_topBid_price4, _token_token_topBid_price_netAmount, _token_token22, _token_token_topBid5, _token_token_topBid_price5, _token_token_topBid_price_currency2, _token_token23, _token_token_topBid6, _token_token_topBid_price6, _token_token_topBid_price_currency3, _ref, _token_token24, _ref_source, _token_token25, _token_token26, _token_token_topBid7, _token_token_topBid_price7, _token_token_topBid_price_amount2, _token_token27, _token_token_topBid8, _token_token_topBid_price8, _token_token_topBid_price_currency4, _token_token28, _token_token_topBid9, _token_token_topBid_price9, _token_token_topBid_price_currency5, _token_token29, _token_token_topBid10, _token_token_topBid_price10, _token_token_topBid_price_amount3, _token_token30, _token_token_topBid11, _token_token_topBid_price11, _token_token_topBid_price_amount4, _token_token31, _token_token32, _token_token33, _token_token_topBid12, _token_token_topBid_price12, _token_token_topBid_price_amount5, _token_token34, _token_ownership14, _token_ownership_floorAsk12, _token_token35, _token_token36, _token_token_collection7, _token_ownership15, _token_ownership_floorAsk13, _token_token37, _token_token38, _token_token_collection8, _token_ownership16, _token_ownership_floorAsk14, _token_token39;
    const { routePrefix , proxyApi  } = (0,hooks/* useMarketplaceChain */.gw)();
    const { addToast  } = (0,react.useContext)(ToastContextProvider/* ToastContext */.u);
    const [isRefreshing, setIsRefreshing] = (0,react.useState)(false);
    const isSmallDevice = (0,react_responsive.useMediaQuery)({
        maxWidth: 900
    });
    const addSelectedItem = (item)=>{
        setSelectedItems([
            ...selectedItems,
            item
        ]);
    };
    const removeSelectedItem = (item)=>{
        setSelectedItems(selectedItems.filter((selectedItem)=>{
            var _selectedItem_token, _item_token, _selectedItem_token1, _item_token1;
            return (selectedItem === null || selectedItem === void 0 ? void 0 : (_selectedItem_token = selectedItem.token) === null || _selectedItem_token === void 0 ? void 0 : _selectedItem_token.tokenId) !== (item === null || item === void 0 ? void 0 : (_item_token = item.token) === null || _item_token === void 0 ? void 0 : _item_token.tokenId) || (selectedItem === null || selectedItem === void 0 ? void 0 : (_selectedItem_token1 = selectedItem.token) === null || _selectedItem_token1 === void 0 ? void 0 : _selectedItem_token1.contract) !== (item === null || item === void 0 ? void 0 : (_item_token1 = item.token) === null || _item_token1 === void 0 ? void 0 : _item_token1.contract);
        }));
    };
    const isSelectedItem = (item)=>{
        return selectedItems.some((selectedItem)=>{
            var _selectedItem_token, _item_token, _selectedItem_token1, _item_token1;
            return (selectedItem === null || selectedItem === void 0 ? void 0 : (_selectedItem_token = selectedItem.token) === null || _selectedItem_token === void 0 ? void 0 : _selectedItem_token.tokenId) === (item === null || item === void 0 ? void 0 : (_item_token = item.token) === null || _item_token === void 0 ? void 0 : _item_token.tokenId) && (selectedItem === null || selectedItem === void 0 ? void 0 : (_selectedItem_token1 = selectedItem.token) === null || _selectedItem_token1 === void 0 ? void 0 : _selectedItem_token1.contract) === (item === null || item === void 0 ? void 0 : (_item_token1 = item.token) === null || _item_token1 === void 0 ? void 0 : _item_token1.contract);
        });
    };
    const [acceptBidModalOpen, setAcceptBidModalOpen] = (0,react.useState)(false);
    const imageSrc = (0,react.useMemo)(()=>{
        var _token_token, _token_token1, _token_token2, _token_token_collection, _token_token3, _token_token_collection1;
        return (token === null || token === void 0 ? void 0 : (_token_token = token.token) === null || _token_token === void 0 ? void 0 : _token_token.tokenId) ? (token === null || token === void 0 ? void 0 : (_token_token1 = token.token) === null || _token_token1 === void 0 ? void 0 : _token_token1.imageSmall) || (0,optimizeImage/* default */.Z)(token === null || token === void 0 ? void 0 : (_token_token2 = token.token) === null || _token_token2 === void 0 ? void 0 : (_token_token_collection = _token_token2.collection) === null || _token_token_collection === void 0 ? void 0 : _token_token_collection.imageUrl, 250) : (0,optimizeImage/* default */.Z)(token === null || token === void 0 ? void 0 : (_token_token3 = token.token) === null || _token_token3 === void 0 ? void 0 : (_token_token_collection1 = _token_token3.collection) === null || _token_token_collection1 === void 0 ? void 0 : _token_token_collection1.imageUrl, 250);
    }, [
        token === null || token === void 0 ? void 0 : (_token_token = token.token) === null || _token_token === void 0 ? void 0 : _token_token.tokenId,
        token === null || token === void 0 ? void 0 : (_token_token1 = token.token) === null || _token_token1 === void 0 ? void 0 : _token_token1.imageSmall,
        token === null || token === void 0 ? void 0 : (_token_token2 = token.token) === null || _token_token2 === void 0 ? void 0 : (_token_token_collection = _token_token2.collection) === null || _token_token_collection === void 0 ? void 0 : _token_token_collection.imageUrl
    ]);
    const isOracleOrder = token === null || token === void 0 ? void 0 : (_token_ownership = token.ownership) === null || _token_ownership === void 0 ? void 0 : (_token_ownership_floorAsk = _token_ownership.floorAsk) === null || _token_ownership_floorAsk === void 0 ? void 0 : _token_ownership_floorAsk.isNativeOffChainCancellable;
    const contract = ((_token_token3 = token.token) === null || _token_token3 === void 0 ? void 0 : (_token_token_collection1 = _token_token3.collection) === null || _token_token_collection1 === void 0 ? void 0 : _token_token_collection1.id) ? (_token_token_collection_id = (_token_token4 = token.token) === null || _token_token4 === void 0 ? void 0 : _token_token4.collection.id) === null || _token_token_collection_id === void 0 ? void 0 : _token_token_collection_id.split(":")[0] : undefined;
    if (isSmallDevice) {
        var _token_token40, _token_token41, _token_token42, _token_token43, _token_token_collection9, _token_token44, _token_token45, _token_token_collection10, _token_token_collection_floorAskPrice3, _token_token_collection_floorAskPrice_amount1, _token_token46, _token_token_collection11, _token_token_collection_floorAskPrice4, _token_token_collection_floorAskPrice_currency2, _token_token47, _token_token_collection12, _token_token_collection_floorAskPrice5, _token_token_collection_floorAskPrice_currency3, _token_token48, _token_token_topBid13, _token_token_topBid_price13, _token_token_topBid_price_amount6, _token_token49, _token_token_topBid14, _token_token_topBid_price14, _token_token_topBid_price_currency6, _token_token50, _token_token_topBid15, _token_token_topBid_price15, _token_token_topBid_price_currency7, _token_token51, _token_token_topBid16, _token_token_topBid_price16, _token_token_topBid_price_amount7, _token_token52, _token_ownership17, _token_ownership_floorAsk15, _token_token53, _token_token54, _token_token_collection13, _token_ownership18, _token_ownership_floorAsk16, _token_token55, _token_token56, _token_token_collection14, _token_ownership19, _token_ownership_floorAsk17, _token_token57;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
            direction: "column",
            align: "start",
            css: {
                gap: "$3",
                borderBottom: "1px solid $gray3",
                py: "$3",
                width: "100%",
                overflow: "hidden",
                flex: 1
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: "/".concat(routePrefix, "/asset/").concat(token === null || token === void 0 ? void 0 : (_token_token40 = token.token) === null || _token_token40 === void 0 ? void 0 : _token_token40.contract, ":").concat(token === null || token === void 0 ? void 0 : (_token_token41 = token.token) === null || _token_token41 === void 0 ? void 0 : _token_token41.tokenId),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                        align: "center",
                        children: [
                            imageSrc && /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                style: {
                                    borderRadius: "4px",
                                    objectFit: "cover",
                                    aspectRatio: "1/1"
                                },
                                loader: (param)=>{
                                    let { src  } = param;
                                    return src;
                                },
                                src: imageSrc,
                                alt: "".concat(token === null || token === void 0 ? void 0 : (_token_token42 = token.token) === null || _token_token42 === void 0 ? void 0 : _token_token42.name),
                                width: 36,
                                height: 36
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                direction: "column",
                                css: {
                                    ml: "$2",
                                    overflow: "hidden",
                                    minWidth: 0
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                        style: "subtitle3",
                                        ellipsify: true,
                                        color: "subtle",
                                        children: token === null || token === void 0 ? void 0 : (_token_token43 = token.token) === null || _token_token43 === void 0 ? void 0 : (_token_token_collection9 = _token_token43.collection) === null || _token_token_collection9 === void 0 ? void 0 : _token_token_collection9.name
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Text */.xv, {
                                        style: "subtitle2",
                                        ellipsify: true,
                                        children: [
                                            "#",
                                            token === null || token === void 0 ? void 0 : (_token_token44 = token.token) === null || _token_token44 === void 0 ? void 0 : _token_token44.tokenId
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                    justify: "between",
                    css: {
                        width: "100%",
                        gap: "$3"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                            direction: "column",
                            align: "start",
                            css: {
                                width: "100%"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                    style: "subtitle3",
                                    color: "subtle",
                                    children: "Floor"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* FormatCryptoCurrency */.gv, {
                                    amount: token === null || token === void 0 ? void 0 : (_token_token45 = token.token) === null || _token_token45 === void 0 ? void 0 : (_token_token_collection10 = _token_token45.collection) === null || _token_token_collection10 === void 0 ? void 0 : (_token_token_collection_floorAskPrice3 = _token_token_collection10.floorAskPrice) === null || _token_token_collection_floorAskPrice3 === void 0 ? void 0 : (_token_token_collection_floorAskPrice_amount1 = _token_token_collection_floorAskPrice3.amount) === null || _token_token_collection_floorAskPrice_amount1 === void 0 ? void 0 : _token_token_collection_floorAskPrice_amount1.decimal,
                                    address: token === null || token === void 0 ? void 0 : (_token_token46 = token.token) === null || _token_token46 === void 0 ? void 0 : (_token_token_collection11 = _token_token46.collection) === null || _token_token_collection11 === void 0 ? void 0 : (_token_token_collection_floorAskPrice4 = _token_token_collection11.floorAskPrice) === null || _token_token_collection_floorAskPrice4 === void 0 ? void 0 : (_token_token_collection_floorAskPrice_currency2 = _token_token_collection_floorAskPrice4.currency) === null || _token_token_collection_floorAskPrice_currency2 === void 0 ? void 0 : _token_token_collection_floorAskPrice_currency2.contract,
                                    decimals: token === null || token === void 0 ? void 0 : (_token_token47 = token.token) === null || _token_token47 === void 0 ? void 0 : (_token_token_collection12 = _token_token47.collection) === null || _token_token_collection12 === void 0 ? void 0 : (_token_token_collection_floorAskPrice5 = _token_token_collection12.floorAskPrice) === null || _token_token_collection_floorAskPrice5 === void 0 ? void 0 : (_token_token_collection_floorAskPrice_currency3 = _token_token_collection_floorAskPrice5.currency) === null || _token_token_collection_floorAskPrice_currency3 === void 0 ? void 0 : _token_token_collection_floorAskPrice_currency3.decimals,
                                    textStyle: "subtitle2",
                                    logoHeight: 14
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                            direction: "column",
                            align: "start",
                            css: {
                                width: "100%"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                    style: "subtitle3",
                                    color: "subtle",
                                    children: "Top Offer"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* FormatCryptoCurrency */.gv, {
                                    amount: token === null || token === void 0 ? void 0 : (_token_token48 = token.token) === null || _token_token48 === void 0 ? void 0 : (_token_token_topBid13 = _token_token48.topBid) === null || _token_token_topBid13 === void 0 ? void 0 : (_token_token_topBid_price13 = _token_token_topBid13.price) === null || _token_token_topBid_price13 === void 0 ? void 0 : (_token_token_topBid_price_amount6 = _token_token_topBid_price13.amount) === null || _token_token_topBid_price_amount6 === void 0 ? void 0 : _token_token_topBid_price_amount6.decimal,
                                    address: token === null || token === void 0 ? void 0 : (_token_token49 = token.token) === null || _token_token49 === void 0 ? void 0 : (_token_token_topBid14 = _token_token49.topBid) === null || _token_token_topBid14 === void 0 ? void 0 : (_token_token_topBid_price14 = _token_token_topBid14.price) === null || _token_token_topBid_price14 === void 0 ? void 0 : (_token_token_topBid_price_currency6 = _token_token_topBid_price14.currency) === null || _token_token_topBid_price_currency6 === void 0 ? void 0 : _token_token_topBid_price_currency6.contract,
                                    decimals: token === null || token === void 0 ? void 0 : (_token_token50 = token.token) === null || _token_token50 === void 0 ? void 0 : (_token_token_topBid15 = _token_token50.topBid) === null || _token_token_topBid15 === void 0 ? void 0 : (_token_token_topBid_price15 = _token_token_topBid15.price) === null || _token_token_topBid_price15 === void 0 ? void 0 : (_token_token_topBid_price_currency7 = _token_token_topBid_price15.currency) === null || _token_token_topBid_price_currency7 === void 0 ? void 0 : _token_token_topBid_price_currency7.decimals,
                                    textStyle: "subtitle2",
                                    logoHeight: 14
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                    css: {
                        gap: "$2",
                        width: "100%"
                    },
                    children: [
                        (token === null || token === void 0 ? void 0 : (_token_token51 = token.token) === null || _token_token51 === void 0 ? void 0 : (_token_token_topBid16 = _token_token51.topBid) === null || _token_token_topBid16 === void 0 ? void 0 : (_token_token_topBid_price16 = _token_token_topBid16.price) === null || _token_token_topBid_price16 === void 0 ? void 0 : (_token_token_topBid_price_amount7 = _token_token_topBid_price16.amount) === null || _token_token_topBid_price_amount7 === void 0 ? void 0 : _token_token_topBid_price_amount7.decimal) && isOwner ? /*#__PURE__*/ (0,jsx_runtime.jsx)(buttons/* AcceptBid */.ZS, {
                            tokenId: token.token.tokenId,
                            collectionId: token === null || token === void 0 ? void 0 : (_token_token52 = token.token) === null || _token_token52 === void 0 ? void 0 : _token_token52.contract,
                            mutate: mutate,
                            openState: [
                                acceptBidModalOpen,
                                (open)=>{
                                    if (open !== acceptBidModalOpen) {
                                        onAcceptBidModalOpened(open);
                                    }
                                    setAcceptBidModalOpen(open);
                                }
                            ],
                            buttonCss: {
                                width: "100%",
                                maxWidth: "300px",
                                justifyContent: "center",
                                px: "20px",
                                backgroundColor: "$primary9",
                                color: "white",
                                "&:hover": {
                                    backgroundColor: "$primary10"
                                }
                            },
                            buttonChildren: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                align: "center",
                                css: {
                                    gap: "$2"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                        icon: free_solid_svg_icons/* faBolt */.BDt
                                    }),
                                    "Sell"
                                ]
                            })
                        }) : null,
                        isOwner ? /*#__PURE__*/ (0,jsx_runtime.jsx)(buttons/* List */.aV, {
                            token: token,
                            mutate: mutate,
                            buttonCss: {
                                width: "100%",
                                maxWidth: "300px",
                                justifyContent: "center",
                                px: "20px",
                                backgroundColor: "$gray3",
                                color: "$gray12",
                                "&:hover": {
                                    backgroundColor: "$gray4"
                                }
                            },
                            buttonChildren: "List"
                        }) : null,
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Dropdown/* Dropdown */.Lt, {
                            modal: false,
                            trigger: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Button */.zx, {
                                color: "gray3",
                                size: "xs",
                                css: {
                                    width: 44,
                                    height: 44,
                                    justifyContent: "center",
                                    flexShrink: 0
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                    icon: free_solid_svg_icons/* faEllipsis */.S6C
                                })
                            }),
                            contentProps: {
                                asChild: true,
                                forceMount: true
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Dropdown/* DropdownMenuItem */.Xi, {
                                    css: {
                                        py: "$3",
                                        width: "100%"
                                    },
                                    onClick: (e)=>{
                                        var _token_token;
                                        if (isRefreshing) {
                                            e.preventDefault();
                                            return;
                                        }
                                        setIsRefreshing(true);
                                        (0,fetcher/* default */.ZP)("".concat(window.location.origin, "/").concat(proxyApi, "/tokens/refresh/v1"), undefined, {
                                            method: "POST",
                                            headers: {
                                                "Content-Type": "application/json"
                                            },
                                            body: JSON.stringify({
                                                token: "".concat(contract, ":").concat((_token_token = token.token) === null || _token_token === void 0 ? void 0 : _token_token.tokenId)
                                            })
                                        }).then((param)=>{
                                            let { data , response  } = param;
                                            if (response.status === 200) {
                                                addToast === null || addToast === void 0 ? void 0 : addToast({
                                                    title: "Refresh token",
                                                    description: "Request to refresh this token was accepted."
                                                });
                                            } else {
                                                throw data;
                                            }
                                            setIsRefreshing(false);
                                        }).catch((e)=>{
                                            var _DATE_REGEX_exec;
                                            const ratelimit = (_DATE_REGEX_exec = till/* DATE_REGEX.exec */.n.exec(e === null || e === void 0 ? void 0 : e.message)) === null || _DATE_REGEX_exec === void 0 ? void 0 : _DATE_REGEX_exec[0];
                                            addToast === null || addToast === void 0 ? void 0 : addToast({
                                                title: "Refresh token failed",
                                                description: ratelimit ? "This token was recently refreshed. The next available refresh is ".concat((0,till/* timeTill */.x)(ratelimit), ".") : "This token was recently refreshed. Please try again later."
                                            });
                                            setIsRefreshing(false);
                                            throw e;
                                        });
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                        align: "center",
                                        css: {
                                            gap: "$2"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Box */.xu, {
                                                css: {
                                                    color: "$gray10",
                                                    animation: isRefreshing ? "".concat(LoadingSpinner/* spin */.O, " 1s cubic-bezier(0.76, 0.35, 0.2, 0.7) infinite") : "none"
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                    icon: free_solid_svg_icons/* faRefresh */.QDM,
                                                    width: 16,
                                                    height: 16
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                                children: "Refresh"
                                            })
                                        ]
                                    })
                                }),
                                isOracleOrder && (token === null || token === void 0 ? void 0 : (_token_ownership17 = token.ownership) === null || _token_ownership17 === void 0 ? void 0 : (_token_ownership_floorAsk15 = _token_ownership17.floorAsk) === null || _token_ownership_floorAsk15 === void 0 ? void 0 : _token_ownership_floorAsk15.id) && (token === null || token === void 0 ? void 0 : (_token_token53 = token.token) === null || _token_token53 === void 0 ? void 0 : _token_token53.tokenId) && (token === null || token === void 0 ? void 0 : (_token_token54 = token.token) === null || _token_token54 === void 0 ? void 0 : (_token_token_collection13 = _token_token54.collection) === null || _token_token_collection13 === void 0 ? void 0 : _token_token_collection13.id) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_module/* EditListingModal */.oU, {
                                    trigger: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                        align: "center",
                                        css: {
                                            gap: "$2",
                                            px: "$2",
                                            py: "$3",
                                            borderRadius: 8,
                                            outline: "none",
                                            cursor: "pointer",
                                            "&:hover": {
                                                backgroundColor: "$gray5"
                                            },
                                            "&:focus": {
                                                backgroundColor: "$gray5"
                                            }
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Box */.xu, {
                                                css: {
                                                    color: "$gray10"
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                    icon: free_solid_svg_icons/* faEdit */.Xcf
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                                children: "Edit Listing"
                                            })
                                        ]
                                    }),
                                    listingId: token === null || token === void 0 ? void 0 : (_token_ownership18 = token.ownership) === null || _token_ownership18 === void 0 ? void 0 : (_token_ownership_floorAsk16 = _token_ownership18.floorAsk) === null || _token_ownership_floorAsk16 === void 0 ? void 0 : _token_ownership_floorAsk16.id,
                                    tokenId: token === null || token === void 0 ? void 0 : (_token_token55 = token.token) === null || _token_token55 === void 0 ? void 0 : _token_token55.tokenId,
                                    collectionId: token === null || token === void 0 ? void 0 : (_token_token56 = token.token) === null || _token_token56 === void 0 ? void 0 : (_token_token_collection14 = _token_token56.collection) === null || _token_token_collection14 === void 0 ? void 0 : _token_token_collection14.id,
                                    onClose: (data, currentStep)=>{
                                        if (mutate && currentStep == dist_index_module/* EditListingStep.Complete */.qy.Complete) mutate();
                                    }
                                }) : null,
                                (token === null || token === void 0 ? void 0 : (_token_ownership19 = token.ownership) === null || _token_ownership19 === void 0 ? void 0 : (_token_ownership_floorAsk17 = _token_ownership19.floorAsk) === null || _token_ownership_floorAsk17 === void 0 ? void 0 : _token_ownership_floorAsk17.id) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CancelListing/* default */.Z, {
                                    listingId: token.ownership.floorAsk.id,
                                    mutate: mutate,
                                    trigger: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Flex */.kC, {
                                        css: {
                                            px: "$2",
                                            py: "$3",
                                            borderRadius: 8,
                                            outline: "none",
                                            cursor: "pointer",
                                            "&:hover": {
                                                backgroundColor: "$gray5"
                                            },
                                            "&:focus": {
                                                backgroundColor: "$gray5"
                                            }
                                        },
                                        children: !isOracleOrder ? /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Tooltip */.u, {
                                            content: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                                style: "body2",
                                                as: "p",
                                                children: "Cancelling this order requires gas."
                                            }),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                                align: "center",
                                                css: {
                                                    gap: "$2"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Box */.xu, {
                                                        css: {
                                                            color: "$gray10"
                                                        },
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                            icon: free_solid_svg_icons/* faGasPump */.q16
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                                        color: "error",
                                                        children: "Cancel"
                                                    })
                                                ]
                                            })
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                            color: "error",
                                            children: "Cancel"
                                        })
                                    })
                                }) : null
                            ]
                        })
                    ]
                })
            ]
        }, token === null || token === void 0 ? void 0 : (_token_token57 = token.token) === null || _token_token57 === void 0 ? void 0 : _token_token57.tokenId);
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* TableRow */.SC, {
        css: {
            gridTemplateColumns: isOwner ? ownerDesktopTemplateColumns : TokenTable_desktopTemplateColumns
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* TableCell */.pj, {
                css: {
                    minWidth: 0,
                    overflow: "hidden"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                    align: "center",
                    css: {
                        gap: "$3"
                    },
                    children: [
                        isOwner ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                            disabled: ((_token_token5 = token.token) === null || _token_token5 === void 0 ? void 0 : _token_token5.contract) ? !constants/* AllowedCollectionList.includes */.T.includes((_token_token6 = token.token) === null || _token_token6 === void 0 ? void 0 : _token_token6.contract) : false,
                            checked: isSelectedItem(token),
                            onCheckedChange: (checked)=>{
                                if (checked) {
                                    addSelectedItem(token);
                                } else {
                                    removeSelectedItem(token);
                                }
                            }
                        }) : null,
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/".concat(routePrefix, "/asset/").concat(token === null || token === void 0 ? void 0 : (_token_token7 = token.token) === null || _token_token7 === void 0 ? void 0 : _token_token7.contract, ":").concat(token === null || token === void 0 ? void 0 : (_token_token8 = token.token) === null || _token_token8 === void 0 ? void 0 : _token_token8.tokenId),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                align: "center",
                                children: [
                                    imageSrc && /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        style: {
                                            borderRadius: "4px",
                                            objectFit: "cover",
                                            aspectRatio: "1/1"
                                        },
                                        loader: (param)=>{
                                            let { src  } = param;
                                            return src;
                                        },
                                        src: imageSrc,
                                        alt: "".concat(token === null || token === void 0 ? void 0 : (_token_token9 = token.token) === null || _token_token9 === void 0 ? void 0 : _token_token9.name),
                                        width: 48,
                                        height: 48
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                        direction: "column",
                                        css: {
                                            ml: "$2",
                                            overflow: "hidden"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                                justify: "between",
                                                align: "center",
                                                css: {
                                                    gap: "$2"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                                        style: "subtitle3",
                                                        ellipsify: true,
                                                        color: "subtle",
                                                        children: token === null || token === void 0 ? void 0 : (_token_token10 = token.token) === null || _token_token10 === void 0 ? void 0 : (_token_token_collection2 = _token_token10.collection) === null || _token_token_collection2 === void 0 ? void 0 : _token_token_collection2.name
                                                    }),
                                                    (token === null || token === void 0 ? void 0 : (_token_token11 = token.token) === null || _token_token11 === void 0 ? void 0 : _token_token11.kind) === "erc1155" && (token === null || token === void 0 ? void 0 : (_token_ownership1 = token.ownership) === null || _token_ownership1 === void 0 ? void 0 : _token_ownership1.tokenCount) && /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Flex */.kC, {
                                                        justify: "center",
                                                        align: "center",
                                                        css: {
                                                            borderRadius: 9999,
                                                            backgroundColor: "$gray4",
                                                            maxWidth: "50%"
                                                        },
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Text */.xv, {
                                                            ellipsify: true,
                                                            style: "subtitle3",
                                                            css: {
                                                                px: "$2",
                                                                fontSize: 10
                                                            },
                                                            children: [
                                                                "x",
                                                                (0,numbers/* formatNumber */.uf)(token === null || token === void 0 ? void 0 : (_token_ownership2 = token.ownership) === null || _token_ownership2 === void 0 ? void 0 : _token_ownership2.tokenCount, 0, true)
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(OpenSeaVerified/* OpenSeaVerified */.v, {
                                                        openseaVerificationStatus: token === null || token === void 0 ? void 0 : (_token_token12 = token.token) === null || _token_token12 === void 0 ? void 0 : (_token_token_collection3 = _token_token12.collection) === null || _token_token_collection3 === void 0 ? void 0 : _token_token_collection3.openseaVerificationStatus
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Text */.xv, {
                                                style: "subtitle2",
                                                ellipsify: true,
                                                children: [
                                                    "#",
                                                    token === null || token === void 0 ? void 0 : (_token_token13 = token.token) === null || _token_token13 === void 0 ? void 0 : _token_token13.tokenId
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* TableCell */.pj, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Tooltip */.u, {
                    side: "left",
                    sideOffset: "2",
                    open: (token === null || token === void 0 ? void 0 : (_token_ownership3 = token.ownership) === null || _token_ownership3 === void 0 ? void 0 : (_token_ownership_floorAsk1 = _token_ownership3.floorAsk) === null || _token_ownership_floorAsk1 === void 0 ? void 0 : (_token_ownership_floorAsk_price = _token_ownership_floorAsk1.price) === null || _token_ownership_floorAsk_price === void 0 ? void 0 : (_token_ownership_floorAsk_price_amount = _token_ownership_floorAsk_price.amount) === null || _token_ownership_floorAsk_price_amount === void 0 ? void 0 : _token_ownership_floorAsk_price_amount.decimal) ? undefined : false,
                    content: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                        direction: "column",
                        css: {
                            gap: "$2"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                justify: "between",
                                css: {
                                    gap: "$3"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                        style: "body3",
                                        children: "Total Listed Price"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* FormatCryptoCurrency */.gv, {
                                        amount: token === null || token === void 0 ? void 0 : (_token_ownership4 = token.ownership) === null || _token_ownership4 === void 0 ? void 0 : (_token_ownership_floorAsk2 = _token_ownership4.floorAsk) === null || _token_ownership_floorAsk2 === void 0 ? void 0 : (_token_ownership_floorAsk_price1 = _token_ownership_floorAsk2.price) === null || _token_ownership_floorAsk_price1 === void 0 ? void 0 : (_token_ownership_floorAsk_price_amount1 = _token_ownership_floorAsk_price1.amount) === null || _token_ownership_floorAsk_price_amount1 === void 0 ? void 0 : _token_ownership_floorAsk_price_amount1.decimal,
                                        address: token === null || token === void 0 ? void 0 : (_token_ownership5 = token.ownership) === null || _token_ownership5 === void 0 ? void 0 : (_token_ownership_floorAsk3 = _token_ownership5.floorAsk) === null || _token_ownership_floorAsk3 === void 0 ? void 0 : (_token_ownership_floorAsk_price2 = _token_ownership_floorAsk3.price) === null || _token_ownership_floorAsk_price2 === void 0 ? void 0 : (_token_ownership_floorAsk_price_currency = _token_ownership_floorAsk_price2.currency) === null || _token_ownership_floorAsk_price_currency === void 0 ? void 0 : _token_ownership_floorAsk_price_currency.contract,
                                        decimals: token === null || token === void 0 ? void 0 : (_token_ownership6 = token.ownership) === null || _token_ownership6 === void 0 ? void 0 : (_token_ownership_floorAsk4 = _token_ownership6.floorAsk) === null || _token_ownership_floorAsk4 === void 0 ? void 0 : (_token_ownership_floorAsk_price3 = _token_ownership_floorAsk4.price) === null || _token_ownership_floorAsk_price3 === void 0 ? void 0 : (_token_ownership_floorAsk_price_currency1 = _token_ownership_floorAsk_price3.currency) === null || _token_ownership_floorAsk_price_currency1 === void 0 ? void 0 : _token_ownership_floorAsk_price_currency1.decimals,
                                        textStyle: "subtitle3",
                                        logoHeight: 14
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                justify: "between",
                                css: {
                                    gap: "$2"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                        style: "body3",
                                        children: "You Get"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* FormatCryptoCurrency */.gv, {
                                        amount: token === null || token === void 0 ? void 0 : (_token_ownership7 = token.ownership) === null || _token_ownership7 === void 0 ? void 0 : (_token_ownership_floorAsk5 = _token_ownership7.floorAsk) === null || _token_ownership_floorAsk5 === void 0 ? void 0 : (_token_ownership_floorAsk_price4 = _token_ownership_floorAsk5.price) === null || _token_ownership_floorAsk_price4 === void 0 ? void 0 : (_token_ownership_floorAsk_price_netAmount = _token_ownership_floorAsk_price4.netAmount) === null || _token_ownership_floorAsk_price_netAmount === void 0 ? void 0 : _token_ownership_floorAsk_price_netAmount.decimal,
                                        address: token === null || token === void 0 ? void 0 : (_token_ownership8 = token.ownership) === null || _token_ownership8 === void 0 ? void 0 : (_token_ownership_floorAsk6 = _token_ownership8.floorAsk) === null || _token_ownership_floorAsk6 === void 0 ? void 0 : (_token_ownership_floorAsk_price5 = _token_ownership_floorAsk6.price) === null || _token_ownership_floorAsk_price5 === void 0 ? void 0 : (_token_ownership_floorAsk_price_currency2 = _token_ownership_floorAsk_price5.currency) === null || _token_ownership_floorAsk_price_currency2 === void 0 ? void 0 : _token_ownership_floorAsk_price_currency2.contract,
                                        decimals: token === null || token === void 0 ? void 0 : (_token_ownership9 = token.ownership) === null || _token_ownership9 === void 0 ? void 0 : (_token_ownership_floorAsk7 = _token_ownership9.floorAsk) === null || _token_ownership_floorAsk7 === void 0 ? void 0 : (_token_ownership_floorAsk_price6 = _token_ownership_floorAsk7.price) === null || _token_ownership_floorAsk_price6 === void 0 ? void 0 : (_token_ownership_floorAsk_price_currency3 = _token_ownership_floorAsk_price6.currency) === null || _token_ownership_floorAsk_price_currency3 === void 0 ? void 0 : _token_ownership_floorAsk_price_currency3.decimals,
                                        textStyle: "subtitle3",
                                        logoHeight: 14
                                    })
                                ]
                            })
                        ]
                    }),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                        align: "center",
                        css: {
                            gap: "$2"
                        },
                        children: [
                            ((_token_ownership10 = token.ownership) === null || _token_ownership10 === void 0 ? void 0 : (_token_ownership_floorAsk8 = _token_ownership10.floorAsk) === null || _token_ownership_floorAsk8 === void 0 ? void 0 : (_token_ownership_floorAsk_source = _token_ownership_floorAsk8.source) === null || _token_ownership_floorAsk_source === void 0 ? void 0 : _token_ownership_floorAsk_source.icon) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: token.ownership.floorAsk.source.icon,
                                alt: "Listing Source Icon",
                                style: {
                                    height: 16,
                                    width: 16
                                }
                            }) : null,
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* FormatCryptoCurrency */.gv, {
                                amount: token === null || token === void 0 ? void 0 : (_token_ownership11 = token.ownership) === null || _token_ownership11 === void 0 ? void 0 : (_token_ownership_floorAsk9 = _token_ownership11.floorAsk) === null || _token_ownership_floorAsk9 === void 0 ? void 0 : (_token_ownership_floorAsk_price7 = _token_ownership_floorAsk9.price) === null || _token_ownership_floorAsk_price7 === void 0 ? void 0 : (_token_ownership_floorAsk_price_amount2 = _token_ownership_floorAsk_price7.amount) === null || _token_ownership_floorAsk_price_amount2 === void 0 ? void 0 : _token_ownership_floorAsk_price_amount2.decimal,
                                address: token === null || token === void 0 ? void 0 : (_token_ownership12 = token.ownership) === null || _token_ownership12 === void 0 ? void 0 : (_token_ownership_floorAsk10 = _token_ownership12.floorAsk) === null || _token_ownership_floorAsk10 === void 0 ? void 0 : (_token_ownership_floorAsk_price8 = _token_ownership_floorAsk10.price) === null || _token_ownership_floorAsk_price8 === void 0 ? void 0 : (_token_ownership_floorAsk_price_currency4 = _token_ownership_floorAsk_price8.currency) === null || _token_ownership_floorAsk_price_currency4 === void 0 ? void 0 : _token_ownership_floorAsk_price_currency4.contract,
                                decimals: token === null || token === void 0 ? void 0 : (_token_ownership13 = token.ownership) === null || _token_ownership13 === void 0 ? void 0 : (_token_ownership_floorAsk11 = _token_ownership13.floorAsk) === null || _token_ownership_floorAsk11 === void 0 ? void 0 : (_token_ownership_floorAsk_price9 = _token_ownership_floorAsk11.price) === null || _token_ownership_floorAsk_price9 === void 0 ? void 0 : (_token_ownership_floorAsk_price_currency5 = _token_ownership_floorAsk_price9.currency) === null || _token_ownership_floorAsk_price_currency5 === void 0 ? void 0 : _token_ownership_floorAsk_price_currency5.decimals,
                                textStyle: "subtitle1",
                                logoHeight: 14
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* TableCell */.pj, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* FormatCryptoCurrency */.gv, {
                    amount: token === null || token === void 0 ? void 0 : (_token_token14 = token.token) === null || _token_token14 === void 0 ? void 0 : (_token_token_collection4 = _token_token14.collection) === null || _token_token_collection4 === void 0 ? void 0 : (_token_token_collection_floorAskPrice = _token_token_collection4.floorAskPrice) === null || _token_token_collection_floorAskPrice === void 0 ? void 0 : (_token_token_collection_floorAskPrice_amount = _token_token_collection_floorAskPrice.amount) === null || _token_token_collection_floorAskPrice_amount === void 0 ? void 0 : _token_token_collection_floorAskPrice_amount.decimal,
                    address: token === null || token === void 0 ? void 0 : (_token_token15 = token.token) === null || _token_token15 === void 0 ? void 0 : (_token_token_collection5 = _token_token15.collection) === null || _token_token_collection5 === void 0 ? void 0 : (_token_token_collection_floorAskPrice1 = _token_token_collection5.floorAskPrice) === null || _token_token_collection_floorAskPrice1 === void 0 ? void 0 : (_token_token_collection_floorAskPrice_currency = _token_token_collection_floorAskPrice1.currency) === null || _token_token_collection_floorAskPrice_currency === void 0 ? void 0 : _token_token_collection_floorAskPrice_currency.contract,
                    decimals: token === null || token === void 0 ? void 0 : (_token_token16 = token.token) === null || _token_token16 === void 0 ? void 0 : (_token_token_collection6 = _token_token16.collection) === null || _token_token_collection6 === void 0 ? void 0 : (_token_token_collection_floorAskPrice2 = _token_token_collection6.floorAskPrice) === null || _token_token_collection_floorAskPrice2 === void 0 ? void 0 : (_token_token_collection_floorAskPrice_currency1 = _token_token_collection_floorAskPrice2.currency) === null || _token_token_collection_floorAskPrice_currency1 === void 0 ? void 0 : _token_token_collection_floorAskPrice_currency1.decimals,
                    textStyle: "subtitle1",
                    logoHeight: 14
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* TableCell */.pj, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Tooltip */.u, {
                    side: "left",
                    sideOffset: "2",
                    open: (token === null || token === void 0 ? void 0 : (_token_token17 = token.token) === null || _token_token17 === void 0 ? void 0 : (_token_token_topBid = _token_token17.topBid) === null || _token_token_topBid === void 0 ? void 0 : (_token_token_topBid_price = _token_token_topBid.price) === null || _token_token_topBid_price === void 0 ? void 0 : (_token_token_topBid_price_amount = _token_token_topBid_price.amount) === null || _token_token_topBid_price_amount === void 0 ? void 0 : _token_token_topBid_price_amount.decimal) ? undefined : false,
                    content: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                        direction: "column",
                        css: {
                            gap: "$2"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                justify: "between",
                                css: {
                                    gap: "$3"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                        style: "body3",
                                        children: "Total Offer"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* FormatCryptoCurrency */.gv, {
                                        amount: token === null || token === void 0 ? void 0 : (_token_token18 = token.token) === null || _token_token18 === void 0 ? void 0 : (_token_token_topBid1 = _token_token18.topBid) === null || _token_token_topBid1 === void 0 ? void 0 : (_token_token_topBid_price1 = _token_token_topBid1.price) === null || _token_token_topBid_price1 === void 0 ? void 0 : (_token_token_topBid_price_amount1 = _token_token_topBid_price1.amount) === null || _token_token_topBid_price_amount1 === void 0 ? void 0 : _token_token_topBid_price_amount1.decimal,
                                        address: token === null || token === void 0 ? void 0 : (_token_token19 = token.token) === null || _token_token19 === void 0 ? void 0 : (_token_token_topBid2 = _token_token19.topBid) === null || _token_token_topBid2 === void 0 ? void 0 : (_token_token_topBid_price2 = _token_token_topBid2.price) === null || _token_token_topBid_price2 === void 0 ? void 0 : (_token_token_topBid_price_currency = _token_token_topBid_price2.currency) === null || _token_token_topBid_price_currency === void 0 ? void 0 : _token_token_topBid_price_currency.contract,
                                        decimals: token === null || token === void 0 ? void 0 : (_token_token20 = token.token) === null || _token_token20 === void 0 ? void 0 : (_token_token_topBid3 = _token_token20.topBid) === null || _token_token_topBid3 === void 0 ? void 0 : (_token_token_topBid_price3 = _token_token_topBid3.price) === null || _token_token_topBid_price3 === void 0 ? void 0 : (_token_token_topBid_price_currency1 = _token_token_topBid_price3.currency) === null || _token_token_topBid_price_currency1 === void 0 ? void 0 : _token_token_topBid_price_currency1.decimals,
                                        textStyle: "subtitle3",
                                        logoHeight: 14
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                justify: "between",
                                css: {
                                    gap: "$2"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                        style: "body3",
                                        children: "You Get"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* FormatCryptoCurrency */.gv, {
                                        amount: token === null || token === void 0 ? void 0 : (_token_token21 = token.token) === null || _token_token21 === void 0 ? void 0 : (_token_token_topBid4 = _token_token21.topBid) === null || _token_token_topBid4 === void 0 ? void 0 : (_token_token_topBid_price4 = _token_token_topBid4.price) === null || _token_token_topBid_price4 === void 0 ? void 0 : (_token_token_topBid_price_netAmount = _token_token_topBid_price4.netAmount) === null || _token_token_topBid_price_netAmount === void 0 ? void 0 : _token_token_topBid_price_netAmount.decimal,
                                        address: token === null || token === void 0 ? void 0 : (_token_token22 = token.token) === null || _token_token22 === void 0 ? void 0 : (_token_token_topBid5 = _token_token22.topBid) === null || _token_token_topBid5 === void 0 ? void 0 : (_token_token_topBid_price5 = _token_token_topBid5.price) === null || _token_token_topBid_price5 === void 0 ? void 0 : (_token_token_topBid_price_currency2 = _token_token_topBid_price5.currency) === null || _token_token_topBid_price_currency2 === void 0 ? void 0 : _token_token_topBid_price_currency2.contract,
                                        decimals: token === null || token === void 0 ? void 0 : (_token_token23 = token.token) === null || _token_token23 === void 0 ? void 0 : (_token_token_topBid6 = _token_token23.topBid) === null || _token_token_topBid6 === void 0 ? void 0 : (_token_token_topBid_price6 = _token_token_topBid6.price) === null || _token_token_topBid_price6 === void 0 ? void 0 : (_token_token_topBid_price_currency3 = _token_token_topBid_price6.currency) === null || _token_token_topBid_price_currency3 === void 0 ? void 0 : _token_token_topBid_price_currency3.decimals,
                                        textStyle: "subtitle3",
                                        logoHeight: 14
                                    })
                                ]
                            })
                        ]
                    }),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                        direction: "column",
                        align: "start",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                css: {
                                    gap: "$2"
                                },
                                align: "center",
                                children: [
                                    ((_ref = (_token_token24 = token.token) === null || _token_token24 === void 0 ? void 0 : _token_token24.topBid) === null || _ref === void 0 ? void 0 : (_ref_source = _ref.source) === null || _ref_source === void 0 ? void 0 : _ref_source.icon) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: (token === null || token === void 0 ? void 0 : (_token_token25 = token.token) === null || _token_token25 === void 0 ? void 0 : _token_token25.topBid).source.icon,
                                        alt: "Listing Source Icon",
                                        style: {
                                            height: 16,
                                            width: 16
                                        }
                                    }) : null,
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* FormatCryptoCurrency */.gv, {
                                        amount: token === null || token === void 0 ? void 0 : (_token_token26 = token.token) === null || _token_token26 === void 0 ? void 0 : (_token_token_topBid7 = _token_token26.topBid) === null || _token_token_topBid7 === void 0 ? void 0 : (_token_token_topBid_price7 = _token_token_topBid7.price) === null || _token_token_topBid_price7 === void 0 ? void 0 : (_token_token_topBid_price_amount2 = _token_token_topBid_price7.amount) === null || _token_token_topBid_price_amount2 === void 0 ? void 0 : _token_token_topBid_price_amount2.decimal,
                                        address: token === null || token === void 0 ? void 0 : (_token_token27 = token.token) === null || _token_token27 === void 0 ? void 0 : (_token_token_topBid8 = _token_token27.topBid) === null || _token_token_topBid8 === void 0 ? void 0 : (_token_token_topBid_price8 = _token_token_topBid8.price) === null || _token_token_topBid_price8 === void 0 ? void 0 : (_token_token_topBid_price_currency4 = _token_token_topBid_price8.currency) === null || _token_token_topBid_price_currency4 === void 0 ? void 0 : _token_token_topBid_price_currency4.contract,
                                        decimals: token === null || token === void 0 ? void 0 : (_token_token28 = token.token) === null || _token_token28 === void 0 ? void 0 : (_token_token_topBid9 = _token_token28.topBid) === null || _token_token_topBid9 === void 0 ? void 0 : (_token_token_topBid_price9 = _token_token_topBid9.price) === null || _token_token_topBid_price9 === void 0 ? void 0 : (_token_token_topBid_price_currency5 = _token_token_topBid_price9.currency) === null || _token_token_topBid_price_currency5 === void 0 ? void 0 : _token_token_topBid_price_currency5.decimals,
                                        textStyle: "subtitle2",
                                        logoHeight: 14
                                    })
                                ]
                            }),
                            (token === null || token === void 0 ? void 0 : (_token_token29 = token.token) === null || _token_token29 === void 0 ? void 0 : (_token_token_topBid10 = _token_token29.topBid) === null || _token_token_topBid10 === void 0 ? void 0 : (_token_token_topBid_price10 = _token_token_topBid10.price) === null || _token_token_topBid_price10 === void 0 ? void 0 : (_token_token_topBid_price_amount3 = _token_token_topBid_price10.amount) === null || _token_token_topBid_price_amount3 === void 0 ? void 0 : _token_token_topBid_price_amount3.usd) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                style: "subtitle3",
                                css: {
                                    color: "$gray11"
                                },
                                ellipsify: true,
                                children: (0,numbers/* formatDollar */.el)(token === null || token === void 0 ? void 0 : (_token_token30 = token.token) === null || _token_token30 === void 0 ? void 0 : (_token_token_topBid11 = _token_token30.topBid) === null || _token_token_topBid11 === void 0 ? void 0 : (_token_token_topBid_price11 = _token_token_topBid11.price) === null || _token_token_topBid_price11 === void 0 ? void 0 : (_token_token_topBid_price_amount4 = _token_token_topBid_price11.amount) === null || _token_token_topBid_price_amount4 === void 0 ? void 0 : _token_token_topBid_price_amount4.usd)
                            }) : null
                        ]
                    })
                })
            }),
            isOwner && ((_token_token31 = token.token) === null || _token_token31 === void 0 ? void 0 : _token_token31.contract) && constants/* AllowedCollectionList.includes */.T.includes((_token_token32 = token.token) === null || _token_token32 === void 0 ? void 0 : _token_token32.contract) && /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* TableCell */.pj, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                    justify: "end",
                    css: {
                        gap: "$3"
                    },
                    children: [
                        (token === null || token === void 0 ? void 0 : (_token_token33 = token.token) === null || _token_token33 === void 0 ? void 0 : (_token_token_topBid12 = _token_token33.topBid) === null || _token_token_topBid12 === void 0 ? void 0 : (_token_token_topBid_price12 = _token_token_topBid12.price) === null || _token_token_topBid_price12 === void 0 ? void 0 : (_token_token_topBid_price_amount5 = _token_token_topBid_price12.amount) === null || _token_token_topBid_price_amount5 === void 0 ? void 0 : _token_token_topBid_price_amount5.decimal) && /*#__PURE__*/ (0,jsx_runtime.jsx)(buttons/* AcceptBid */.ZS, {
                            openState: [
                                acceptBidModalOpen,
                                (open)=>{
                                    if (open !== acceptBidModalOpen) {
                                        onAcceptBidModalOpened(open);
                                    }
                                    setAcceptBidModalOpen(open);
                                }
                            ],
                            tokenId: token.token.tokenId,
                            collectionId: token === null || token === void 0 ? void 0 : (_token_token34 = token.token) === null || _token_token34 === void 0 ? void 0 : _token_token34.contract,
                            buttonCss: {
                                px: "32px",
                                backgroundColor: "$primary9",
                                color: "white",
                                "&:hover": {
                                    backgroundColor: "$primary10"
                                }
                            },
                            buttonChildren: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                align: "center",
                                css: {
                                    gap: "$2"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                        icon: free_solid_svg_icons/* faBolt */.BDt
                                    }),
                                    "Sell"
                                ]
                            }),
                            mutate: mutate
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(buttons/* List */.aV, {
                            token: token,
                            buttonCss: {
                                px: "42px",
                                backgroundColor: "$gray3",
                                color: "$gray12",
                                "&:hover": {
                                    backgroundColor: "$gray4"
                                }
                            },
                            buttonChildren: "List",
                            mutate: mutate
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Dropdown/* Dropdown */.Lt, {
                            modal: false,
                            trigger: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Button */.zx, {
                                color: "gray3",
                                size: "xs",
                                css: {
                                    width: 44,
                                    justifyContent: "center"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                    icon: free_solid_svg_icons/* faEllipsis */.S6C
                                })
                            }),
                            contentProps: {
                                asChild: true,
                                forceMount: true
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Dropdown/* DropdownMenuItem */.Xi, {
                                    css: {
                                        py: "$3",
                                        width: "100%"
                                    },
                                    onClick: (e)=>{
                                        var _token_token;
                                        if (isRefreshing) {
                                            e.preventDefault();
                                            return;
                                        }
                                        setIsRefreshing(true);
                                        (0,fetcher/* default */.ZP)("".concat(window.location.origin, "/").concat(proxyApi, "/tokens/refresh/v1"), undefined, {
                                            method: "POST",
                                            headers: {
                                                "Content-Type": "application/json"
                                            },
                                            body: JSON.stringify({
                                                token: "".concat(contract, ":").concat((_token_token = token.token) === null || _token_token === void 0 ? void 0 : _token_token.tokenId)
                                            })
                                        }).then((param)=>{
                                            let { data , response  } = param;
                                            if (response.status === 200) {
                                                addToast === null || addToast === void 0 ? void 0 : addToast({
                                                    title: "Refresh token",
                                                    description: "Request to refresh this token was accepted."
                                                });
                                            } else {
                                                throw data;
                                            }
                                            setIsRefreshing(false);
                                        }).catch((e)=>{
                                            var _DATE_REGEX_exec;
                                            const ratelimit = (_DATE_REGEX_exec = till/* DATE_REGEX.exec */.n.exec(e === null || e === void 0 ? void 0 : e.message)) === null || _DATE_REGEX_exec === void 0 ? void 0 : _DATE_REGEX_exec[0];
                                            addToast === null || addToast === void 0 ? void 0 : addToast({
                                                title: "Refresh token failed",
                                                description: ratelimit ? "This token was recently refreshed. The next available refresh is ".concat((0,till/* timeTill */.x)(ratelimit), ".") : "This token was recently refreshed. Please try again later."
                                            });
                                            setIsRefreshing(false);
                                            throw e;
                                        });
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                        align: "center",
                                        css: {
                                            gap: "$2"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Box */.xu, {
                                                css: {
                                                    color: "$gray10",
                                                    animation: isRefreshing ? "".concat(LoadingSpinner/* spin */.O, " 1s cubic-bezier(0.76, 0.35, 0.2, 0.7) infinite") : "none"
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                    icon: free_solid_svg_icons/* faRefresh */.QDM,
                                                    width: 16,
                                                    height: 16
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                                children: "Refresh"
                                            })
                                        ]
                                    })
                                }),
                                isOracleOrder && (token === null || token === void 0 ? void 0 : (_token_ownership14 = token.ownership) === null || _token_ownership14 === void 0 ? void 0 : (_token_ownership_floorAsk12 = _token_ownership14.floorAsk) === null || _token_ownership_floorAsk12 === void 0 ? void 0 : _token_ownership_floorAsk12.id) && (token === null || token === void 0 ? void 0 : (_token_token35 = token.token) === null || _token_token35 === void 0 ? void 0 : _token_token35.tokenId) && (token === null || token === void 0 ? void 0 : (_token_token36 = token.token) === null || _token_token36 === void 0 ? void 0 : (_token_token_collection7 = _token_token36.collection) === null || _token_token_collection7 === void 0 ? void 0 : _token_token_collection7.id) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_module/* EditListingModal */.oU, {
                                    trigger: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                        align: "center",
                                        css: {
                                            gap: "$2",
                                            px: "$2",
                                            py: "$3",
                                            borderRadius: 8,
                                            outline: "none",
                                            cursor: "pointer",
                                            "&:hover": {
                                                backgroundColor: "$gray5"
                                            },
                                            "&:focus": {
                                                backgroundColor: "$gray5"
                                            }
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Box */.xu, {
                                                css: {
                                                    color: "$gray10"
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                    icon: free_solid_svg_icons/* faEdit */.Xcf
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                                children: "Edit Listing"
                                            })
                                        ]
                                    }),
                                    listingId: token === null || token === void 0 ? void 0 : (_token_ownership15 = token.ownership) === null || _token_ownership15 === void 0 ? void 0 : (_token_ownership_floorAsk13 = _token_ownership15.floorAsk) === null || _token_ownership_floorAsk13 === void 0 ? void 0 : _token_ownership_floorAsk13.id,
                                    tokenId: token === null || token === void 0 ? void 0 : (_token_token37 = token.token) === null || _token_token37 === void 0 ? void 0 : _token_token37.tokenId,
                                    collectionId: token === null || token === void 0 ? void 0 : (_token_token38 = token.token) === null || _token_token38 === void 0 ? void 0 : (_token_token_collection8 = _token_token38.collection) === null || _token_token_collection8 === void 0 ? void 0 : _token_token_collection8.id,
                                    onClose: (data, currentStep)=>{
                                        if (mutate && currentStep == dist_index_module/* EditListingStep.Complete */.qy.Complete) mutate();
                                    }
                                }) : null,
                                (token === null || token === void 0 ? void 0 : (_token_ownership16 = token.ownership) === null || _token_ownership16 === void 0 ? void 0 : (_token_ownership_floorAsk14 = _token_ownership16.floorAsk) === null || _token_ownership_floorAsk14 === void 0 ? void 0 : _token_ownership_floorAsk14.id) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CancelListing/* default */.Z, {
                                    listingId: token.ownership.floorAsk.id,
                                    mutate: mutate,
                                    trigger: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Flex */.kC, {
                                        css: {
                                            px: "$2",
                                            py: "$3",
                                            borderRadius: 8,
                                            outline: "none",
                                            cursor: "pointer",
                                            "&:hover": {
                                                backgroundColor: "$gray5"
                                            },
                                            "&:focus": {
                                                backgroundColor: "$gray5"
                                            }
                                        },
                                        children: !isOracleOrder ? /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Tooltip */.u, {
                                            content: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                                style: "body2",
                                                as: "p",
                                                children: "Cancelling this order requires gas."
                                            }),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                                align: "center",
                                                css: {
                                                    gap: "$2"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Box */.xu, {
                                                        css: {
                                                            color: "$gray10"
                                                        },
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                            icon: free_solid_svg_icons/* faGasPump */.q16
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                                        color: "error",
                                                        children: "Cancel"
                                                    })
                                                ]
                                            })
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                            color: "error",
                                            children: "Cancel"
                                        })
                                    })
                                }) : null
                            ]
                        })
                    ]
                })
            })
        ]
    }, token === null || token === void 0 ? void 0 : (_token_token39 = token.token) === null || _token_token39 === void 0 ? void 0 : _token_token39.tokenId);
};
const TokenTable_TableHeading = (param)=>/*#__PURE__*/ {
    let { isOwner  } = param;
    return (0,jsx_runtime.jsxs)(primitives/* HeaderRow */.VJ, {
        css: {
            display: "none",
            "@md": {
                display: "grid"
            },
            gridTemplateColumns: isOwner ? ownerDesktopTemplateColumns : TokenTable_desktopTemplateColumns,
            position: "sticky",
            top: navbar/* NAVBAR_HEIGHT */.ik,
            backgroundColor: "$neutralBg"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* TableCell */.pj, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                    style: "subtitle3",
                    color: "subtle",
                    children: "Items"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* TableCell */.pj, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                    style: "subtitle3",
                    color: "subtle",
                    children: "Listed Price"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* TableCell */.pj, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                    style: "subtitle3",
                    color: "subtle",
                    children: "Floor"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* TableCell */.pj, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                    style: "subtitle3",
                    color: "subtle",
                    children: "Top Offer"
                })
            }),
            isOwner ? /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* TableCell */.pj, {}) : null
        ]
    });
};

// EXTERNAL MODULE: ./components/common/ActivityTable.tsx
var ActivityTable = __webpack_require__(31322);
;// CONCATENATED MODULE: ./components/portfolio/UserActivityTable.tsx





const UserActivityTable = (param)=>{
    let { user , activityTypes  } = param;
    let activityQuery = {
        limit: 20,
        types: activityTypes
    };
    const { chain  } = (0,react.useContext)(ChainContextProvider/* ChainContext */.p);
    if (chain.collectionSetId) {
        activityQuery.collectionsSetId = chain.collectionSetId;
    } else if (chain.community) {
        activityQuery.community = chain.community;
    }
    const data = (0,dist_index_module/* useUsersActivity */.uR)(user ? [
        user
    ] : undefined, activityQuery, {
        revalidateOnMount: true,
        fallbackData: []
    });
    (0,react.useEffect)(()=>{
        data.mutate();
        return ()=>{
            data.setSize(1);
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ActivityTable/* ActivityTable */.T, {
        data: data
    });
};

;// CONCATENATED MODULE: ./components/portfolio/ViewToggle.tsx




const ViewToggle = (param)=>{
    let { itemView , setItemView  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* ToggleGroup */.tX, {
        type: "single",
        value: itemView,
        onValueChange: (value)=>setItemView(value),
        css: {
            flexShrink: 0
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* ToggleGroupItem */.GX, {
                value: "list",
                css: {
                    width: 48,
                    height: 48
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Box */.xu, {
                    css: {
                        color: "$gray12"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                        icon: free_solid_svg_icons/* faList */.Zrf,
                        width: 16,
                        height: 16
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* ToggleGroupItem */.GX, {
                value: "grid",
                css: {
                    width: 48,
                    height: 48
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Box */.xu, {
                    css: {
                        color: "$gray12"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                        icon: free_solid_svg_icons/* faTableCellsLarge */.jJj,
                        width: 16,
                        height: 16
                    })
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./components/primitives/Avatar.tsx
var Avatar = __webpack_require__(95715);
// EXTERNAL MODULE: ./components/primitives/Tab.tsx
var Tab = __webpack_require__(53370);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react-jazzicon/dist/index.js
var react_jazzicon_dist = __webpack_require__(44111);
var dist_default = /*#__PURE__*/__webpack_require__.n(react_jazzicon_dist);
;// CONCATENATED MODULE: ./pages/portfolio/[[...address]].tsx


































const IndexPage = ()=>{
    const router = (0,next_router.useRouter)();
    const { address: accountAddress , isConnected  } = (0,dist/* useAccount */.mA)();
    const address = router.query.address ? router.query.address[0] : accountAddress;
    const [tabValue, setTabValue] = (0,react.useState)("items");
    const [itemView, setItemView] = (0,react.useState)("list");
    const [activityTypes, setActivityTypes] = (0,react.useState)([
        "sale"
    ]);
    const [activityFiltersOpen, setActivityFiltersOpen] = (0,react.useState)(true);
    const [tokenFiltersOpen, setTokenFiltersOpen] = (0,react.useState)(true);
    const [filterCollection, setFilterCollection] = (0,react.useState)(undefined);
    const [sortByType, setSortByType] = (0,react.useState)("acquiredAt");
    const isSmallDevice = (0,react_responsive.useMediaQuery)({
        maxWidth: 905
    });
    const isMounted = (0,hooks/* useMounted */.s4)();
    const { addToast  } = (0,react.useContext)(ToastContextProvider/* ToastContext */.u);
    const isOwner = !router.query.address || router.query.address[0] === accountAddress;
    const { avatar: ensAvatar , name: resolvedEnsName , shortAddress  } = (0,hooks/* useENSResolver */.Af)(address);
    let collectionQuery = {
        limit: 100
    };
    const { chain  } = (0,react.useContext)(ChainContextProvider/* ChainContext */.p);
    if (chain.collectionSetId) {
        collectionQuery.collectionsSetId = chain.collectionSetId;
    } else if (chain.community) {
        collectionQuery.community = chain.community;
    }
    const { data: collections , isLoading: collectionsLoading , fetchNextPage  } = (0,dist_index_module/* useUserCollections */.UJ)(address, collectionQuery);
    // Batch listing logic
    const [showListingPage, setShowListingPage] = (0,react.useState)(false);
    const [batchAcceptBidModalOpen, setBatchAcceptBidModalOpen] = (0,react.useState)(false);
    const [selectedItems, setSelectedItems] = (0,react.useState)([]);
    const sellableItems = (0,react.useMemo)(()=>{
        return selectedItems.filter((item)=>{
            var _item_token, _item_token_topBid;
            return ((_item_token = item.token) === null || _item_token === void 0 ? void 0 : (_item_token_topBid = _item_token.topBid) === null || _item_token_topBid === void 0 ? void 0 : _item_token_topBid.id) !== null;
        }).map((item)=>{
            var _item_token, _item_token1, _item_token_collection;
            return {
                tokenId: (_item_token = item.token) === null || _item_token === void 0 ? void 0 : _item_token.tokenId,
                collectionId: (_item_token1 = item.token) === null || _item_token1 === void 0 ? void 0 : (_item_token_collection = _item_token1.collection) === null || _item_token_collection === void 0 ? void 0 : _item_token_collection.id
            };
        });
    }, [
        selectedItems
    ]);
    const tokenTableRef = (0,react.useRef)(null);
    (0,react.useEffect)(()=>{
        setSelectedItems([]);
    }, [
        chain
    ]);
    (0,react.useEffect)(()=>{
        setSelectedItems([]);
        setShowListingPage(false);
        setBatchAcceptBidModalOpen(false);
    }, [
        address
    ]);
    (0,react.useEffect)(()=>{
        let tab = tabValue;
        let deeplinkTab = null;
        if (true) {
            const params = new URL(window.location.href).searchParams;
            deeplinkTab = params.get("tab");
        }
        if (deeplinkTab) {
            switch(deeplinkTab){
                case "items":
                    tab = "items";
                    break;
                case "collections":
                    tab = "collections";
                    break;
                case "listings":
                    tab = "listings";
                    break;
                case "offers":
                    tab = "offers";
                    break;
                case "activity":
                    tab = "activity";
                    break;
            }
        }
        setTabValue(tab);
    }, [
        isSmallDevice,
        router.asPath
    ]);
    (0,react.useEffect)(()=>{
        router.query.tab = tabValue;
        router.push(router, undefined, {
            shallow: true
        });
    }, [
        tabValue
    ]);
    if (!isMounted) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Flex */.kC, {
                        direction: "column",
                        css: {
                            px: "$4",
                            py: 40,
                            "@sm": {
                                px: "$5"
                            }
                        },
                        children: !isOwner || isConnected ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: showListingPage && !isSmallDevice ? /*#__PURE__*/ (0,jsx_runtime.jsx)(portfolio_BatchListings, {
                                selectedItems: selectedItems,
                                setSelectedItems: setSelectedItems,
                                setShowListingPage: setShowListingPage
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                        align: "center",
                                        justify: "between",
                                        css: {
                                            gap: "$4",
                                            flexDirection: "column",
                                            alignItems: "start",
                                            "@sm": {
                                                flexDirection: "row",
                                                alignItems: "center"
                                            }
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                                align: "center",
                                                children: [
                                                    ensAvatar ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* Avatar */.q, {
                                                        size: "xxl",
                                                        src: ensAvatar
                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((dist_default()), {
                                                        diameter: 64,
                                                        seed: (0,react_jazzicon_dist.jsNumberForAddress)(address)
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                                        direction: "column",
                                                        css: {
                                                            ml: "$4"
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                                                style: "h5",
                                                                children: resolvedEnsName ? resolvedEnsName : shortAddress
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CopyText/* default */.Z, {
                                                                text: address,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                                                    align: "center",
                                                                    css: {
                                                                        cursor: "pointer"
                                                                    },
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                                                            style: "subtitle1",
                                                                            color: "subtle",
                                                                            css: {
                                                                                mr: "$3"
                                                                            },
                                                                            children: shortAddress
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Box */.xu, {
                                                                            css: {
                                                                                color: "$gray10"
                                                                            },
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                                                icon: free_solid_svg_icons/* faCopy */.kZ_,
                                                                                width: 16,
                                                                                height: 16
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ChainToggle/* default */.Z, {})
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_module/* Root */.fC, {
                                        defaultValue: "items",
                                        value: tabValue,
                                        onValueChange: (value)=>setTabValue(value),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Flex */.kC, {
                                                css: {
                                                    overflowX: "scroll",
                                                    "@sm": {
                                                        overflowX: "auto"
                                                    }
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Tab/* TabsList */.dr, {
                                                    style: {
                                                        whiteSpace: "nowrap",
                                                        width: "100%"
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Tab/* TabsTrigger */.SP, {
                                                            value: "items",
                                                            children: "Items"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Tab/* TabsTrigger */.SP, {
                                                            value: "listings",
                                                            children: "Listings"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Tab/* TabsTrigger */.SP, {
                                                            value: "offers",
                                                            children: "Offers Made"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Tab/* TabsTrigger */.SP, {
                                                            value: "activity",
                                                            children: "Activity"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Tab/* TabsContent */.nU, {
                                                value: "items",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                                    css: {
                                                        gap: tokenFiltersOpen ? "$5" : "0",
                                                        position: "relative",
                                                        pb: 37
                                                    },
                                                    children: [
                                                        isSmallDevice ? /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileTokenFilters, {
                                                            collections: collections,
                                                            filterCollection: filterCollection,
                                                            setFilterCollection: setFilterCollection,
                                                            loadMoreCollections: fetchNextPage
                                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(TokenFilters, {
                                                            isLoading: collectionsLoading,
                                                            isOwner: isOwner,
                                                            open: tokenFiltersOpen,
                                                            setOpen: setTokenFiltersOpen,
                                                            collections: collections,
                                                            filterCollection: filterCollection,
                                                            setFilterCollection: setFilterCollection,
                                                            loadMoreCollections: fetchNextPage
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Box */.xu, {
                                                            css: {
                                                                flex: 1,
                                                                maxWidth: "100%"
                                                            },
                                                            children: [
                                                                isSmallDevice && /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                                                    justify: "between",
                                                                    css: {
                                                                        gap: "$3"
                                                                    },
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(common_PortfolioSortDropdown, {
                                                                            option: sortByType,
                                                                            onOptionSelected: (option)=>{
                                                                                setSortByType(option);
                                                                            }
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ViewToggle, {
                                                                            itemView: itemView,
                                                                            setItemView: setItemView
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                                                    justify: "between",
                                                                    css: {
                                                                        marginBottom: "$4"
                                                                    },
                                                                    children: [
                                                                        !isSmallDevice && !collectionsLoading && collections.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterButton/* FilterButton */.L, {
                                                                            open: tokenFiltersOpen,
                                                                            setOpen: setTokenFiltersOpen
                                                                        }),
                                                                        !isSmallDevice && !collectionsLoading && /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                                                            align: "center",
                                                                            justify: "between",
                                                                            css: {
                                                                                gap: "$3"
                                                                            },
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(common_PortfolioSortDropdown, {
                                                                                    option: sortByType,
                                                                                    onOptionSelected: (option)=>{
                                                                                        setSortByType(option);
                                                                                    }
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ViewToggle, {
                                                                                    itemView: itemView,
                                                                                    setItemView: setItemView
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TokenTable, {
                                                                    ref: tokenTableRef,
                                                                    isLoading: collectionsLoading,
                                                                    address: address,
                                                                    filterCollection: filterCollection,
                                                                    sortBy: sortByType,
                                                                    selectedItems: selectedItems,
                                                                    setSelectedItems: setSelectedItems,
                                                                    isOwner: isOwner,
                                                                    itemView: itemView
                                                                })
                                                            ]
                                                        }),
                                                        !isSmallDevice && /*#__PURE__*/ (0,jsx_runtime.jsx)(portfolio_BatchActionsFooter, {
                                                            selectedItems: selectedItems,
                                                            setSelectedItems: setSelectedItems,
                                                            setShowListingPage: setShowListingPage,
                                                            setOpenAcceptBidModal: setBatchAcceptBidModalOpen,
                                                            isOwner: isOwner
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Tab/* TabsContent */.nU, {
                                                value: "listings",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListingsTable, {
                                                    address: address,
                                                    isOwner: isOwner
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Tab/* TabsContent */.nU, {
                                                value: "offers",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OffersTable, {
                                                    address: address,
                                                    isOwner: isOwner
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Tab/* TabsContent */.nU, {
                                                value: "activity",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                                    css: {
                                                        gap: activityFiltersOpen ? "$5" : "",
                                                        position: "relative"
                                                    },
                                                    children: [
                                                        !isSmallDevice && /*#__PURE__*/ (0,jsx_runtime.jsx)(ActivityFilters/* ActivityFilters */.Y, {
                                                            open: activityFiltersOpen,
                                                            setOpen: setActivityFiltersOpen,
                                                            activityTypes: activityTypes,
                                                            setActivityTypes: setActivityTypes
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Box */.xu, {
                                                            css: {
                                                                flex: 1,
                                                                gap: "$4",
                                                                pb: "$5"
                                                            },
                                                            children: [
                                                                isSmallDevice ? /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileActivityFilters/* MobileActivityFilters */.r, {
                                                                    activityTypes: activityTypes,
                                                                    setActivityTypes: setActivityTypes
                                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterButton/* FilterButton */.L, {
                                                                    open: activityFiltersOpen,
                                                                    setOpen: setActivityFiltersOpen
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UserActivityTable, {
                                                                    user: address,
                                                                    activityTypes: activityTypes
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                            direction: "column",
                            align: "center",
                            css: {
                                mx: "auto",
                                py: "120px",
                                maxWidth: "350px",
                                gap: "$4"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                    style: "h4",
                                    css: {
                                        mb: "$3"
                                    },
                                    children: "Sell your NFT instantly"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                    css: {
                                        color: "$gray11"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                        icon: free_solid_svg_icons/* faWallet */.X5K,
                                        size: "2xl"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                    style: "body1",
                                    css: {
                                        color: "$gray11",
                                        textAlign: "center",
                                        mb: "$4"
                                    },
                                    children: "Connect wallet to instant sell your token across all major marketplaces."
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ConnectWalletButton/* ConnectWalletButton */.p, {})
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_module/* AcceptBidModal */.wK, {
                        trigger: null,
                        openState: [
                            batchAcceptBidModalOpen,
                            setBatchAcceptBidModalOpen
                        ],
                        tokens: sellableItems,
                        onClose: (data, stepData, currentStep)=>{
                            if (tokenTableRef && currentStep == dist_index_module/* AcceptBidStep.Complete */.h$.Complete) {
                                var _tokenTableRef_current;
                                (_tokenTableRef_current = tokenTableRef.current) === null || _tokenTableRef_current === void 0 ? void 0 : _tokenTableRef_current.mutate();
                                setSelectedItems([]);
                            }
                        },
                        onBidAcceptError: (error)=>{
                            if ((error === null || error === void 0 ? void 0 : error.type) === "price mismatch") {
                                addToast === null || addToast === void 0 ? void 0 : addToast({
                                    title: "Could not accept offer",
                                    description: "Offer was lower than expected."
                                });
                                return;
                            }
                            // Handle user rejection
                            if ((error === null || error === void 0 ? void 0 : error.code) === 4001) {
                                addToast === null || addToast === void 0 ? void 0 : addToast({
                                    title: "User canceled transaction",
                                    description: "You have canceled the transaction."
                                });
                                return;
                            }
                            addToast === null || addToast === void 0 ? void 0 : addToast({
                                title: "Could not accept offer",
                                description: "The transaction was not completed."
                            });
                        }
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var _address_ = (IndexPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7948,4946,8957,2659,1943,6143,3924,9774,2888,179], function() { return __webpack_exec__(13425); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);